//************  API Calls ************//
// Communication / Notification settings
export const GET_COMMUNICATION_LIST_API = "/communication/list";
export const GET_COMMUNICATION_DATA_API = "/communication/data";
export const GET_COMMUNICATION_CHANNEL_LIST_API = "/communicationchannel/list";
export const CREATE_COMMUNICATION_CHANNEL_API = "/communicationchannel/create";
export const UPDATE_COMMUNICATION_CHANNEL_API = "/communicationchannel/update";
export const GET_COMMUNICATION_PLACEHOLDER_LIST_API =
  "/communicationplaceholder/list";
export const GET_NOTIFICATION_TEMPLATE_LIST_API = "/notificationtemplate/list";
// Change #100528 - staff subscribers for subscriber-based alerts
export const LIST_COMMUNICATION_SUBSCRIBER_API = "/communicationsubscriber/list";
export const CREATE_COMMUNICATION_SUBSCRIBER_API =
  "/communicationsubscriber/create";
export const UPDATE_COMMUNICATION_SUBSCRIBER_API =
  "/communicationsubscriber/update";
export const DELETE_COMMUNICATION_SUBSCRIBER_API =
  "/communicationsubscriber/delete";
//GET_SMS_TEMPLATES_API
export const GET_SMS_TEMPLATES_API = "/smstemplate/list";
//GET_SMS_TEMPLATE_DETAILS
export const GET_SMS_TEMPLATE_DETAILS = "/smstemplate/data";
//ADD_SMS_TEMPLATE
export const ADD_SMS_TEMPLATE = "/smstemplate/create";
//UPDATE_SMS_TEMPLATE
export const UPDATE_SMS_TEMPLATE = "/smstemplate/update";
//DELETE_SMS_TEMPLATE
export const DELETE_SMS_TEMPLATE = "/smstemplate/delete";
//SEND_SMS_OUTBOUND_API_CALL
export const SEND_SMS_OUTBOUND_API_CALL = "/smsoutbound/send";
//GET_SMS_ADDRESS_BOOK_API_CALL
export const GET_SMS_ADDRESS_BOOK_API_CALL = "/smsoutbound/addressbook/lookup";

//************  API Calls ************//
//Twilio
//POST_TWILIO_PREAUTH
export const POST_TWILIO_PREAUTH = "/calloutbound/preauth";
//************  API Calls ************//
//Master
//GET_MASTER_HARDWARE_CATALOG_LIST
export const GET_MASTER_HARDWARE_CATALOG_LIST = "/masterhardwarecatalog/list";
//CREATE_MASTER_HARDWARE_CATALOG
export const CREATE_MASTER_HARDWARE_CATALOG = "/masterhardwarecatalog/create";
//UPDATE_MASTER_HARDWARE_CATALOG
export const UPDATE_MASTER_HARDWARE_CATALOG = "/masterhardwarecatalog/update";
//DELETE_MASTER_HARDWARE_CATALOG
export const DELETE_MASTER_HARDWARE_CATALOG = "/masterhardwarecatalog/delete";
//************  API Calls ************//
//Master Third Party Pricing
//GET_MASTER_THIRD_PARTY_PRICING_LIST
export const GET_MASTER_THIRD_PARTY_PRICING_LIST = "/thirdpartypricing/list";
//CREATE_MASTER_THIRD_PARTY_PRICING
export const CREATE_MASTER_THIRD_PARTY_PRICING = "/thirdpartypricing/create";
//UPDATE_MASTER_THIRD_PARTY_PRICING
export const UPDATE_MASTER_THIRD_PARTY_PRICING = "/thirdpartypricing/update";
//DELETE_MASTER_THIRD_PARTY_PRICING
export const DELETE_MASTER_THIRD_PARTY_PRICING = "/thirdpartypricing/delete";
//Master SIM (emnify) management
export const GET_MASTER_SIM_LIST = "/mastersim/list";
export const GET_MASTER_SIM_DATA = "/mastersim/data"; // + /:id
export const GET_MASTER_SIM_COMPANIES = "/mastersim/companies";
export const GET_MASTER_SIM_STAFF = "/mastersim/staff";
// Change #100416 - emnify device (endpoint) pickers + make live
export const GET_MASTER_SIM_DEVICE_OPTIONS = "/mastersim/deviceoptions";
export const POST_MASTER_SIM_MAKE_LIVE = "/mastersim/makelive";
// Change #100664 - eSIM activation code (QR) and emailing it
export const GET_MASTER_SIM_ESIM_CODE = "/mastersim/esimcode";
export const POST_MASTER_SIM_ESIM_EMAIL = "/mastersim/esimemail";
// Change #100665 / #100667 - refresh one SIM from emnify (live connectivity + usage)
export const GET_MASTER_SIM_LIVE = "/mastersim/live";
// Change #100666 - a company's own SIMs (read-only)
export const GET_COMPANY_SIM_LIST = "/companysim/list";
export const GET_COMPANY_SIM_LIVE = "/companysim/live";
export const GET_COMPANY_SIM_STAFF = "/companysim/staff";
export const POST_COMPANY_SIM_ALLOCATE = "/companysim/allocate";
// Change #100668 - one user's sign-ins to this company
export const GET_USER_SIGN_IN_LOG_LIST = "/usersigninlog/list";
export const CREATE_MASTER_SIM = "/mastersim/create";
export const UPDATE_MASTER_SIM = "/mastersim/update";
export const DELETE_MASTER_SIM = "/mastersim/delete";
export const SYNC_MASTER_SIM = "/mastersim/sync";
export const REGISTER_MASTER_SIM = "/mastersim/register";
export const ACTIVATE_MASTER_SIM = "/mastersim/activate";
export const SUSPEND_MASTER_SIM = "/mastersim/suspend";
export const ASSIGN_MASTER_SIM = "/mastersim/assign";
export const UNASSIGN_MASTER_SIM = "/mastersim/unassign";
//************  API Calls ************//
//Master System Server
//GET_MASTER_SYSTEM_SERVER_LIST
export const GET_MASTER_SYSTEM_SERVER_LIST = "/mastersystemserver/list";
//DEPLOY_MASTER_SYSTEM_SERVER (dynamic POST -> /mastersystemserver/deploy/:id)
export const DEPLOY_MASTER_SYSTEM_SERVER = "/mastersystemserver/deploy";
//DEPLOY_STATUS_MASTER_SYSTEM_SERVER (dynamic GET -> /mastersystemserver/deploystatus/:id)
export const DEPLOY_STATUS_MASTER_SYSTEM_SERVER = "/mastersystemserver/deploystatus";
//DigitalOcean app-level environment variables (Change #100749)
export const ENV_LIST_MASTER_SYSTEM_SERVER = "/mastersystemserver/envlist";
export const ENV_SET_MASTER_SYSTEM_SERVER = "/mastersystemserver/envset";
export const ENV_DELETE_MASTER_SYSTEM_SERVER = "/mastersystemserver/envdelete";
export const ENV_PREVIEW_MASTER_SYSTEM_SERVER = "/mastersystemserver/envpreview";
export const ENV_PUSH_MASTER_SYSTEM_SERVER = "/mastersystemserver/envpush";
export const ENV_IMPORT_MASTER_SYSTEM_SERVER = "/mastersystemserver/envimport";
//MasterEnvVar table (Change #100749)
export const GET_MASTER_ENV_VAR_LIST = "/masterenvvar/list";
export const CREATE_MASTER_ENV_VAR = "/masterenvvar/create";
export const UPDATE_MASTER_ENV_VAR = "/masterenvvar/update";
export const DELETE_MASTER_ENV_VAR = "/masterenvvar/delete";
export const CREATE_MASTER_ENV_VAR_VALUE = "/masterenvvar/valuecreate";
export const UPDATE_MASTER_ENV_VAR_VALUE = "/masterenvvar/valueupdate";
export const DELETE_MASTER_ENV_VAR_VALUE = "/masterenvvar/valuedelete";
//************  API Calls ************//
//POS SYSTEM
//GET_POS_SYSTEM_RENDER_DATA_API
export const GET_POS_SYSTEM_RENDER_DATA_API = "/possystem/render";
//GET_POS_SYSTEM_LIST_API
export const GET_POS_SYSTEM_LIST_API = "/possystem/list";
//GET_POS_SYSTEM_DATA_API
export const GET_POS_SYSTEM_DATA_API = "/possystem/data";
//CREATE_POS_SYSTEM_API
export const CREATE_POS_SYSTEM_API = "/possystem/create";
//UPDATE_POS_SYSTEM_API
export const UPDATE_POS_SYSTEM_API = "/possystem/update";
//DELETE_POS_SYSTEM_API
export const DELETE_POS_SYSTEM_API = "/possystem/delete";

// --- SystemDevice hardware (real POS devices: terminals, printers, card readers) ---
//SYSTEM_DEVICE_HW_LIST_API
export const SYSTEM_DEVICE_HW_LIST_API = "/systemdevice/list";
//SYSTEM_DEVICE_HW_DATA_API
export const SYSTEM_DEVICE_HW_DATA_API = "/systemdevice/data";
//SYSTEM_DEVICE_READER_STATUS_API
export const SYSTEM_DEVICE_READER_STATUS_API = "/systemdevice/readerstatus";
//SYSTEM_DEVICE_TEST_READER_API
export const SYSTEM_DEVICE_TEST_READER_API = "/systemdevice/testreader";
//GET_POS_SYSTEM_TO_USER_LIST_API
export const GET_POS_SYSTEM_TO_USER_LIST_API = "/possystemtouser/list";
//GET_POS_SYSTEM_TO_USER_DATA_API
export const GET_POS_SYSTEM_TO_USER_DATA_API = "/possystemtouser/data";
//CREATE_POS_SYSTEM_TO_USER_API
export const CREATE_POS_SYSTEM_TO_USER_API = "/possystemtouser/create";
//UPDATE_POS_SYSTEM_TO_USER_API
export const UPDATE_POS_SYSTEM_TO_USER_API = "/possystemtouser/update";
//DELETE_POS_SYSTEM_TO_USER_API
export const DELETE_POS_SYSTEM_TO_USER_API = "/possystemtouser/delete";

// POS ORDER
//GET_POS_ORDER_LIST_API
export const GET_POS_ORDER_LIST_API = "/posorder/list";
//POS_ORDER_SEARCH_API
export const POS_ORDER_SEARCH_API = "/posorder/search";
//GET_POS_ORDER_DATA_API
export const GET_POS_ORDER_DATA_API = "/posorder/data";
//CREATE_POS_ORDER_API
export const CREATE_POS_ORDER_API = "/posorder/create";
//UPDATE_POS_ORDER_API
export const UPDATE_POS_ORDER_API = "/posorder/update";
//DELETE_POS_ORDER_API
export const DELETE_POS_ORDER_API = "/posorder/delete";
//CREATE_POS_ORDER_PAYMENT_REQUEST_API
export const CREATE_POS_ORDER_PAYMENT_REQUEST_API = "/posorder/paymentrequest";
//GET_POS_SYSTEM_OVERVIEW_API
export const GET_POS_SYSTEM_OVERVIEW_API = "/possystem/overview";
//VOID_POS_ORDER_PAYMENT_REQUEST_API
export const VOID_POS_ORDER_PAYMENT_REQUEST_API = "/paymentrequest/void";
//PRINT_POS_ORDER_RECEIPT_API
export const PRINT_POS_ORDER_RECEIPT_API = "/posorder/receipt/print";
//EMAIL_POS_ORDER_RECEIPT_API
export const EMAIL_POS_ORDER_RECEIPT_API = "/posorder/receipt/email";
//REFUND_POS_ORDER_API
export const REFUND_POS_ORDER_API = "/posorder/refund";
// POS BILLING (Task 24246) - discounts, tenders, cash-up
export const POS_ORDER_TENDER_API = "/posorder/tender";
export const GET_POS_DISCOUNT_REASON_LIST_API = "/posdiscountreason/list";
export const CREATE_POS_ORDER_DISCOUNT_API = "/posorderdiscount/create";
export const GET_POS_ORDER_DISCOUNT_LIST_API = "/posorderdiscount/list";
export const DELETE_POS_ORDER_DISCOUNT_API = "/posorderdiscount/delete";
export const OPEN_POS_CASH_SESSION_API = "/poscashsession/open";
export const CLOSE_POS_CASH_SESSION_API = "/poscashsession/close";
export const GET_POS_CASH_SESSION_LIST_API = "/poscashsession/list";
export const GET_POS_CASH_SESSION_DATA_API = "/poscashsession/data";
export const GET_POS_CASH_SESSION_XREPORT_API = "/poscashsession/xreport";
export const GET_POS_CASH_SESSION_ZREPORT_API = "/poscashsession/zreport";
export const CREATE_POS_CASH_MOVEMENT_API = "/poscashmovement/create";
export const GET_POS_CASH_MOVEMENT_LIST_API = "/poscashmovement/list";
// POS TABLE SERVICE + KDS (Task 24247)
export const GET_POS_FLOOR_PLAN_LIST_API = "/posfloorplan/list";
export const CREATE_POS_FLOOR_PLAN_API = "/posfloorplan/create";
export const UPDATE_POS_FLOOR_PLAN_API = "/posfloorplan/update";
export const DELETE_POS_FLOOR_PLAN_API = "/posfloorplan/delete";
export const GET_POS_FLOOR_PLAN_TABLE_LIST_API = "/posfloorplantable/list";
export const CREATE_POS_FLOOR_PLAN_TABLE_API = "/posfloorplantable/create";
export const UPDATE_POS_FLOOR_PLAN_TABLE_API = "/posfloorplantable/update";
export const DELETE_POS_FLOOR_PLAN_TABLE_API = "/posfloorplantable/delete";
export const POS_TABLE_SEAT_API = "/posfloorplantable/seat";
export const POS_TABLE_TRANSFER_API = "/posfloorplantable/transfer";
export const POS_TABLE_MERGE_API = "/posfloorplantable/merge";
export const POS_TABLE_SPLIT_API = "/posfloorplantable/split";
export const POS_TABLE_CLEAR_API = "/posfloorplantable/clear";
export const GET_POS_COURSE_LIST_API = "/poscourse/list";
export const POS_ORDER_FIRE_API = "/posorder/fire";
export const GET_KDS_TICKETS_API = "/kds/tickets";
export const KDS_TICKET_BUMP_API = "/kds/ticket";
export const KDS_TICKET_RECALL_API = "/kds/ticket";
// POS OFFLINE SYNC (Task 24248)
export const POS_ORDER_SYNC_API = "/posorder/sync";
// POS CUSTOMER IDENTITY + HOUSE ACCOUNTS (Task 24249)
export const POS_CUSTOMER_CONTEXT_API = "/poscustomer/context";
export const POS_CUSTOMER_SET_API = "/poscustomer/setcustomer";
export const POS_CUSTOMER_LIST_API = "/customer/list";
// CUSTOMER LIVE LOOKUP (Task 24630) - name / postcode / phone / email / id
export const GET_CUSTOMER_LOOKUP_API = "/customer/lookup";
// POS MENU INTELLIGENCE + PRICING + AI (Task 24250)
export const POS_ANALYTICS_MENU_ENGINEERING_API = "/posanalytics/menuengineering";
export const POS_ANALYTICS_PL_API = "/posanalytics/profitandloss";
export const POS_MENU_AI_GENERATE_API = "/posmenuai/generate";
export const POS_PRICE_RULE_LIST_API = "/pospricerule/list";
export const POS_PRICE_RULE_CREATE_API = "/pospricerule/create";
export const POS_PRICE_RULE_UPDATE_API = "/pospricerule/update";
export const POS_PRICE_RULE_DELETE_API = "/pospricerule/delete";
export const POS_PRICE_RULE_RESOLVE_API = "/pospricerule/resolve";
//
//
//************  API Calls ************//
//LEADS
//CALL_LEAD_TYPE_LIST_API
//Modules
//GET_SYSTEM_MODULE_LIST_API_CALL
export const GET_SYSTEM_MODULE_LIST_API_CALL = "/systemmodule/list";
//GET_SYSTEM_MODULE_DATA_API_CALL
export const GET_SYSTEM_MODULE_DATA_API_CALL = "/systemmodule/data";
//GET_ACTIVATE_MODULE_DATA_API_CALL
export const GET_ACTIVATE_MODULE_DATA_API_CALL = "/systemmodule/activate";
//GET_DEACTIVATE_MODULE_DATA_API_CALL
export const GET_DEACTIVATE_MODULE_DATA_API_CALL = "/systemmodule/deactivate";
//CREATE_MODULE_API_CALL
export const CREATE_MODULE_API_CALL = "/systemmodule/create";
//UPDATE_MODULE_API_CALL
export const UPDATE_MODULE_API_CALL = "/systemmodule/update";
//DELETE_MODULE_API_CALL
export const DELETE_MODULE_API_CALL = "/systemmodule/delete";
//************  API Calls ************//
//LEADS
//CALL_LEAD_TYPE_LIST_API
export const CALL_LEAD_TYPE_LIST_API = "/leadtype/list";
//CALL_LEAD_TYPE_DATA_API
export const CALL_LEAD_TYPE_DATA_API = "/leadtype/data";
//CALL_LEAD_TYPE_CREATE_API
export const CALL_LEAD_TYPE_CREATE_API = "/leadtype/create";
//CALL_LEAD_TYPE_UPDATE_API
export const CALL_LEAD_TYPE_UPDATE_API = "/leadtype/update";
//CALL_LEAD_TYPE_DELETE_API
export const CALL_LEAD_TYPE_DELETE_API = "/leadtype/delete";
//CALL_LEAD_STATUS_LIST_API
export const CALL_LEAD_STATUS_LIST_API = "/leadstatus/list";
//CALL_LEAD_STATUS_DATA_API
export const CALL_LEAD_STATUS_DATA_API = "/leadstatus/data";
//CALL_LEAD_STATUS_CREATE_API
export const CALL_LEAD_STATUS_CREATE_API = "/leadstatus/create";
//CALL_LEAD_STATUS_UPDATE_API
export const CALL_LEAD_STATUS_UPDATE_API = "/leadstatus/update";
//CALL_LEAD_STATUS_DELETE_API
export const CALL_LEAD_STATUS_DELETE_API = "/leadstatus/delete";
//CALL_LEAD_PRIORITY_LIST_API
export const CALL_LEAD_PRIORITY_LIST_API = "/leadpriority/list";
//CALL_LEAD_PRIORITY_DATA_API
export const CALL_LEAD_PRIORITY_DATA_API = "/leadpriority/data";
//CALL_LEAD_PRIORITY_CREATE_API
export const CALL_LEAD_PRIORITY_CREATE_API = "/leadpriority/create";
//CALL_LEAD_PRIORITY_UPDATE_API
export const CALL_LEAD_PRIORITY_UPDATE_API = "/leadpriority/update";
//CALL_LEAD_PRIORITY_DELETE_API
export const CALL_LEAD_PRIORITY_DELETE_API = "/leadpriority/delete";
//CALL_LEAD_NOTE_LIST_API
export const CALL_LEAD_NOTE_LIST_API = "/leadnote/list";
//CALL_LEAD_NOTE_SEARCH_API
export const CALL_LEAD_NOTE_SEARCH_API = "/leadnote/search";
//CALL_LEAD_NOTE_DATA_API
export const CALL_LEAD_NOTE_DATA_API = "/leadnote/data";
//CALL_LEAD_NOTE_CREATE_API
export const CALL_LEAD_NOTE_CREATE_API = "/leadnote/create";
//CALL_LEAD_LIST_API
export const CALL_LEAD_LIST_API = "/lead/list";
//CALL_LEAD_LIST_UNINVOICED_API
export const CALL_LEAD_LIST_UNINVOICED_API = "/lead/list_uninvoiced";
//CALL_LEAD_OVERVIEW_FUNNEL_API
export const CALL_LEAD_OVERVIEW_FUNNEL_API = "/lead/overview/funnel";
//CALL_LEAD_DATA_API
export const CALL_LEAD_DATA_API = "/lead/data";
//CALL_LEAD_CREATE_API
export const CALL_LEAD_CREATE_API = "/lead/create";
//CALL_LEAD_UPDATE_API
export const CALL_LEAD_UPDATE_API = "/lead/update";
//CALL_LEAD_DELETE_API
export const CALL_LEAD_DELETE_API = "/lead/delete";
//CALL_LEAD_SEARCH_API
export const CALL_LEAD_SEARCH_API = "/lead/search";
//CALL_LEAD_TASK_SEARCH_API
export const CALL_LEAD_TASK_SEARCH_API = "/leadtask/search";
//CALL_LEAD_TASK_CREATE_API
export const CALL_LEAD_TASK_CREATE_API = "/leadtask/create";
//CALL_LEAD_TASK_TYPE_LIST_API
export const CALL_LEAD_TASK_TYPE_LIST_API = "/leadtasktype/list";
//CALL_LEAD_TASK_TYPE_DATA_API
export const CALL_LEAD_TASK_TYPE_DATA_API = "/leadtasktype/data";
//CALL_LEAD_TASK_TYPE_CREATE_API
export const CALL_LEAD_TASK_TYPE_CREATE_API = "/leadtasktype/create";
//CALL_LEAD_TASK_TYPE_UPDATE_API
export const CALL_LEAD_TASK_TYPE_UPDATE_API = "/leadtasktype/update";
//CALL_LEAD_TASK_TYPE_DELETE_API
export const CALL_LEAD_TASK_TYPE_DELETE_API = "/leadtasktype/delete";
//CALL_LEAD_RECENT_ACTIVITY_LIST_API
export const CALL_LEAD_RECENT_ACTIVITY_LIST_API = "/leadrecentactivity/list";

//************  API Calls ************//
//FETCH_STAFF_PLANNER_LIST
export const FETCH_STAFF_PLANNER_LIST = "/staffshift/list";
//FETCH_STAFF_PLANNER_DATA
export const FETCH_STAFF_PLANNER_DATA = "/staffshift/data";
//CREATE_STAFF_PLANNER
export const CREATE_STAFF_PLANNER = "/staffshift/create";
///staffshift/update
export const UPDATE_STAFF_PLANNER = "/staffshift/update";
//DELETE_STAFF_PLANNER
export const DELETE_STAFF_PLANNER = "/staffshift/delete";
//SEARCH_STAFF_PLANNER
export const SEARCH_STAFF_PLANNER = "/staffshift/search";
//COMPLETE_STAFF_PLANNER
export const COMPLETE_STAFF_PLANNER = "/staffshift/complete";
//UNINVOICED_STAFF_PLANNER
export const UNINVOICED_STAFF_PLANNER = "/staffshift/uninvoiced";
//CONVERT_TO_INVOICE_STAFF_PLANNER
export const CONVERT_TO_INVOICE_STAFF_PLANNER = "/staffshift/converttoinvoice";
//GENERATE_RECURRENCE_STAFF_PLANNER
export const GENERATE_RECURRENCE_STAFF_PLANNER =
  "/staffshift/generaterecurrence";
//FETCH_STAFF_PLANNER_STATUS_LIST
export const FETCH_STAFF_PLANNER_STATUS_LIST = "/staffshiftstatus/list";
//FETCH_STAFF_PLANNER_RECENT_ACTIVITY
export const FETCH_STAFF_PLANNER_RECENT_ACTIVITY =
  "/staffshiftrecentactivity/list";
//FETCH_STAFF_PLANNER_ASSIGNMENT_LIST
export const FETCH_STAFF_PLANNER_ASSIGNMENT_LIST = "/staffshiftassignment/list";
//FETCH_STAFF_PLANNER_ASSIGNMENT_DATA
export const FETCH_STAFF_PLANNER_ASSIGNMENT_DATA = "/staffshiftassignment/data";
//CREATE_STAFF_PLANNER_ASSIGNMENT
export const CREATE_STAFF_PLANNER_ASSIGNMENT = "/staffshiftassignment/create";
//UPDATE_STAFF_PLANNER_ASSIGNMENT
export const UPDATE_STAFF_PLANNER_ASSIGNMENT = "/staffshiftassignment/update";
//DELETE_STAFF_PLANNER_ASSIGNMENT
export const DELETE_STAFF_PLANNER_ASSIGNMENT = "/staffshiftassignment/delete";
//ASSIGN_STAFF_PLANNER_ASSIGNMENT
export const ASSIGN_STAFF_PLANNER_ASSIGNMENT = "/staffshiftassignment/assign";
//UNASSIGN_STAFF_PLANNER_ASSIGNMENT
export const UNASSIGN_STAFF_PLANNER_ASSIGNMENT =
  "/staffshiftassignment/unassign";
//************  API Calls ************//
//FETCH_SMM_POST_CHANNEL_STATUS_LIST_API
export const FETCH_SMM_POST_CHANNEL_STATUS_LIST_API =
  "/socialmediapoststatus/list";
//FETCH_SMM_POST_CHANNEL_STATUS_DATA_API
export const FETCH_SMM_POST_CHANNEL_STATUS_DATA_API =
  "/socialmediapoststatus/data";
//CREATE_SMM_POST_CHANNEL_STATUS_API
export const CREATE_SMM_POST_CHANNEL_STATUS_API =
  "/socialmediapoststatus/create";
//UPDATE_SMM_POST_CHANNEL_STATUS_API
export const UPDATE_SMM_POST_CHANNEL_STATUS_API =
  "/socialmediapoststatus/update";
//DELETE_SMM_POST_CHANNEL_STATUS_API
export const DELETE_SMM_POST_CHANNEL_STATUS_API =
  "/socialmediapoststatus/delete";
//FETCH_SMM_POST_LIST_API
export const FETCH_SMM_POST_LIST_API = "/socialmediapost/list";
//FETCH_SMM_POST_DATA_API
export const FETCH_SMM_POST_DATA_API = "/socialmediapost/data";
//CREATE_SMM_POST_API
export const CREATE_SMM_POST_API = "/socialmediapost/create";
//UPDATE_SMM_POST_API
export const UPDATE_SMM_POST_API = "/socialmediapost/update";
//DELETE_SMM_POST_API
export const DELETE_SMM_POST_API = "/socialmediapost/update";
//GET_LIST_MASTER_SOCIAL_MEDIA_PROVIDER_API
export const GET_LIST_MASTER_SOCIAL_MEDIA_PROVIDER_API =
  "/mastersocialmediaprovider/list";
//GET_DATA_MASTER_SOCIAL_MEDIA_PROVIDER_API
export const GET_DATA_MASTER_SOCIAL_MEDIA_PROVIDER_API =
  "/mastersocialmediaprovider/data";
//CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_API
export const CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_API =
  "/mastersocialmediaprovider/create";
//UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_API
export const UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_API =
  "/mastersocialmediaprovider/update";
//DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_API
export const DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_API =
  "/mastersocialmediaprovider/delete";
//GET_LIST_MASTER_SOCIAL_MEDIA_PROFILE_API
export const GET_LIST_MASTER_SOCIAL_MEDIA_PROFILE_API =
  "/socialmediaprofile/list";
//GET_DATA_MASTER_SOCIAL_MEDIA_PROFILE_API
export const GET_DATA_MASTER_SOCIAL_MEDIA_PROFILE_API =
  "/socialmediaprofile/data";
//CREATE_MASTER_SOCIAL_MEDIA_PROFILE_API
export const CREATE_MASTER_SOCIAL_MEDIA_PROFILE_API =
  "/socialmediaprofile/create";
//UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_API
export const UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_API =
  "/socialmediaprofile/update";
//DELETE_MASTER_SOCIAL_MEDIA_PROFILE_API
export const DELETE_MASTER_SOCIAL_MEDIA_PROFILE_API =
  "/socialmediaprofile/delete";
// Task 24873 - connecting a channel to the account it posts to.
// start takes the channel id on the URL; the rest carry it in the body.
export const SOCIAL_MEDIA_CONNECT_START_API = "/socialmediaconnect/start";
export const SOCIAL_MEDIA_CONNECT_COMPLETE_API = "/socialmediaconnect/complete";
export const SOCIAL_MEDIA_CONNECT_ASSIGN_API = "/socialmediaconnect/assign";
export const SOCIAL_MEDIA_CONNECT_DISCONNECT_API =
  "/socialmediaconnect/disconnect";
//GENERATE_SMM_POST_CONTENT_API
export const GENERATE_SMM_POST_CONTENT_API = "/socialmediapost/generatecontent";
//GENERATE_SMM_POST_IMAGE_API
export const GENERATE_SMM_POST_IMAGE_API = "/socialmediapost/generateimage";
//************  API Calls ************//
//Cron Schedules
//FETCH_MASTER_CRON_SCHEDULE_LIST_OVERDUE
export const FETCH_MASTER_CRON_SCHEDULE_LIST_OVERDUE =
  "/mastercronschedule/list/overdue";
//FETCH_MASTER_CRON_SCHEDULE_LIST
export const FETCH_MASTER_CRON_SCHEDULE_LIST = "/mastercronschedule/list";
//FETCH_MASTER_CRON_SCHEDULE_REQUEST_RUN
export const FETCH_MASTER_CRON_SCHEDULE_REQUEST_RUN =
  "/mastercronschedule/requestrerun";
//************  API Calls ************//
//Ecommerce
//CREATE_SALES_ORDER_API
export const CREATE_SALES_ORDER_API = "/salesorder/create";
//POSTCODE_LOOKUP_API
export const POSTCODE_LOOKUP_API = "/extpostcodelookup/search";
//GET_RENDER_ECOMMERCE_STORE_API
export const GET_RENDER_ECOMMERCE_STORE_API = "/ecommercestore/render";
//GET_PRODUCT_CATEGORIES_API
export const GET_PRODUCT_CATEGORIES_API =
  "/ecommercestoreproductcategory/public/listwithproduct";
//SEARCH_PRODUCTS_BY_CATEGORY_API
export const SEARCH_PRODUCTS_BY_CATEGORY_API =
  "/ecommercestoreproductcategorytoproduct/public/search/";
//CALCULATE_SHIPPING_API
export const CALCULATE_SHIPPING_API =
  "/ecommercestore/public/calculate/shipping";
//CALCULATE_ORDER_TOTAL_API
export const CALCULATE_ORDER_TOTAL_API =
  "/ecommercestore/public/calculate/ordertotal";
//EXECUTE_ECOMMERCE_STORE_API
export const EXECUTE_ECOMMERCE_STORE_API = "/ecommercestore/public/execute";
//GET_ECOMMERCE_DELIVERY_SLOTS_API — store id is appended by FetchAPI from payload.id
export const GET_ECOMMERCE_DELIVERY_SLOTS_API =
  "/ecommercestoredeliveryslot/public/list";
//************  API Calls ************//
//BOM
//GET_SALES_ORDER_BILL_OF_MATERIALS_API (aggregated BOM for a whole sales order)
export const GET_SALES_ORDER_BILL_OF_MATERIALS_API =
  "/salesorder/billofmaterials";
//GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_API
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_API =
  "/productbillofmaterialcomponentsupplierproduct/list";
//GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_API
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_API =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_API";
//SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_API
export const SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_API =
  "/productbillofmaterialcomponentsupplierproduct/search";
//CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_API
export const CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_API =
  "/productbillofmaterialcomponentsupplierproduct/create";
//UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_API
export const UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_API =
  "/productbillofmaterialcomponentsupplierproduct/update";
//DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_API
export const DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_API =
  "/productbillofmaterialcomponentsupplierproduct/delete";
//GET_BOM_COMPONENT_LIST_API
export const GET_BOM_COMPONENT_LIST_API =
  "/productbillofmaterialcomponent/list";
//GET_BOM_COMPONENT_DATA_API
export const GET_BOM_COMPONENT_DATA_API =
  "/productbillofmaterialcomponent/data";
//SEARCH_BOM_COMPONENT_API
export const SEARCH_BOM_COMPONENT_API =
  "/productbillofmaterialcomponent/search";
//CREATE_BOM_COMPONENT_API
export const CREATE_BOM_COMPONENT_API =
  "/productbillofmaterialcomponent/create";
//UPDATE_BOM_COMPONENT_API
export const UPDATE_BOM_COMPONENT_API =
  "/productbillofmaterialcomponent/update";
//DELETE_BOM_COMPONENT_API
export const DELETE_BOM_COMPONENT_API =
  "/productbillofmaterialcomponent/delete";
//GET_BOM_LIST_API
export const GET_BOM_LIST_API = "/productbillofmaterial/list";
//GET_BOM_DATA_API
export const GET_BOM_DATA_API = "/productbillofmaterial/data";
//SEARCH_BOM_API
export const SEARCH_BOM_API = "/productbillofmaterial/search";
//CREATE_BOM_API
export const CREATE_BOM_API = "/productbillofmaterial/create";
//UPDATE_BOM_API
export const UPDATE_BOM_API = "/productbillofmaterial/update";
//DELETE_BOM_API
export const DELETE_BOM_API = "/productbillofmaterial/delete";
//CREATE_BOM_VERSION_API
export const CREATE_BOM_VERSION_API = "/productbillofmaterial/createversion";
//SEARCH_PRODUCT_TO_BOM_API
export const SEARCH_PRODUCT_TO_BOM_API =
  "/producttoproductbillofmaterial/search";
//SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_API (map a BOM to products via lookup)
export const SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_API =
  "/productbillofmaterialtoproductrule/search";
//CLONE_BOM_API
export const CLONE_BOM_API = "/productbillofmaterial/clone";
//************  API Calls ************//
//GET_SUPPLIER_PRODUCT_LIST
export const GET_SUPPLIER_PRODUCT_LIST = "/supplierproduct/list";
//GET_SUPPLIER_PRODUCT_DATA
export const GET_SUPPLIER_PRODUCT_DATA = "/supplierproduct/data";
//GET_SUPPLIER_PRODUCT_SEARCH
export const GET_SUPPLIER_PRODUCT_SEARCH = "/supplierproduct/search";
//CREATE_SUPPLIER_PRODUCT
export const CREATE_SUPPLIER_PRODUCT = "/supplierproduct/create";
//UPDATE_SUPPLIER_PRODUCT
export const UPDATE_SUPPLIER_PRODUCT = "/supplierproduct/update";
//DELETE_SUPPLIER_PRODUCT
export const DELETE_SUPPLIER_PRODUCT = "/supplierproduct/delete";
//GET_INVOICE_DRAFT_LIST
export const GET_INVOICE_DRAFT_LIST = "/invoicedraft/list";
//SEARCH_INVOICE_DRAFT
export const SEARCH_INVOICE_DRAFT = "/invoicedraft/search";
//CREATE_INVOICE_DRAFT
export const CREATE_INVOICE_DRAFT = "/invoicedraft/create";
//UPDATE_INVOICE_DRAFT
export const UPDATE_INVOICE_DRAFT = "/invoicedraft/update";
//VOID_INVOICE_DRAFT
export const VOID_INVOICE_DRAFT = "/invoicedraft/void";
//GET_INVOICE_DRAFT_PDF
export const GET_INVOICE_DRAFT_PDF = "/invoicedraft/pdf/";
//GET_INVOICE_DRAFT_DAILY_BALANCE
export const GET_INVOICE_DRAFT_DAILY_BALANCE = "/invoicedraft/dailybalance";
//GET_INVOICE_DRAFT_STATUS_LIST
export const GET_INVOICE_DRAFT_STATUS_LIST = "/invoicedraftstatus/list";
//GET_INVOICE_DRAFT_STATUS_DATA
export const GET_INVOICE_DRAFT_STATUS_DATA = "/invoicedraftstatus/data";
//CREATE_INVOICE_DRAFT_STATUS
export const CREATE_INVOICE_DRAFT_STATUS = "/invoicedraftstatus/create";
//UPDATE_INVOICE_DRAFT_STATUS
export const UPDATE_INVOICE_DRAFT_STATUS = "/invoicedraftstatus/update";
//DELETE_INVOICE_DRAFT_STATUS
export const DELETE_INVOICE_DRAFT_STATUS = "/invoicedraftstatus/delete";
//GET_INVOICE_DRAFT_DATA
export const GET_INVOICE_DRAFT_DATA = "/invoicedraft/data";
//SEARCH_INVOICE_DRAFT_ACTIVITY_LOG
export const SEARCH_INVOICE_DRAFT_ACTIVITY_LOG =
  "/invoicedraftactivitylog/search";
//CONVERT_TO_INVOICE
export const CONVERT_TO_INVOICE = "/invoicedraft/converttoinvoice";
//************  API Calls ************//
//IMPORT_OPPORTUNITY_API
export const IMPORT_OPPORTUNITY_API = "/dataimportexport/import/opportunity";
//IMPORT_DATA_SCHEMA_API (POST, no body) — returns importable entities + fields
export const IMPORT_DATA_SCHEMA_API = "/dataimportexport/import/schema";
//IMPORT_DATA_API (POST) — runs an import job
export const IMPORT_DATA_API = "/dataimportexport/import";
//IMPORT_DATA_RESHAPE_API (POST) — AI-reshapes a messy grid into a flat table
export const IMPORT_DATA_RESHAPE_API = "/dataimportexport/import/ai_reshape";
//ResDiary migration importers (Task 24417) — bespoke, not part of the Data
//Import Center pipeline. All take Base64Content + FoodPreOrderSiteLocation_Id.
//IMPORT_RESDIARY_TABLES_API (POST) — saved ResDiary table-plan HTML
export const IMPORT_RESDIARY_TABLES_API =
  "/dataimportexport/import/thirdparty/resdiary/tables";
//IMPORT_RESDIARY_BOOKINGS_HTML_API (POST) — saved ResDiary bookings report HTML (fallback)
export const IMPORT_RESDIARY_BOOKINGS_HTML_API =
  "/dataimportexport/import/thirdparty/resdiary/bookings";
//IMPORT_RESDIARY_BOOKINGS_CSV_API (POST) — ResDiary bookings CSV export (primary)
export const IMPORT_RESDIARY_BOOKINGS_CSV_API =
  "/dataimportexport/import/thirdparty/resdiary/bookings/csv";
//IMPORT_RESDIARY_CLOSURES_API (POST) — ResDiary closures CSV -> FoodTableDiaryRule
export const IMPORT_RESDIARY_CLOSURES_API =
  "/dataimportexport/import/thirdparty/resdiary/closures";
//************  API Calls ************//
//HMRC
//HMRC_URL_AUTH_API
export const HMRC_URL_AUTH_API = "/thirdpartyhmrc/urlauth";
//HMRC_GENERATE_ACCESS_TOKEN_API
export const HMRC_GENERATE_ACCESS_TOKEN_API =
  "/thirdpartyhmrc/generateaccesstoken";
//************  API Calls ************//
//payment requests
//GET_PAYMENT_REQUEST_LIST
export const GET_PAYMENT_REQUEST_LIST = "/paymentrequest/list";
//GET_PAYMENT_REQUEST_PREVIEW
export const GET_PAYMENT_REQUEST_PREVIEW = "/paymentrequest/preview";
//GET_PAYMENT_REQUEST_PREDICTED
export const GET_PAYMENT_REQUEST_PREDICTED = "/paymentrequest/predicted";
//GET_PAYMENT_REQUEST_UNCOLLECTABLE
export const GET_PAYMENT_REQUEST_UNCOLLECTABLE = "/paymentrequest/uncollectable";
//GET_PAYMENT_REQUEST_DATA
export const GET_PAYMENT_REQUEST_DATA = "/paymentrequest/data";
//CREATE_PAYMENT_REQUEST
export const CREATE_PAYMENT_REQUEST = "/paymentrequest/create";
//SEARCH_PAYMENT_REQUEST
export const SEARCH_PAYMENT_REQUEST = "/paymentrequest/search";
//VOID_PAYMENT_REQUEST
export const VOID_PAYMENT_REQUEST = "/paymentrequest/void";
//GET_PURCHASE_DRAFT_STATUS_LIST_API
export const GET_PURCHASE_DRAFT_STATUS_LIST_API = "/purchasedraftstatus/list";
//GET_PURCHASE_DRAFT_STATUS_DATA_API
export const GET_PURCHASE_DRAFT_STATUS_DATA_API = "/purchasedraftstatus/data";
//CREATE_PURCHASE_DRAFT_STATUS_API
export const CREATE_PURCHASE_DRAFT_STATUS_API = "/purchasedraftstatus/create";
//UPDATE_PURCHASE_DRAFT_STATUS_API
export const UPDATE_PURCHASE_DRAFT_STATUS_API = "/purchasedraftstatus/update";
//DELETE_PURCHASE_DRAFT_STATUS_API
export const DELETE_PURCHASE_DRAFT_STATUS_API = "/purchasedraftstatus/delete";
//************  API Calls ************//
//purchase draft
//GET_PURCHASE_DRAFT_LIST_API
export const GET_PURCHASE_DRAFT_LIST_API = "/purchasedraft/list/pending"; // changed from "/purchasedraft/list" to "/purchasedraft/list/pending"
//GET_PURCHASE_DRAFT_SEARCH_API
export const GET_PURCHASE_DRAFT_SEARCH_API = "/purchasedraft/search";
//GET_PURCHASE_DRAFT_DATA_API
export const GET_PURCHASE_DRAFT_DATA_API = "/purchasedraft/data";
//CREATE_PURCHASE_DRAFT_API
export const CREATE_PURCHASE_DRAFT_API = "/purchasedraft/create";
//UPDATE_PURCHASE_DRAFT_API
export const UPDATE_PURCHASE_DRAFT_API = "/purchasedraft/update";
//DELETE_PURCHASE_DRAFT_API
export const DELETE_PURCHASE_DRAFT_API = "/purchasedraft/delete";
//CONVERT_TO_PURCHASE_API
export const CONVERT_TO_PURCHASE_API = "/purchasedraft/converttopurchase";
//************  API Calls ************//
//GET_MESSAGING_CONVERSATION_LIST_API
//public payment
//GET_PAYMENT_REQUEST_DATA_API
export const GET_PAYMENT_REQUEST_DATA_API = "/paymentrequest/public/data";
//GET_PAYMENT_COMPLETE_DATA_API
export const GET_PAYMENT_COMPLETE_DATA_API =
  "/paymentrequest/public/paymentcomplete";
//CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_API
export const CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_API =
  "/paymentrequest/public/createintent";
//GET_REPORT_SCHEMA_API
export const GET_REPORT_SCHEMA_API = "/reportentity/schema";
//RUN_REPORT_API
export const RUN_REPORT_API = "/reportentity/execute";
//REPORT_SAVED_API
export const REPORT_SAVED_LIST_API = "/reportsaved/list";
export const REPORT_SAVED_CREATE_API = "/reportsaved/create";
export const REPORT_SAVED_UPDATE_API = "/reportsaved/update";
export const REPORT_SAVED_DELETE_API = "/reportsaved/delete";
//************  API Calls ************//
//GET_MESSAGING_CONVERSATION_LIST_API
export const GET_MESSAGING_CONVERSATION_LIST_API =
  "/messagingconversation/list";
//SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_API
export const SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_API =
  "/messagingconversationmessage/search";
//SEND_MESSAGING_CONVERSATION_MESSAGE_API
export const SEND_MESSAGING_CONVERSATION_MESSAGE_API =
  "/messagingconversationmessage/send";
//UPDATE_MESSAGING_CONVERSATION_API
export const UPDATE_MESSAGING_CONVERSATION_API =
  "/messagingconversation/update";
//CREATE_MESSAGING_CONVERSATION_API
export const CREATE_MESSAGING_CONVERSATION_API =
  "/messagingconversation/create";

//************  API Calls ************//
//GET_FOOD_TABLE_RESERVATION_LIST
export const GET_FOOD_TABLE_RESERVATION_LIST = "/foodtablereservation/list";
//GET_FOOD_TABLE_RESERVATION_LIST_TODAY
export const GET_FOOD_TABLE_RESERVATION_LIST_TODAY =
  "/foodtablereservation/list/today";
//GET_FOOD_TABLE_RESERVATION_LIST_TOMORROW
export const GET_FOOD_TABLE_RESERVATION_LIST_TOMORROW =
  "/foodtablereservation/list/today";
//GET_FOOD_TABLE_RESERVATION_LIST_FUTURE
export const GET_FOOD_TABLE_RESERVATION_LIST_FUTURE =
  "/foodtablereservation/list/future";
//GET_FOOD_TABLE_RESERVATION_DATA
export const GET_FOOD_TABLE_RESERVATION_DATA = "/foodtablereservation/data";
//POST_FOOD_TABLE_RESERVATION_CREATE
export const POST_FOOD_TABLE_RESERVATION_CREATE =
  "/foodtablereservation/create";
//POST_FOOD_TABLE_RESERVATION_IMPORT
export const POST_FOOD_TABLE_RESERVATION_IMPORT =
  "/foodtablereservation/import";
//PUT_FOOD_TABLE_RESERVATION_UPDATE
export const PUT_FOOD_TABLE_RESERVATION_UPDATE = "/foodtablereservation/update";
//DELETE_FOOD_TABLE_RESERVATION_DELETE
export const DELETE_FOOD_TABLE_RESERVATION_DELETE =
  "/foodtablereservation/delete";
//GET_FOOD_TABLE_AREA_LIST
export const GET_FOOD_TABLE_AREA_LIST = "/foodtablearea/list";
//GET_FOOD_TABLE_AREA_DATA
export const GET_FOOD_TABLE_AREA_DATA = "/foodtablearea/data";
//POST_FOOD_TABLE_AREA_CREATE
export const POST_FOOD_TABLE_AREA_CREATE = "/foodtablearea/create";
//PUT_FOOD_TABLE_AREA_UPDATE
export const PUT_FOOD_TABLE_AREA_UPDATE = "/foodtablearea/update";
//DELETE_FOOD_TABLE_AREA_DELETE
export const DELETE_FOOD_TABLE_AREA_DELETE = "/foodtablearea/delete";
//PUT_FOOD_TABLE_AREA_REORDER (drag-sort areas)
export const PUT_FOOD_TABLE_AREA_REORDER = "/foodtablearea/reorder";
//FOOD_TABLE_RESERVATION_DURATION_RULE (booking duration rules)
export const GET_FOOD_TABLE_RESERVATION_DURATION_RULE_DATA =
  "/foodtablereservationdurationrule/data";
export const POST_FOOD_TABLE_RESERVATION_DURATION_RULE_CREATE =
  "/foodtablereservationdurationrule/create";
export const PUT_FOOD_TABLE_RESERVATION_DURATION_RULE_UPDATE =
  "/foodtablereservationdurationrule/update";
export const DELETE_FOOD_TABLE_RESERVATION_DURATION_RULE_DELETE =
  "/foodtablereservationdurationrule/delete";
export const POST_FOOD_TABLE_RESERVATION_DURATION_RULE_SEARCH =
  "/foodtablereservationdurationrule/search";
//GET_MESSAGING_CHANNEL_LIST_API
export const GET_MESSAGING_CHANNEL_LIST_API = "/messagingchannel/list";
//START_MESSAGING_CONVERSATION_MESSAGE_API
export const START_MESSAGING_CONVERSATION_MESSAGE_API =
  "/messagingconversationmessage/start";
//SEARCH_MESSAGING_CONVERSATION_TEMPLATE_API
export const SEARCH_MESSAGING_CONVERSATION_TEMPLATE_API =
  "/messagingconversationtemplate/search";
//REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_API
export const REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_API =
  "/messagingconversationparticipant/remove";
//MARK_MESSAGING_CONVERSATION_READ_API
export const MARK_MESSAGING_CONVERSATION_READ_API =
  "/messagingconversation/markread";
//MARK_MESSAGING_CONVERSATION_UNREAD_API
export const MARK_MESSAGING_CONVERSATION_UNREAD_API =
  "/messagingconversation/markunread";
//MARK_MESSAGING_CONVERSATION_MESSAGE_READ_API
export const MARK_MESSAGING_CONVERSATION_MESSAGE_READ_API =
  "/messagingconversationmessage/markread";
//MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_API
export const MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_API =
  "/messagingconversationmessage/markunread";
//GET_MESSAGING_CONVERSATION_DATA_API
export const GET_MESSAGING_CONVERSATION_DATA_API =
  "/messagingconversationmessage/data";
//CLOSE_MESSAGING_CONVERSATION_API
export const CLOSE_MESSAGING_CONVERSATION_API = "/messagingconversation/close";
//GET_FOOD_TABLE_LIST
export const GET_FOOD_TABLE_LIST = "/foodtable/list";
//GET_FOOD_TABLE_DATA
export const GET_FOOD_TABLE_DATA = "/foodtable/data";
//POST_FOOD_TABLE_CREATE
export const POST_FOOD_TABLE_CREATE = "/foodtable/create";
//PUT_FOOD_TABLE_UPDATE
export const PUT_FOOD_TABLE_UPDATE = "/foodtable/update";
//DELETE_FOOD_TABLE_DELETE
export const DELETE_FOOD_TABLE_DELETE = "/foodtable/delete";
//GET_FOOD_TABLE_RESERVATION_SEARCH
export const GET_FOOD_TABLE_RESERVATION_SEARCH = "/foodtablereservation/search";
//PUT_FOOD_TABLE_DIARY_BLOCK_UPDATE
export const PUT_FOOD_TABLE_DIARY_BLOCK_UPDATE = "/foodtableblock/update";
//GET_FOOD_TABLE_BLOCK_LIST
export const GET_FOOD_TABLE_BLOCK_LIST = "/foodtableblock/list";
//GET_FOOD_TABLE_BLOCK_DATA
export const GET_FOOD_TABLE_BLOCK_DATA = "/foodtableblock/data";
//POST_FOOD_TABLE_BLOCK_CREATE
export const POST_FOOD_TABLE_BLOCK_CREATE = "/foodtableblock/create";
//DELETE_FOOD_TABLE_BLOCK_DELETE
export const DELETE_FOOD_TABLE_BLOCK_DELETE = "/foodtableblock/delete";
//PUT_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
export const PUT_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE =
  "/foodtablereservation/update";
//PUT_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
export const PUT_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL =
  "/foodtablereservation/cancel";
// Task 24607 - the Unallocated tray: park a booking off-table, and put it back.
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN =
  "/foodtablereservationtableassignment/unassign";
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN =
  "/foodtablereservationtableassignment/assign";
// Task 24278 - request-to-book approve / decline
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE =
  "/foodtablereservation/request/approve";
export const GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW =
  "/foodtablereservation/request/decline/preview";
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE =
  "/foodtablereservation/request/decline";
//GET_FOOD_TABLE_DIARY_RULE_LIST
export const GET_FOOD_TABLE_DIARY_RULE_LIST = "/foodtablediaryrule/list";
//GET_FOOD_TABLE_DIARY_RULE_DATA
export const GET_FOOD_TABLE_DIARY_RULE_DATA = "/foodtablediaryrule/data";
//POST_FOOD_TABLE_DIARY_RULE_CREATE
export const POST_FOOD_TABLE_DIARY_RULE_CREATE = "/foodtablediaryrule/create";
//PUT_FOOD_TABLE_DIARY_RULE_UPDATE
export const PUT_FOOD_TABLE_DIARY_RULE_UPDATE = "/foodtablediaryrule/update";
//DELETE_FOOD_TABLE_DIARY_RULE_DELETE
export const DELETE_FOOD_TABLE_DIARY_RULE_DELETE = "/foodtablediaryrule/delete";
//POST_FOOD_TABLE_DIARY_RULE_REORDER
export const POST_FOOD_TABLE_DIARY_RULE_REORDER =
  "/foodtablediaryrule/reorder";
//GET_FOOD_TABLE_DIARY_RULE_SEARCH
export const GET_FOOD_TABLE_DIARY_RULE_SEARCH = "/foodtablediaryrule/search";
//GET_FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT
export const GET_FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT =
  "/foodtablediaryrule/search/bytimeslot";
//GET_FOOD_TABLE_SEARCH_API
export const GET_FOOD_TABLE_SEARCH_API = "/foodtable/search";
// TABLE PLANNER (Task 24625) - saves positions/sizes only
export const PUT_FOOD_TABLE_FLOORPLAN_API = "/foodtable/floorplan";
// BOOKING ENGINE TABLE ORDER (Task 24634)
export const PUT_FOOD_TABLE_REORDER_API = "/foodtable/reorder";
//GET_FOOD_TABLE_AREA_SEARCH_API
export const GET_FOOD_TABLE_AREA_SEARCH_API = "/foodtablearea/search";
//GET_FOOD_TABLE_RULE_SEARCH_API
export const GET_FOOD_TABLE_RULE_SEARCH_API = "/foodtablediaryrule/search";
//GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
export const GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER =
  "/foodtablereservation/pdf/runningorder";
//GET_FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
export const GET_FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY =
  "/foodtablereservation/checkavailability";
//GET_FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
export const GET_FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER =
  "/foodtablereservation/search";
//GET_FOOD_TABLE_JOIN_LIST
export const GET_FOOD_TABLE_JOIN_LIST = "/foodtablejoin/list";
//GET_FOOD_TABLE_JOIN_DATA
export const GET_FOOD_TABLE_JOIN_DATA = "/foodtablejoin/data";
//POST_FOOD_TABLE_JOIN_CREATE
export const POST_FOOD_TABLE_JOIN_CREATE = "/foodtablejoin/create";
//DELETE_FOOD_TABLE_JOIN_DELETE
export const DELETE_FOOD_TABLE_JOIN_DELETE = "/foodtablejoin/delete";
//GET_FOOD_TABLE_JOIN_SEARCH
export const GET_FOOD_TABLE_JOIN_SEARCH = "/foodtablejoin/search";
//GET_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST
export const GET_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST =
  "/foodpreordersitelocationfloorplanobject/list";
//GET_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA
export const GET_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA =
  "/foodpreordersitelocationfloorplanobject/data";
//POST_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE
export const POST_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE =
  "/foodpreordersitelocationfloorplanobject/create";
//PUT_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE
export const PUT_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE =
  "/foodpreordersitelocationfloorplanobject/update";
//DELETE_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE
export const DELETE_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE =
  "/foodpreordersitelocationfloorplanobject/delete";
//************  API Calls ************//
//Book A Table
//GET_FOOD_TABLE_WIDGET_RENDER_DATA_REQUEST
export const GET_FOOD_TABLE_WIDGET_RENDER_DATA_REQUEST =
  "/foodtablewidget/render";
//POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_REQUEST
export const POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_REQUEST =
  "/foodtablewidget/checkavailability";
//POST_FOOD_TABLE_WIDGET_BOOK_REQUEST
export const POST_FOOD_TABLE_WIDGET_BOOK_REQUEST = "/foodtablewidget/book";
//GET_FOOD_TABLE_WIDGET_LIST_REQUEST
export const GET_FOOD_TABLE_WIDGET_LIST_REQUEST = "/foodtablewidget/list";
//GET_FOOD_TABLE_WIDGET_DATA_REQUEST
export const GET_FOOD_TABLE_WIDGET_DATA_REQUEST = "/foodtablewidget/data";
//POST_FOOD_TABLE_WIDGET_CREATE_REQUEST
export const POST_FOOD_TABLE_WIDGET_CREATE_REQUEST = "/foodtablewidget/create";
//PUT_FOOD_TABLE_WIDGET_UPDATE_REQUEST
export const PUT_FOOD_TABLE_WIDGET_UPDATE_REQUEST = "/foodtablewidget/update";
//DELETE_FOOD_TABLE_WIDGET_DELETE_REQUEST
export const DELETE_FOOD_TABLE_WIDGET_DELETE_REQUEST =
  "/foodtablewidget/delete";
//GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_REQUEST
export const GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_REQUEST =
  "/foodtablereservationactivitylog/search";
//POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_REQUEST
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_REQUEST =
  "/foodtablereservation/lock";
//POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_REQUEST
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_REQUEST =
  "/foodtablereservation/unlock";
//GET_FOOD_TABLE_WIDGET_SEARCH_REQUEST
export const GET_FOOD_TABLE_WIDGET_SEARCH_REQUEST = "/foodtablewidget/search";
//GET_PAYMENT_REQUEST_PUBLIC_DATA_REQUEST
export const GET_PAYMENT_REQUEST_PUBLIC_DATA_REQUEST =
  "/payment/public/preauthorise";
//GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_REQUEST
export const GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_REQUEST =
  "/foodtablereservation/public/render";
//POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_REQUEST
export const POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_REQUEST =
  "/foodtablereservation/public/cancel";
//************  API Calls ************//
//Chat CRMit
//CHATBOT_INTERACT_API
export const CHATBOT_INTERACT_API = "/chatbot/interact";
//CHATBOT_VOICE_TO_TEXT_API
export const CHATBOT_VOICE_TO_TEXT_API = "/chatbot/voicetotext";
//CRMit AI Assistant (agentic) — replaces the legacy /chatbot endpoints
export const ASSISTANT_CHAT_API = "/assistant/chat";
export const ASSISTANT_CONFIRM_API = "/assistant/confirm";
export const ASSISTANT_GENERAL_API = "/assistant/general";
export const ASSISTANT_CONVERSATIONS_API = "/assistant/conversations";
export const ASSISTANT_CONVERSATION_API = "/assistant/conversation";
//************  API Calls ************//
//Shift Reports
//API_GET_FOOD_SHIFT_REPORT_LIST
export const API_GET_FOOD_SHIFT_REPORT_LIST = "/foodshiftreport/list";
//API_SEARCH_FOOD_SHIFT_REPORT
export const API_SEARCH_FOOD_SHIFT_REPORT = "/foodshiftreport/search";
//************  API Calls ************//
//GET_PURCHASE_ORDER_LIST_API
export const GET_PURCHASE_ORDER_LIST_API = "/purchaseorder/list ";
//GET_PURCHASE_ORDER_SEARCH_API
export const GET_PURCHASE_ORDER_SEARCH_API = "/purchaseorder/search";
//GET_PURCHASE_ORDER_DATA_API
export const GET_PURCHASE_ORDER_DATA_API = "/purchaseorder/data";
//CREATE_PURCHASE_ORDER_API
export const CREATE_PURCHASE_ORDER_API = "/purchaseorder/create";
//UPDATE_PURCHASE_ORDER_API
export const UPDATE_PURCHASE_ORDER_API = "/purchaseorder/update";
//VOID_PURCHASE_ORDER_API
export const VOID_PURCHASE_ORDER_API = "/purchaseorder/void";
//MARK_COMPLETE_PURCHASE_ORDER_API
export const MARK_COMPLETE_PURCHASE_ORDER_API = "/purchaseorder/markcomplete";
//GET_PURCHASE_ORDER_STATUS_LIST_API
export const GET_PURCHASE_ORDER_STATUS_LIST_API = "/purchaseorderstatus/list";
//************  API Calls ************//
//MASTER_PAYMENT_PROVIDER

//GET_MASTER_PAYMENT_PROVIDER_LIST_API
export const GET_MASTER_PAYMENT_PROVIDER_LIST_API =
  "/masterpaymentprovider/list";
//GET_MASTER_PAYMENT_PROVIDER_DATA_API
export const GET_MASTER_PAYMENT_PROVIDER_DATA_API =
  "/masterpaymentprovider/data";
//CREATE_MASTER_PAYMENT_PROVIDER_API
export const CREATE_MASTER_PAYMENT_PROVIDER_API =
  "/masterpaymentprovider/create";
//UPDATE_MASTER_PAYMENT_PROVIDER_API
export const UPDATE_MASTER_PAYMENT_PROVIDER_API =
  "/masterpaymentprovider/update";
//DELETE_MASTER_PAYMENT_PROVIDER_API
export const DELETE_MASTER_PAYMENT_PROVIDER_API =
  "/masterpaymentprovider/delete";

//************  API Calls ************//
//SALES_ORDER_LIST_API
export const SALES_ORDER_LIST_API = "/salesorder/list";
//SALES_ORDER_DATA_API
export const SALES_ORDER_DATA_API = "/salesorder/data";
//SALES_ORDER_SEARCH_API
export const SALES_ORDER_SEARCH_API = "/salesorder/search";
//SALES_ORDER_CREATE_API
export const SALES_ORDER_CREATE_API = "/salesorder/create";
//SALES_ORDER_UPDATE_API
export const SALES_ORDER_UPDATE_API = "/salesorder/update";
//SALES_ORDER_VOID_API
export const SALES_ORDER_VOID_API = "/salesorder/void";
//SALES_ORDER_PDF_API
export const SALES_ORDER_PDF_API = "/salesorder/pdf/";
//SALES_ORDER_EMAIL_AUTOMATED_API
export const SALES_ORDER_EMAIL_AUTOMATED_API = "/salesorder/email/automated";
//SALES_ORDER_EMAIL_RESEND_AUTOMATED_API
export const SALES_ORDER_EMAIL_RESEND_AUTOMATED_API =
  "/salesorder/emailresend/automated";
//SALES_ORDER_DAILY_BALANCE_API
export const SALES_ORDER_DAILY_BALANCE_API = "/salesorderdailybalance";
//SALES_ORDER_ITEM_SEARCH_API
export const SALES_ORDER_ITEM_SEARCH_API = "/salesorderitem/search";
//SALES_ORDER_ITEM_LIST_API
export const SALES_ORDER_ITEM_LIST_API = "/salesorderitem/list";
//SALES_ORDER_STATUS_LIST_API
export const SALES_ORDER_STATUS_LIST_API = "/salesorderstatus/list";
//SALES_ORDER_STATUS_DATA_API
export const SALES_ORDER_STATUS_DATA_API = "/salesorderstatus/data";
//SALES_ORDER_STATUS_CREATE_API
export const SALES_ORDER_STATUS_CREATE_API = "/salesorderstatus/create";
//SALES_ORDER_STATUS_UPDATE_API
export const SALES_ORDER_STATUS_UPDATE_API = "/salesorderstatus/update";
//SALES_ORDER_STATUS_DELETE_API
export const SALES_ORDER_STATUS_DELETE_API = "/salesorderstatus/delete";
//SALES_ORDER_ACTIVITY_LOG_SEARCH_API
export const SALES_ORDER_ACTIVITY_LOG_SEARCH_API =
  "/salesorderactivitylog/search";
//SALES_ORDER_CONVERT_TO_INVOICE_API
export const SALES_ORDER_CONVERT_TO_INVOICE_API =
  "/salesorder/converttoinvoice";
//PRODUCT_STOCK_RESERVED_SEARCH_API
export const PRODUCT_STOCK_RESERVED_SEARCH_API = "/productstockreserved/search";
//PRODUCT_STOCK_RESERVED_LIST_API
export const PRODUCT_STOCK_RESERVED_LIST_API = "/productstockreserved/list";
//GET_PURCHASE_ORDER_STATUS_DATA_API
export const GET_PURCHASE_ORDER_STATUS_DATA_API = "/purchaseorderstatus/data";
//CREATE_PURCHASE_ORDER_STATUS_API
export const CREATE_PURCHASE_ORDER_STATUS_API = "/purchaseorderstatus/create";
//UPDATE_PURCHASE_ORDER_STATUS_API
export const UPDATE_PURCHASE_ORDER_STATUS_API = "/purchaseorderstatus/update";
//DELETE_PURCHASE_ORDER_STATUS_API
export const DELETE_PURCHASE_ORDER_STATUS_API = "/purchaseorderstatus/delete";
//GET_PURCHASE_ORDER_PDF_API
export const GET_PURCHASE_ORDER_PDF_API = "/purchaseorder/pdf";
//************  API Calls ************//
//Staff Leave
//GET_STAFF_HOLIDAY_CALENDAR_LIST_API
export const GET_STAFF_HOLIDAY_CALENDAR_LIST_API = "/staffholidaycalendar/list";
//GET_STAFF_HOLIDAY_CALENDAR_DATA_API
export const GET_STAFF_HOLIDAY_CALENDAR_DATA_API = "/staffholidaycalendar/data";
//CREATE_STAFF_HOLIDAY_CALENDAR_API
export const CREATE_STAFF_HOLIDAY_CALENDAR_API = "/staffholidaycalendar/create";
//UPDATE_STAFF_HOLIDAY_CALENDAR_API
export const UPDATE_STAFF_HOLIDAY_CALENDAR_API = "/staffholidaycalendar/update";
//DELETE_STAFF_HOLIDAY_CALENDAR_API
export const DELETE_STAFF_HOLIDAY_CALENDAR_API = "/staffholidaycalendar/delete";
//GENERATE_STAFF_HOLIDAY_CALENDAR_PERIODS_API
export const GENERATE_STAFF_HOLIDAY_CALENDAR_PERIODS_API =
  "/staffholidaycalendar/generateperiods";
//GET_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API
export const GET_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API =
  "/staffholidaycalendarperiod/list";
//GET_STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_API
export const GET_STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_API =
  "/staffholidaycalendarperiod/data";
//CREATE_STAFF_HOLIDAY_CALENDAR_PERIOD_API
export const CREATE_STAFF_HOLIDAY_CALENDAR_PERIOD_API =
  "/staffholidaycalendarperiod/create";
//UPDATE_STAFF_HOLIDAY_CALENDAR_PERIOD_API
export const UPDATE_STAFF_HOLIDAY_CALENDAR_PERIOD_API =
  "/staffholidaycalendarperiod/update";
//DELETE_STAFF_HOLIDAY_CALENDAR_PERIOD_API
export const DELETE_STAFF_HOLIDAY_CALENDAR_PERIOD_API =
  "/staffholidaycalendarperiod/delete";
//GET_CALENDAR_NON_WORKING_DAY_LIST_API
export const GET_CALENDAR_NON_WORKING_DAY_LIST_API =
  "/calendarnonworkingday/list";
//GET_CALENDAR_NON_WORKING_DAY_DATA_API
export const GET_CALENDAR_NON_WORKING_DAY_DATA_API =
  "/calendarnonworkingday/data";
//CREATE_CALENDAR_NON_WORKING_DAY_API
export const CREATE_CALENDAR_NON_WORKING_DAY_API =
  "/calendarnonworkingday/create";
//UPDATE_CALENDAR_NON_WORKING_DAY_API
export const UPDATE_CALENDAR_NON_WORKING_DAY_API =
  "/calendarnonworkingday/update";
//DELETE_CALENDAR_NON_WORKING_DAY_API
export const DELETE_CALENDAR_NON_WORKING_DAY_API =
  "/calendarnonworkingday/delete";
//CREATE_STAFF_LEAVE_REQUEST_API
export const CREATE_STAFF_LEAVE_REQUEST_API = "/staffleave/create";
//SEED_APPROVED_STAFF_LEAVE_API - Task 24476, records leave already agreed
//outside the CRM straight in as approved, without the manager decision chain.
export const SEED_APPROVED_STAFF_LEAVE_API = "/staffleave/seedapproved";
//GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_API
export const GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_API =
  "/stafftostaffholidaycalendarperiod/list/current";
//GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_API
export const GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_API =
  "/stafftostaffholidaycalendarperiod/list/future";
//GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_API
export const GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_API =
  "/stafftostaffholidaycalendarperiod/list/past";
//GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API
export const GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API =
  "/stafftostaffholidaycalendarperiod/list";
//STAFF_LEAVE_DECISION_APPROVE_API
export const STAFF_LEAVE_DECISION_APPROVE_API = "/staffleavedecision/approve";
//STAFF_LEAVE_DECISION_DECLINE_API
export const STAFF_LEAVE_DECISION_DECLINE_API = "/staffleavedecision/decline";
//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_API
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_API =
  "/stafftostaffholidaycalendarperiod/list/current/myteammembers";
//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_API
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_API =
  "/stafftostaffholidaycalendarperiod/list/current/my";
//STAFF_LEAVE_DECISION_DATA_API
export const STAFF_LEAVE_DECISION_DATA_API = "/staffleavedecision/data";
//STAFF_LEAVE_DECISION_CONTEXT_API - Task 24672
//SEARCH_MY_TEAM_MEMBERS_API - Task 24675
export const SEARCH_MY_TEAM_MEMBERS_API = "/staff/search/myteammembers";
export const STAFF_LEAVE_DECISION_CONTEXT_API =
  "/staffleavedecision/data/context";
//STAFF_LEAVE_DECISION_LIST_MY_OPEN_API
export const STAFF_LEAVE_DECISION_LIST_MY_OPEN_API =
  "/staffleavedecision/list/my/open";
//STAFF_LEAVE_DECISION_LIST_API
export const STAFF_LEAVE_DECISION_LIST_API = "/staffleavedecision/list";
//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_API
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_API =
  "/stafftostaffholidaycalendarperiod/list/current";
//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_API
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_API =
  "/stafftostaffholidaycalendarperiod/list/future";
//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_API
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_API =
  "/stafftostaffholidaycalendarperiod/list/past";
//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API
export const OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API =
  "/stafftostaffholidaycalendarperiod/list";
//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_API
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_API =
  "/stafftostaffholidaycalendarperiod/list/open/myandmyteammembers";
//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_API
export const STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_API =
  "/stafftostaffholidaycalendarperiod/search";
//GET_STAFF_LEAVE_RESTRICTION_PERIOD_LIST_API
export const GET_STAFF_LEAVE_RESTRICTION_PERIOD_LIST_API =
  "/staffleaverestrictionperiod/list";
//GET_STAFF_LEAVE_RESTRICTION_PERIOD_DATA_API
export const GET_STAFF_LEAVE_RESTRICTION_PERIOD_DATA_API =
  "/staffleaverestrictionperiod/data";
//CREATE_STAFF_LEAVE_RESTRICTION_PERIOD_API
export const CREATE_STAFF_LEAVE_RESTRICTION_PERIOD_API =
  "/staffleaverestrictionperiod/create";
//UPDATE_STAFF_LEAVE_RESTRICTION_PERIOD_API
export const UPDATE_STAFF_LEAVE_RESTRICTION_PERIOD_API =
  "/staffleaverestrictionperiod/update";
//DELETE_STAFF_LEAVE_RESTRICTION_PERIOD_API
export const DELETE_STAFF_LEAVE_RESTRICTION_PERIOD_API =
  "/staffleaverestrictionperiod/delete";

//POST_FEEDBACK_API
export const POST_FEEDBACK_API = "/system/reportissue";
//************  API Calls ************//
//Reports
//GET_REPORT_CONTRACT_ITEMS_BY_CUSTOMER
export const GET_REPORT_CONTRACT_ITEMS_BY_CUSTOMER =
  "/report/report_contractitems_by_customer";
//************  API Calls ************//
// File Uploads
//MODULE_FILE_CSV_UPLOAD_API
export const MODULE_FILE_CSV_UPLOAD_API = "/zsystemimporter/import";
//MODULE_AVAILABLE_MODULE_FIELDS_API
export const MODULE_AVAILABLE_MODULE_FIELDS_API =
  "/zsystemimporter/availablemodulefields";
//FILE_ATTACHMENT_CREATE_PREAUTH_API
export const FILE_ATTACHMENT_CREATE_PREAUTH_API =
  "/fileattachment/create/preauth";

//************  API Calls ************//
//COMPANY_RECENT_ACTIVITY_LIST_API
export const COMPANY_RECENT_ACTIVITY_LIST_API = "/userrecentactivity/list";
//************  API Calls ************//
//Proforma Invoices
//GET_PROFORMA_INVOICE_LIST_API
export const GET_PROFORMA_INVOICE_LIST_API = "/proformainvoice/list";
//GET_PROFORMA_INVOICE_DATA_API
export const GET_PROFORMA_INVOICE_DATA_API = "/proformainvoice/data";
//CREATE_PROFORMA_INVOICE_API
export const CREATE_PROFORMA_INVOICE_API = "/proformainvoice/create";
//UPDATE_PROFORMA_INVOICE_API
export const UPDATE_PROFORMA_INVOICE_API = "/proformainvoice/update";
//VOID_PROFORMA_INVOICE_API
export const VOID_PROFORMA_INVOICE_API = "/proformainvoice/void";
//GET_PROFORMA_INVOICE_ITEM_LIST_API
export const GET_PROFORMA_INVOICE_ITEM_LIST_API = "/proformainvoiceitem/list";
//SEARCH_PROFORMA_INVOICE_ITEM_API
export const SEARCH_PROFORMA_INVOICE_ITEM_API = "/proformainvoiceitem/search";
//GET_PROFORMA_INVOICE_STATUS_LIST_API
export const GET_PROFORMA_INVOICE_STATUS_LIST_API =
  "/proformainvoicestatus/list";
//GET_PROFORMA_INVOICE_STATUS_DATA_API
export const GET_PROFORMA_INVOICE_STATUS_DATA_API =
  "/proformainvoicestatus/data";
//CREATE_PROFORMA_INVOICE_STATUS
export const CREATE_PROFORMA_INVOICE_STATUS = "/proformainvoicestatus/create";
//UPDATE_PROFORMA_INVOICE_STATUS
export const UPDATE_PROFORMA_INVOICE_STATUS = "/proformainvoicestatus/update";
//DELETE_PROFORMA_INVOICE_STATUS
export const DELETE_PROFORMA_INVOICE_STATUS = "/proformainvoicestatus/delete";
//GET_PROFORMA_INVOICE_PDF_API
export const GET_PROFORMA_INVOICE_PDF_API = "/proformainvoice/pdf";
//SEND_AUTOMATED_PROFORMA_INVOICE_EMAIL_API
export const SEND_AUTOMATED_PROFORMA_INVOICE_EMAIL_API =
  "/proformainvoice/emailsend/automated";
//RESEND_AUTOMATED_PROFORMA_INVOICE_EMAIL_API
export const RESEND_AUTOMATED_PROFORMA_INVOICE_EMAIL_API =
  "/proformainvoice/emailresend/automated";
//CONVERT_PROFORMA_INVOICE_TO_INVOICE_API
export const CONVERT_PROFORMA_INVOICE_TO_INVOICE_API =
  "/proformainvoice/converttoinvoice";
//SEARCH_PROFORMA_INVOICE_API
export const SEARCH_PROFORMA_INVOICE_API = "/proformainvoice/search";
//GET_PROFORMA_INVOICE_ACTIVITY_LOG_API
export const GET_PROFORMA_INVOICE_ACTIVITY_LOG_API =
  "/proformainvoiceactivitylog/search";
//************  API Calls ************//
//ThirdPartyIntegratio
//THIRD_PARTY_XERO_URL_AUTH_API
export const THIRD_PARTY_XERO_URL_AUTH_API = "/thirdpartyxero/urlauth";
//THIRD_PARTY_XERO_CHECK_STATUS_API
export const THIRD_PARTY_XERO_CHECK_STATUS_API = "/thirdpartyxero/checkstatus";
//THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_API
export const THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_API =
  "/thirdpartyxero/generateaccesstoken";
//THIRD_PARTY_XERO_ASSIGN_TENANT_API
export const THIRD_PARTY_XERO_ASSIGN_TENANT_API =
  "/thirdpartyxero/assigntenant";
//THIRD_PARTY_XERO_SYNC_MANUAL_API
export const THIRD_PARTY_XERO_SYNC_MANUAL_API = "/thirdpartyxero/sync/manual";
//THIRD_PARTY_XERO_UNASSIGN_TENANT_API
export const THIRD_PARTY_XERO_UNASSIGN_TENANT_API =
  "/thirdpartyxero/unassigntenant";
//THIRD_PARTY_BRIGHTPAY_* (per-company payroll employee sync)
export const THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_API =
  "/thirdpartybrightpay/savecredentials";
export const THIRD_PARTY_BRIGHTPAY_URL_AUTH_API =
  "/thirdpartybrightpay/urlauth";
export const THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_API =
  "/thirdpartybrightpay/checkstatus";
export const THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_API =
  "/thirdpartybrightpay/generateaccesstoken";
export const THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_API =
  "/thirdpartybrightpay/assignemployer";
export const THIRD_PARTY_BRIGHTPAY_UNASSIGN_API =
  "/thirdpartybrightpay/unassign";
export const THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_API =
  "/thirdpartybrightpay/sync/employees";
export const THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_API =
  "/thirdpartybrightpay/employees/list";
//THIRD_PARTY_GPSLIVE_* (per-company vehicle GPS tracking API key)
export const THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_API =
  "/thirdpartygpslive/savecredentials";
export const THIRD_PARTY_GPSLIVE_CHECK_STATUS_API =
  "/thirdpartygpslive/checkstatus";
export const THIRD_PARTY_GPSLIVE_TEST_CONNECTION_API =
  "/thirdpartygpslive/testconnection";
export const THIRD_PARTY_GPSLIVE_UNASSIGN_API =
  "/thirdpartygpslive/unassign";
//THIRD_PARTY_VAPI_* (per-company Virtual Receptionist — MULTIPLE per company)
export const THIRD_PARTY_VAPI_LIST_API = "/thirdpartyvapi/list";
export const THIRD_PARTY_VAPI_DATA_API = "/thirdpartyvapi/data";
export const THIRD_PARTY_VAPI_CREATE_API = "/thirdpartyvapi/create";
export const THIRD_PARTY_VAPI_UPDATE_API = "/thirdpartyvapi/update";
export const THIRD_PARTY_VAPI_DELETE_API = "/thirdpartyvapi/delete";
export const THIRD_PARTY_VAPI_PROVISION_API =
  "/thirdpartyvapi/provision";
export const THIRD_PARTY_VAPI_LINK_TWILIO_API =
  "/thirdpartyvapi/linktwilio";
export const THIRD_PARTY_VAPI_TOGGLE_API =
  "/thirdpartyvapi/toggle";
//TELEPHONY_* (Twilio number ordering — cross-sells the Virtual Receptionist)
export const CALL_PROVIDER_LIST_API = "/callprovider/list";
export const TELEPHONE_NUMBER_AVAILABLE_API =
  "/telephonenumberaccount/available";
export const TELEPHONE_NUMBER_PURCHASE_API =
  "/telephonenumberaccount/purchase";
export const TELEPHONE_NUMBER_LIST_API = "/telephonenumberaccount/list";
// Change #100774 - send SMS from a bought number, and the replies to it.
export const TELEPHONE_NUMBER_SMS_SENDER_API = "/telephonenumberaccount/smssender";
export const SMS_REPLIES_API = "/smsoutbound/replies";
export const SMS_CONVERSATIONS_API = "/smsoutbound/conversations";
export const SMS_CONVERSATION_API = "/smsoutbound/conversation";
export const SMS_REPLY_API = "/smsoutbound/reply";
export const TWILIO_REGULATORY_BUNDLE_DATA_API = "/twilioregulatorybundle/data";
export const TWILIO_REGULATORY_BUNDLE_SUBMIT_API = "/twilioregulatorybundle/submit";
//THIRD_PARTY_GOOGLE_URL_AUTH_API
export const THIRD_PARTY_GOOGLE_URL_AUTH_API = "/thirdpartygoogle/urlauth";
//THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_API
export const THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_API =
  "/thirdpartygoogle/generateaccesstoken";
//THIRD_PARTY_HMRC_INTEGRATION_ACCESS
export const THIRD_PARTY_HMRC_INTEGRATION_ACCESS = "/thirdpartyhmrc/urlauth";
//THIRD_PARTY_HMRC_ENVIRONMENT_DATA_API
export const THIRD_PARTY_HMRC_ENVIRONMENT_DATA_API =
  "/thirdpartyhmrc/environment/data";
//THIRD_PARTY_HMRC_ENVIRONMENT_SET_API
export const THIRD_PARTY_HMRC_ENVIRONMENT_SET_API =
  "/thirdpartyhmrc/environment/set";
//THIRD_PARTY_HMRC_STATUS_API
export const THIRD_PARTY_HMRC_STATUS_API = "/thirdpartyhmrc/status";
//THIRD_PARTY_HMRC_TEST_API
export const THIRD_PARTY_HMRC_TEST_API = "/thirdpartyhmrc/test";
//THIRD_PARTY_HMRC_DISCONNECT_API
export const THIRD_PARTY_HMRC_DISCONNECT_API = "/thirdpartyhmrc/disconnect";
// Change #100691 - Companies House accounts filing
export const COMPANIES_HOUSE_FILING_SETTINGS_DATA_API = "/thirdpartycompanieshouse/settings/data";
export const COMPANIES_HOUSE_FILING_SETTINGS_SAVE_API = "/thirdpartycompanieshouse/settings/save";
export const COMPANIES_HOUSE_FILING_SETTINGS_CHECK_API = "/thirdpartycompanieshouse/settings/check";
export const COMPANIES_HOUSE_FILING_PREVIEW_API = "/thirdpartycompanieshouse/accounts/preview";
export const COMPANIES_HOUSE_FILING_SUBMIT_API = "/thirdpartycompanieshouse/accounts/submit";
export const COMPANIES_HOUSE_FILING_SUBMISSION_LIST_API = "/thirdpartycompanieshouse/submission/list";
export const COMPANIES_HOUSE_FILING_SUBMISSION_DATA_API = "/thirdpartycompanieshouse/submission/data";
export const COMPANIES_HOUSE_FILING_SUBMISSION_CHECKSTATUS_API = "/thirdpartycompanieshouse/submission/checkstatus";
// Change #100747 - HMRC filing (MTD VAT + CT600)
export const HMRC_FILING_SETTINGS_DATA_API = "/hmrcfiling/settings/data";
export const HMRC_FILING_SETTINGS_SAVE_API = "/hmrcfiling/settings/save";
export const HMRC_FILING_VAT_OBLIGATIONS_API = "/hmrcfiling/vat/obligations";
export const HMRC_FILING_VAT_CALCULATE_API = "/hmrcfiling/vat/calculate";
export const HMRC_FILING_VAT_PREVIEW_API = "/hmrcfiling/vat/preview";
export const HMRC_FILING_VAT_SUBMIT_API = "/hmrcfiling/vat/submit";
export const HMRC_FILING_VAT_RETURN_API = "/hmrcfiling/vat/return";
export const HMRC_FILING_VAT_LIABILITIES_API = "/hmrcfiling/vat/liabilities";
export const HMRC_FILING_VAT_PAYMENTS_API = "/hmrcfiling/vat/payments";
export const HMRC_FILING_CT_CALCULATE_API = "/hmrcfiling/ct/calculate";
export const HMRC_FILING_CT_PREVIEW_API = "/hmrcfiling/ct/preview";
export const HMRC_FILING_CT_SUBMIT_API = "/hmrcfiling/ct/submit";
export const HMRC_FILING_SUBMISSION_LIST_API = "/hmrcfiling/submission/list";
export const HMRC_FILING_SUBMISSION_DATA_API = "/hmrcfiling/submission/data";
export const HMRC_FILING_SUBMISSION_CHECKSTATUS_API = "/hmrcfiling/submission/checkstatus";
//************  API Calls ************//
//Partners
//GET_PARTNERS_LIST_API
export const GET_PARTNERS_LIST_API = "/masterreferralpartner/list";
//************  API Calls ************//
//CHECK_LIST_TEMPLATE_LIST_ACTIVE_API
export const CHECK_LIST_TEMPLATE_LIST_ACTIVE_API =
  "/taskchecklisttemplate/list/active";
//CHECK_LIST_TEMPLATE_ASSIGN_TO_TASK_API
export const CHECK_LIST_TEMPLATE_ASSIGN_TO_TASK_API =
  "/taskchecklisttemplate/assigntotask";
//CHECK_LIST_SEARCH_API
export const CHECK_LIST_SEARCH_API = "/taskchecklist/search";
//CHECK_LIST_DATA_API
export const CHECK_LIST_DATA_API = "/taskchecklisttemplate/data";
//CHECK_LIST_UPDATE_API
export const CHECK_LIST_UPDATE_API = "/taskchecklist/update";
//CHECK_LIST_PDF_SHEET_API
export const CHECK_LIST_PDF_SHEET_API = "/taskchecklist/pdfsheet";
//DELETE_TASK_CHECK_LIST_API
export const DELETE_TASK_CHECK_LIST_API = "/taskchecklist/delete";
//CHECK_LIST_MERGE_WITH_TEMPLATE_API
export const CHECK_LIST_MERGE_WITH_TEMPLATE_API =
  "/taskchecklist/data/mergewithtemplate";
//TASK_CHECK_LIST_SEARCH_API
export const TASK_CHECK_LIST_SEARCH_API = "/taskchecklist/search";
//TASK_CHECK_LIST_LIST_API
export const TASK_CHECK_LIST_LIST_API = "/taskchecklist/list";
//CHECK_LIST_PDF_SHEET_DEBUG_API
export const CHECK_LIST_PDF_SHEET_DEBUG_API = "/taskchecklist/pdfsheet/debug";
//CREATE_CHECK_LIST_TEMPLATE_API
export const CREATE_CHECK_LIST_TEMPLATE_API = "/taskchecklisttemplate/create";
//UPDATE_CHECK_LIST_TEMPLATE_API
export const UPDATE_CHECK_LIST_TEMPLATE_API = "/taskchecklisttemplate/update";
//CLONE_CHECK_LIST_TEMPLATE_API
export const CLONE_CHECK_LIST_TEMPLATE_API = "/taskchecklisttemplate/clone";
//CHECK_LIST_TEMPLATE_DATATYPE_LIST_API
export const CHECK_LIST_TEMPLATE_DATATYPE_LIST_API =
  "/taskchecklisttemplate/datatype/list";
//CHECK_LIST_TEMPLATE_SYSTEMFIELD_LIST_API
export const CHECK_LIST_TEMPLATE_SYSTEMFIELD_LIST_API =
  "/taskchecklisttemplate/systemfield/list";
//CHECK_LIST_TEMPLATE_PDFTHEME_LIST_API
export const CHECK_LIST_TEMPLATE_PDFTHEME_LIST_API =
  "/taskchecklisttemplate/pdftheme/list";
//************  API Calls ************//
//LIST_VEHICLES_API
export const LIST_VEHICLES_API = "/vehicle/list";
//CREATE_VEHICLE_API
export const CREATE_VEHICLE_API = "/vehicle/create";
//DELETE_VEHICLE_API
export const DELETE_VEHICLE_API = "/vehicle/delete";
//UPDATE_VEHICLE_API
export const UPDATE_VEHICLE_API = "/vehicle/update";
//GET_VEHICLE_DETAILS_API
export const GET_VEHICLE_DETAILS_API = "/vehicle/data";
//LIST_VEHICLE_STATUS_API
export const LIST_VEHICLE_STATUS_API = "/vehiclestatus/list";
//CREATE_VEHICLE_STATUS_API
export const CREATE_VEHICLE_STATUS_API = "/vehiclestatus/create";
//UPDATE_VEHICLE_STATUS_API
export const UPDATE_VEHICLE_STATUS_API = "/vehiclestatus/update";
//DELETE_VEHICLE_STATUS_API
export const DELETE_VEHICLE_STATUS_API = "/vehiclestatus/delete";
//LIST_VEHICLE_TYPE_API
export const LIST_VEHICLE_TYPE_API = "/vehicletype/list";
//CREATE_VEHICLE_TYPE_API
export const CREATE_VEHICLE_TYPE_API = "/vehicletype/create";
//UPDATE_VEHICLE_TYPE_API
export const UPDATE_VEHICLE_TYPE_API = "/vehicletype/update";
//DELETE_VEHICLE_TYPE_API
export const DELETE_VEHICLE_TYPE_API = "/vehicletype/delete";
//LIST_VEHICLE_RECENT_ACTIVITY_API
export const LIST_VEHICLE_RECENT_ACTIVITY_API = "/vehiclerecentactivity/list";
//SEARCH_VEHICLE_API
export const SEARCH_VEHICLE_API = "/vehicle/search";

//CompanyVehicle (fleet)
export const LIST_COMPANY_VEHICLES_API = "/companyvehicle/list";
export const GET_COMPANY_VEHICLE_DETAILS_API = "/companyvehicle/data";
export const CREATE_COMPANY_VEHICLE_API = "/companyvehicle/create";
export const UPDATE_COMPANY_VEHICLE_API = "/companyvehicle/update";
export const DELETE_COMPANY_VEHICLE_API = "/companyvehicle/delete";
export const SEARCH_COMPANY_VEHICLE_API = "/companyvehicle/search";
export const DVLA_LOOKUP_COMPANY_VEHICLE_API = "/companyvehicle/dvlalookup"; // Change #100720
//CompanyVehicleStatus
export const LIST_COMPANY_VEHICLE_STATUS_API = "/companyvehiclestatus/list";
export const CREATE_COMPANY_VEHICLE_STATUS_API = "/companyvehiclestatus/create";
export const UPDATE_COMPANY_VEHICLE_STATUS_API = "/companyvehiclestatus/update";
export const DELETE_COMPANY_VEHICLE_STATUS_API = "/companyvehiclestatus/delete";
//CompanyVehicleType
export const LIST_COMPANY_VEHICLE_TYPE_API = "/companyvehicletype/list";
export const CREATE_COMPANY_VEHICLE_TYPE_API = "/companyvehicletype/create";
export const UPDATE_COMPANY_VEHICLE_TYPE_API = "/companyvehicletype/update";
export const DELETE_COMPANY_VEHICLE_TYPE_API = "/companyvehicletype/delete";
//CompanyVehicleCheckType
export const LIST_COMPANY_VEHICLE_CHECK_TYPE_API =
  "/companyvehiclechecktype/list";
export const CREATE_COMPANY_VEHICLE_CHECK_TYPE_API =
  "/companyvehiclechecktype/create";
export const UPDATE_COMPANY_VEHICLE_CHECK_TYPE_API =
  "/companyvehiclechecktype/update";
export const DELETE_COMPANY_VEHICLE_CHECK_TYPE_API =
  "/companyvehiclechecktype/delete";
//CompanyVehicleCheckSchedule - Change #100679 (named check schedules)
export const LIST_COMPANY_VEHICLE_CHECK_SCHEDULE_API =
  "/companyvehiclecheckschedule/list";
export const CREATE_COMPANY_VEHICLE_CHECK_SCHEDULE_API =
  "/companyvehiclecheckschedule/create";
export const UPDATE_COMPANY_VEHICLE_CHECK_SCHEDULE_API =
  "/companyvehiclecheckschedule/update";
export const DELETE_COMPANY_VEHICLE_CHECK_SCHEDULE_API =
  "/companyvehiclecheckschedule/delete";
//CompanyVehicleCheck (scoped by vehicle)
export const LIST_COMPANY_VEHICLE_CHECK_API = "/companyvehiclecheck/list";
export const CREATE_COMPANY_VEHICLE_CHECK_API = "/companyvehiclecheck/create";
export const UPDATE_COMPANY_VEHICLE_CHECK_API = "/companyvehiclecheck/update";
export const DELETE_COMPANY_VEHICLE_CHECK_API = "/companyvehiclecheck/delete";
//CompanyVehicleToStaff (assignment / custody log)
export const LIST_COMPANY_VEHICLE_TO_STAFF_API = "/companyvehicletostaff/list";
export const CREATE_COMPANY_VEHICLE_TO_STAFF_API =
  "/companyvehicletostaff/create";
export const UPDATE_COMPANY_VEHICLE_TO_STAFF_API =
  "/companyvehicletostaff/update";
export const DELETE_COMPANY_VEHICLE_TO_STAFF_API =
  "/companyvehicletostaff/delete";
export const SEARCH_COMPANY_VEHICLE_TO_STAFF_API =
  "/companyvehicletostaff/search";
export const CHECKOUT_COMPANY_VEHICLE_API = "/companyvehicletostaff/checkout";
export const CHECKIN_COMPANY_VEHICLE_API = "/companyvehicletostaff/checkin";
//CompanyVehicleNote (scoped by vehicle)
export const LIST_COMPANY_VEHICLE_NOTE_API = "/companyvehiclenote/list";
export const CREATE_COMPANY_VEHICLE_NOTE_API = "/companyvehiclenote/create";
export const UPDATE_COMPANY_VEHICLE_NOTE_API = "/companyvehiclenote/update";
export const DELETE_COMPANY_VEHICLE_NOTE_API = "/companyvehiclenote/delete";
//CompanyVehicleRecentActivity
export const LIST_COMPANY_VEHICLE_RECENT_ACTIVITY_API =
  "/companyvehiclerecentactivity/list";
//CompanyVehicleAttachment (scoped by vehicle)
export const SEARCH_COMPANY_VEHICLE_ATTACHMENT_API =
  "/companyvehicleattachment/search";
export const DELETE_COMPANY_VEHICLE_ATTACHMENT_API =
  "/companyvehicleattachment/delete";
//BankAccountAttachment (general documents, scoped by bank account)
export const SEARCH_BANK_ACCOUNT_ATTACHMENT_API =
  "/bankaccountattachment/search";
export const DELETE_BANK_ACCOUNT_ATTACHMENT_API =
  "/bankaccountattachment/delete";
//BankAccountStatement (bank statements with a period, scoped by bank account)
export const SEARCH_BANK_ACCOUNT_STATEMENT_API =
  "/bankaccountstatement/search";
export const DELETE_BANK_ACCOUNT_STATEMENT_API =
  "/bankaccountstatement/delete";
//CompanyVehicleGpsTracker (scoped by vehicle)
export const LIST_COMPANY_VEHICLE_GPS_TRACKER_API =
  "/companyvehiclegpstracker/list";
export const CREATE_COMPANY_VEHICLE_GPS_TRACKER_API =
  "/companyvehiclegpstracker/create";
export const UPDATE_COMPANY_VEHICLE_GPS_TRACKER_API =
  "/companyvehiclegpstracker/update";
export const DELETE_COMPANY_VEHICLE_GPS_TRACKER_API =
  "/companyvehiclegpstracker/delete";
// Change #100680 - every tracked vehicle's last position (fleet map).
export const COMPANY_VEHICLE_MAP_API = "/companyvehiclegpstracker/map";
export const COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_API =
  "/companyvehiclegpstracker/providerdevices";
export const REFRESH_COMPANY_VEHICLE_GPS_TRACKER_API =
  "/companyvehiclegpstracker/refresh";

//PdfTemplate (PDF designer)
export const LIST_PDF_TEMPLATE_API = "/pdftemplate/list";
export const GET_PDF_TEMPLATE_DATA_API = "/pdftemplate/data";
export const RENDER_PDF_TEMPLATE_API = "/pdftemplate/render";
export const SAVE_PDF_TEMPLATE_API = "/pdftemplate/save";
export const DELETE_PDF_TEMPLATE_API = "/pdftemplate/delete";
export const DUPLICATE_PDF_TEMPLATE_API = "/pdftemplate/duplicate";
export const UPLOAD_SOURCE_PDF_TEMPLATE_API = "/pdftemplate/uploadsource";
export const UPLOAD_IMAGE_PDF_TEMPLATE_API = "/pdftemplate/uploadimage";
export const PREVIEW_PDF_TEMPLATE_API = "/pdftemplate/preview";
// Change #100700 - Build with AI: a PDF or image in, a draft layout out
export const AI_BUILD_PDF_TEMPLATE_API = "/pdftemplate/aibuild";
//PdfTemplateToCommunication (assign design to a communication action)
export const LIST_PDF_TEMPLATE_TO_COMMUNICATION_API =
  "/pdftemplatetocommunication/list";
export const GET_PDF_TEMPLATE_TO_COMMUNICATION_DATA_API =
  "/pdftemplatetocommunication/data";
export const CREATE_PDF_TEMPLATE_TO_COMMUNICATION_API =
  "/pdftemplatetocommunication/create";
export const UPDATE_PDF_TEMPLATE_TO_COMMUNICATION_API =
  "/pdftemplatetocommunication/update";
export const DELETE_PDF_TEMPLATE_TO_COMMUNICATION_API =
  "/pdftemplatetocommunication/delete";

//ESign (e-signing envelopes)
export const LIST_ESIGN_API = "/esign/list";
export const GET_ESIGN_DATA_API = "/esign/data";
export const CREATE_ESIGN_API = "/esign/create";
export const UPDATE_ESIGN_API = "/esign/update";
export const UPLOAD_ESIGN_DOCUMENT_API = "/esign/document/upload";
export const SEND_ESIGN_API = "/esign/send";
export const VOID_ESIGN_API = "/esign/void";
export const DOWNLOAD_ESIGN_API = "/esign/download";
export const DELETE_ESIGN_API = "/esign/delete";

//Form Builder (branded forms + submissions)
export const LIST_FORM_API = "/form/list";
export const RENDER_FORM_API = "/form/render";
export const SAVE_FORM_API = "/form/save";
// AI FORM BUILD FROM A DOCUMENT (Task 24609)
export const AI_BUILD_FORM_API = "/form/aibuild";
// Task 24698 - page-by-page build. prepare counts the pages and takes the single
// wallet charge; page is then called once per page, in parallel.
export const AI_BUILD_FORM_PREPARE_API = "/form/aibuildprepare";
export const AI_BUILD_FORM_PAGE_API = "/form/aibuildpage";

// Task 24825 - read an uploaded menu document into a proposal, then build it.
// Task 24834 - the staff responsible for a vehicle (not the driver).
export const COMPANY_VEHICLE_MANAGER_LIST_API = "/companyvehicletostaffmanager/list";
export const COMPANY_VEHICLE_MANAGER_CREATE_API = "/companyvehicletostaffmanager/create";
export const COMPANY_VEHICLE_MANAGER_DELETE_API = "/companyvehicletostaffmanager/delete";

export const AI_PROPOSE_FOODMENU_API = "/foodmenu/aipropose";
export const AI_CONFIRM_FOODMENU_API = "/foodmenu/aiconfirm";
export const PUBLISH_FORM_API = "/form/publish";
export const UNPUBLISH_FORM_API = "/form/unpublish";
// Task 24888 - move a form onto one of the company's named statuses. A tiny
// endpoint rather than form/save, which takes the whole form and every child
// list with it.
export const SET_STATUS_FORM_API = "/form/setstatus";
export const LIST_FORM_STATUS_API = "/formstatus/list";
export const CREATE_FORM_STATUS_API = "/formstatus/create";
export const UPDATE_FORM_STATUS_API = "/formstatus/update";
export const DELETE_FORM_STATUS_API = "/formstatus/delete";
export const DUPLICATE_FORM_API = "/form/duplicate";
// Change #100305 - move a form between companies as a JSON file.
export const EXPORT_FORM_API = "/form/export";
export const IMPORT_FORM_API = "/form/import";
export const DELETE_FORM_API = "/form/delete";
export const SUBMISSIONS_FORM_API = "/form/submissions";
export const SUBMISSION_DATA_FORM_API = "/form/submission/data";
export const SUBMIT_FORM_INTERNAL_API = "/form/submit";
// Task 24847 - internal (staff) file upload, mirror of the public upload. Id in
// the URL via FetchAPI's id-append, same as SUBMIT_FORM_INTERNAL_API.
export const UPLOAD_FORM_INTERNAL_API = "/form/upload";
export const ESIGN_READINESS_FORM_API = "/form/esign-readiness";
// Task 24899 - what a form field can be prefilled from (names, not data).
export const PREFILL_SOURCES_FORM_API = "/form/prefillsources";
// Task 24907 - every email and SMS sent for one table booking.
export const RESERVATION_COMMUNICATIONS_API = "/foodtablereservation/communications";
// Change #100611 - resend a booking's payment request (deposit) email.
export const PAYMENT_REQUEST_RESEND_EMAIL_API = "/paymentrequest/resendemail";
// Change #100541 - Settings > Email > Sent Emails. The admin pair is the Back
// End mirror (developer only), with the company id in the URL.
export const SENT_EMAILS_SEARCH_API = "/emailoutbound/search";
export const SENT_EMAILS_DETAIL_API = "/emailoutbound/detail";
export const SENT_EMAILS_ADMIN_SEARCH_API = "/emailoutbound/admin/search";
export const SENT_EMAILS_ADMIN_DETAIL_API = "/emailoutbound/admin/detail";
export const SENT_EMAILS_RESEND_API = "/emailoutbound/resend"; // Change #100765
export const SENT_EMAILS_ADMIN_RESEND_API = "/emailoutbound/admin/resend"; // Change #100765

// Task 24903 - forms at customer level. The assignment list, plus the
// submissions already recorded against the customer (which needed no schema).
export const CUSTOMER_TO_FORM_LIST_API = "/customertoform/list";
export const CUSTOMER_TO_FORM_SUBMISSIONS_API = "/customertoform/submissions";
export const CUSTOMER_TO_FORM_CREATE_API = "/customertoform/create";
export const CUSTOMER_TO_FORM_UPDATE_API = "/customertoform/update";
export const CUSTOMER_TO_FORM_DELETE_API = "/customertoform/delete";
// The customer's own copy, reached by the assignment's IdExternal.
export const ASSIGNMENT_RENDER_FORM_API = "/form/assignment/render";
export const ASSIGNMENT_SUBMIT_FORM_API = "/form/assignment/submit";

// Task 24895 - forms assigned to a task. The assignment exists before any
// submission does, which is what makes "still outstanding on this job"
// answerable at all.
export const TASK_TO_FORM_LIST_API = "/tasktoform/list";
export const TASK_TO_FORM_JOB_LIST_API = "/tasktoform/joblist";
export const TASK_TO_FORM_DATA_API = "/tasktoform/data";
export const TASK_TO_FORM_CREATE_API = "/tasktoform/create";
export const TASK_TO_FORM_UPDATE_API = "/tasktoform/update";
export const TASK_TO_FORM_DELETE_API = "/tasktoform/delete";

// Asset
export const ASSET_LIST_API = "/asset/list";
export const ASSET_DATA_API = "/asset/data";
export const ASSET_CREATE_API = "/asset/create";
export const ASSET_UPDATE_API = "/asset/update";
export const ASSET_DELETE_API = "/asset/delete";
// Task 24439 - bulk set group / type / status across many assets
export const ASSET_BULK_ASSIGN_API = "/asset/bulkassign";

// CompanySiteLocation — the company's own premises (Task 24472)
export const COMPANY_SITE_LOCATION_LIST_API = "/companysitelocation/list";
export const COMPANY_SITE_LOCATION_DATA_API = "/companysitelocation/data";
export const COMPANY_SITE_LOCATION_CREATE_API = "/companysitelocation/create";
export const COMPANY_SITE_LOCATION_UPDATE_API = "/companysitelocation/update";
export const COMPANY_SITE_LOCATION_DELETE_API = "/companysitelocation/delete";

// SLAs (Tasks 24474 / 24469)
export const SLA_PROFILE_LIST_API = "/slaprofile/list";
export const SLA_PROFILE_DATA_API = "/slaprofile/data";
export const SLA_PROFILE_CREATE_API = "/slaprofile/create";
export const SLA_PROFILE_UPDATE_API = "/slaprofile/update";
export const SLA_PROFILE_DELETE_API = "/slaprofile/delete";
export const SLA_METRIC_CREATE_API = "/slametric/create";
export const SLA_METRIC_UPDATE_API = "/slametric/update";
export const SLA_METRIC_DELETE_API = "/slametric/delete";
export const CUSTOMER_SLA_LIST_API = "/customersla/list";
export const CUSTOMER_SLA_ACTIVE_API = "/customersla/active";
export const CUSTOMER_SLA_ASSIGN_API = "/customersla/assign";
export const CUSTOMER_SLA_DELETE_API = "/customersla/delete";

// StaffContact / StaffContactType (Task 24467)
export const STAFF_CONTACT_TYPE_LIST_API = "/staffcontacttype/list";
export const STAFF_CONTACT_TYPE_CREATE_API = "/staffcontacttype/create";
export const STAFF_CONTACT_TYPE_UPDATE_API = "/staffcontacttype/update";
export const STAFF_CONTACT_TYPE_DELETE_API = "/staffcontacttype/delete";
export const STAFF_CONTACT_LIST_API = "/staffcontact/list";
export const STAFF_CONTACT_CREATE_API = "/staffcontact/create";
export const STAFF_CONTACT_UPDATE_API = "/staffcontact/update";
export const STAFF_CONTACT_DELETE_API = "/staffcontact/delete";

//******************** Staff addresses over time (Task 24860)
export const STAFF_ADDRESS_TYPE_LIST_API = "/staffaddresstype/list";
export const STAFF_ADDRESS_TYPE_CREATE_API = "/staffaddresstype/create";
export const STAFF_ADDRESS_TYPE_UPDATE_API = "/staffaddresstype/update";
export const STAFF_ADDRESS_TYPE_DELETE_API = "/staffaddresstype/delete";
export const STAFF_ADDRESS_LIST_API = "/staffaddress/list";
export const STAFF_ADDRESS_SEARCH_API = "/staffaddress/search";
export const STAFF_ADDRESS_CREATE_API = "/staffaddress/create";
export const STAFF_ADDRESS_UPDATE_API = "/staffaddress/update";
export const STAFF_ADDRESS_DELETE_API = "/staffaddress/delete";

// AssetNote (Task 24447)
export const ASSET_NOTE_LIST_API = "/assetnote/list";
export const ASSET_NOTE_CREATE_API = "/assetnote/create";
export const ASSET_NOTE_UPDATE_API = "/assetnote/update";
export const ASSET_NOTE_DELETE_API = "/assetnote/delete";

// AssetAttachment (Task 24446) - upload goes through /fileattachment
export const ASSET_ATTACHMENT_SEARCH_API = "/assetattachment/search";
export const ASSET_ATTACHMENT_DELETE_API = "/assetattachment/delete";

// Asset recent activity + field service linkage (Tasks 24446/24447/24449)
export const ASSET_RECENT_ACTIVITY_LIST_API = "/assetrecentactivity/list";
export const ASSET_DIARY_SLOT_LIST_API = "/diaryslotasset/list/asset";

// AssetToStaff (assignment / custody log — date-range assignment to a person)
export const LIST_ASSET_TO_STAFF_API = "/assettostaff/list";
export const CREATE_ASSET_TO_STAFF_API = "/assettostaff/create";
export const UPDATE_ASSET_TO_STAFF_API = "/assettostaff/update";
export const DELETE_ASSET_TO_STAFF_API = "/assettostaff/delete";
export const SEARCH_ASSET_TO_STAFF_API = "/assettostaff/search";
export const CHECKOUT_ASSET_API = "/assettostaff/checkout";
export const CHECKIN_ASSET_API = "/assettostaff/checkin";

// Change #100392 - asset custody chain (storage location > person > job > person > storage)
export const ASSET_MOVEMENT_LIST_API = "/assetmovement/list";
export const ASSET_MOVEMENT_LIST_JOB_API = "/assetmovement/list/job";
export const ASSET_MOVEMENT_MOVE_API = "/assetmovement/move";
export const ASSET_MOVEMENT_MINE_API = "/assetmovement/mine"; // Change #100645
export const COMPANY_VEHICLE_MINE_API = "/companyvehicle/mine"; // Change #100670
export const ASSET_MOVEMENT_RELOCATE_API = "/assetmovement/relocate"; // Change #100644

// Asset Group (pool of fungible assets)
export const ASSET_GROUP_LIST_API = "/assetgroup/list";
export const ASSET_GROUP_DATA_API = "/assetgroup/data";
export const ASSET_GROUP_CREATE_API = "/assetgroup/create";
export const ASSET_GROUP_UPDATE_API = "/assetgroup/update";
export const ASSET_GROUP_DELETE_API = "/assetgroup/delete";

// Dispatch boards / diaries (configurable field-service dispatch)
export const DISPATCH_BOARD_LIST_API = "/dispatchboard/list";
export const DISPATCH_BOARD_DATA_API = "/dispatchboard/data";
export const DISPATCH_BOARD_CREATE_API = "/dispatchboard/create";
export const DISPATCH_BOARD_UPDATE_API = "/dispatchboard/update";
export const DISPATCH_BOARD_DELETE_API = "/dispatchboard/delete";

// Asset Type
export const ASSET_TYPE_LIST_API = "/assettype/list";
export const ASSET_TYPE_DATA_API = "/assettype/data";
export const ASSET_TYPE_CREATE_API = "/assettype/create";
export const ASSET_TYPE_UPDATE_API = "/assettype/update";
export const ASSET_TYPE_DELETE_API = "/assettype/delete";

// Asset Status
export const ASSET_STATUS_LIST_API = "/assetstatus/list";
export const ASSET_STATUS_DATA_API = "/assetstatus/data";
export const ASSET_STATUS_CREATE_API = "/assetstatus/create";
export const ASSET_STATUS_UPDATE_API = "/assetstatus/update";
export const ASSET_STATUS_DELETE_API = "/assetstatus/delete";

// Company Storage Location
export const COMPANY_STORAGE_LOCATION_LIST_API = "/companystoragelocation/list";
export const COMPANY_STORAGE_LOCATION_DATA_API = "/companystoragelocation/data";
export const COMPANY_STORAGE_LOCATION_CREATE_API =
  "/companystoragelocation/create";
export const COMPANY_STORAGE_LOCATION_UPDATE_API =
  "/companystoragelocation/update";
export const COMPANY_STORAGE_LOCATION_DELETE_API =
  "/companystoragelocation/delete";

//************  API Calls ************//
//GPS
//SEND_MY_CURRENT_LOCATION_API
export const SEND_MY_CURRENT_LOCATION_API = "/staff/update";
//************  API Calls ************//

// GET_MASTER_COMPANY_USAGE_STATS_API
export const GET_MASTER_COMPANY_USAGE_STATS_API =
  "/mastercompanyusagestats/list";
//GET_MASTER_COMPANY_USAGE_STATS_BY_ID_API
export const GET_MASTER_COMPANY_USAGE_STATS_BY_ID_API =
  "/mastercompanyusagestats/data/";
//GET_COMPANY_LIST_API
export const GET_COMPANY_LIST_API = "/company/list";
//GET_COMPANY_BY_ID_API
export const GET_COMPANY_BY_ID_API = "/company/data/";
//GET_COMPANY_RECENT_ACTIVITY_LIST_API
export const GET_COMPANY_RECENT_ACTIVITY_LIST_API =
  "/companyrecentactivity/list/company";
//MASTER_INVOICE_SEARCH_API
export const MASTER_INVOICE_SEARCH_API = "/masterinvoice/search";
//MASTER_INVOICE_PDF_API
export const MASTER_INVOICE_PDF_API = "/masterinvoice/pdf";
//MASTER_SYSTEM_ERROR_LOG_LIST_API
export const MASTER_SYSTEM_ERROR_LOG_LIST_API = "/mastersystemerrorlog/list";
//MASTER_SYSTEM_ERROR_LOG_DATA_API
export const MASTER_SYSTEM_ERROR_LOG_DATA_API = "/mastersystemerrorlog/data";
//MASTER_SYSTEM_ERROR_LOG_SEARCH_API
export const MASTER_SYSTEM_ERROR_LOG_SEARCH_API =
  "/mastersystemerrorlog/search";
//MASTER_USER_LIST_API
export const MASTER_USER_LIST_API = "/masteruser/list";
//MASTER_RECENT_ACTIVITY_LIST_API
export const MASTER_RECENT_ACTIVITY_LIST_API =
  "/masterrecentactivity/list/user";
//************  API Calls ************//

//COMPANIES_HOUSE_GOV_UK_SEARCH_COMPANIES_API
export const COMPANIES_HOUSE_GOV_UK_SEARCH_COMPANIES_API =
  "/extcompanieshouse/search/company";
//COMPANIES_HOUSE_GOV_UK_GET_FILING_HISTORY_API
export const COMPANIES_HOUSE_GOV_UK_GET_FILING_HISTORY_API =
  "/extcompanieshouse/company/filinghistory/list";
//COMPANIES_HOUSE_GOV_UK_GET_OFFICERS_API
export const COMPANIES_HOUSE_GOV_UK_GET_OFFICERS_API =
  "/customer/locate/searchbusiness";
//FOOD_PRE_ORDER_EVENT_SMS_ORGANISER_EVENT_READY_API
export const FOOD_PRE_ORDER_EVENT_SMS_ORGANISER_EVENT_READY_API =
  "/foodpreorderevent/sms/organiser/eventready";
//FOOD_MENU_ITEM_SEARCH_API
export const FOOD_MENU_ITEM_SEARCH_API = "/foodmenu/search";
//FOOD_PRE_ORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_API =
  "/foodpreorderevent/pdf/frontofhousemealplan";
//FOOD_PRE_ORDER_EVENT_GUEST_PAYMENT_LIST_API
export const FOOD_PRE_ORDER_EVENT_GUEST_PAYMENT_LIST_API =
  "/foodpreordereventguestpayment/list";
//FOOD_PRE_ORDER_EVENT_GUEST_PAYMENT_SEARCH_API
export const FOOD_PRE_ORDER_EVENT_GUEST_PAYMENT_SEARCH_API =
  "/foodpreordereventguestpayment/search";
//FOOD_PRE_ORDER_EVENT_GROUP_LIST_API
export const FOOD_PRE_ORDER_EVENT_GROUP_LIST_API =
  "/foodpreordereventgroup/list";
//FOOD_PRE_ORDER_EVENT_GROUP_DATA_API
export const FOOD_PRE_ORDER_EVENT_GROUP_DATA_API =
  "/foodpreordereventgroup/data";
//FOOD_PRE_ORDER_EVENT_GROUP_CREATE_API
export const FOOD_PRE_ORDER_EVENT_GROUP_CREATE_API =
  "/foodpreordereventgroup/create";
//FOOD_PRE_ORDER_EVENT_GROUP_UPDATE_API
export const FOOD_PRE_ORDER_EVENT_GROUP_UPDATE_API =
  "/foodpreordereventgroup/update";
//FOOD_PRE_ORDER_EVENT_GROUP_DELETE_API
export const FOOD_PRE_ORDER_EVENT_GROUP_DELETE_API =
  "/foodpreordereventgroup/delete";
//FOOD_PRE_ORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_API
export const FOOD_PRE_ORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_API =
  "/foodpreordereventrecentactivity/list";
//FOOD_PRE_ORDER_EVENT_COMMUNICATION_LIST_API
export const FOOD_PRE_ORDER_EVENT_COMMUNICATION_LIST_API =
  "/foodpreordereventcommunication/list";
//FoodPreOrderEventAttachment (scoped by pre-order event)
export const FOOD_PRE_ORDER_EVENT_ATTACHMENT_SEARCH_API =
  "/foodpreordereventattachment/search";
export const FOOD_PRE_ORDER_EVENT_ATTACHMENT_DELETE_API =
  "/foodpreordereventattachment/delete";
//FOOD_PRE_ORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_API =
  "/foodpreordereventgroup/pdf/kitchenmealplan";
//FOOD_PRE_ORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_API =
  "/foodpreordereventgroup/pdf/frontofhousemealplan";
//FOOD_PRE_ORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_API
export const FOOD_PRE_ORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_API =
  "/foodpreordereventgroup/pdf/tabletentcards";
//FOOD_PRE_ORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_API
export const FOOD_PRE_ORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_API =
  "/foodpreordereventgroup/pdf/guestlist/confirmed";
//FOOD_PRE_ORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_API
export const FOOD_PRE_ORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_API =
  "/foodpreordereventgroup/pdf/tableplan/list";
//FOOD_PRE_ORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_API =
  "/foodpreordereventgroup/csv/kitchenmealplan";
//FOOD_PRE_ORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_API =
  "/foodpreordereventgroup/csv/frontofhousemealplan";
//FOOD_PRE_ORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_API
export const FOOD_PRE_ORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_API =
  "/foodpreordereventgroup/csv/guestlist/confirmed";
//FOOD_PRE_ORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_API
export const FOOD_PRE_ORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_API =
  "/foodpreordereventgroup/csv/tableplan/list";
//FOOD_PRE_ORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_API =
  "/foodpreorderevent/csv/kitchenmealplan";
//FOOD_PRE_ORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_API =
  "/foodpreorderevent/csv/frontofhousemealplan";
//FOOD_PRE_ORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_API
export const FOOD_PRE_ORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_API =
  "/foodpreorderevent/csv/guestlist/confirmed";
//FOOD_PRE_ORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_API
export const FOOD_PRE_ORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_API =
  "/foodpreordereventgroup/csv/drinklistbytable";
//FOOD_PRE_ORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_API
export const FOOD_PRE_ORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_API =
  "/foodpreordereventgroup/pdf/drinklistbytable";
//FOOD_PRE_ORDER_SITE_LOCATION_SEARCH_API
export const FOOD_PRE_ORDER_SITE_LOCATION_SEARCH_API =
  "/foodpreordersitelocation/search";
//FOOD_MENU_CLONE_API
export const FOOD_MENU_CLONE_API = "/foodmenu/clone";
//************  API Calls ************//
//FOOD_PRE_ORDER_EVENT_LIST_API
export const FOOD_PRE_ORDER_EVENT_LIST_API = "/foodpreorderevent/list";
//FOOD_PRE_ORDER_EVENT_SEARCH_API
export const FOOD_PRE_ORDER_EVENT_SEARCH_API = "/foodpreorderevent/search";
//FOOD_PRE_ORDER_EVENT_DATA_API
export const FOOD_PRE_ORDER_EVENT_DATA_API = "/foodpreorderevent/data";
//FOOD_PRE_ORDER_EVENT_CREATE_API
export const FOOD_PRE_ORDER_EVENT_CREATE_API = "/foodpreorderevent/create";
//FOOD_PRE_ORDER_EVENT_UPDATE_API
export const FOOD_PRE_ORDER_EVENT_UPDATE_API = "/foodpreorderevent/update";
//FOOD_PRE_ORDER_EVENT_DELETE_API
export const FOOD_PRE_ORDER_EVENT_DELETE_API = "/foodpreorderevent/delete";
//FOOD_PRE_ORDER_EVENT_GUEST_LIST_API
export const FOOD_PRE_ORDER_EVENT_GUEST_LIST_API =
  "/foodpreordereventguest/list";
//FOOD_PRE_ORDER_EVENT_GUEST_SEARCH_API
export const FOOD_PRE_ORDER_EVENT_GUEST_SEARCH_API =
  "/foodpreordereventguest/search";
//FOOD_PRE_ORDER_EVENT_GUEST_DATA_API
export const FOOD_PRE_ORDER_EVENT_GUEST_DATA_API =
  "/foodpreordereventguest/data";
//FOOD_PRE_ORDER_EVENT_GUEST_INVITE_API
export const FOOD_PRE_ORDER_EVENT_GUEST_INVITE_API =
  "/foodpreordereventguest/invite";
//FOOD_PRE_ORDER_EVENT_GUEST_DELETE_API
export const FOOD_PRE_ORDER_EVENT_GUEST_DELETE_API =
  "/foodpreordereventguest/delete";
//FOOD_MENU_STATUS_LIST_API
export const FOOD_MENU_STATUS_LIST_API = "/foodmenustatus/list";
//FOOD_MENU_STATUS_DATA_API
export const FOOD_MENU_STATUS_DATA_API = "/foodmenustatus/data";
//FOOD_MENU_STATUS_CREATE_API
export const FOOD_MENU_STATUS_CREATE_API = "/foodmenustatus/create";
//FOOD_MENU_STATUS_UPDATE_API
export const FOOD_MENU_STATUS_UPDATE_API = "/foodmenustatus/update";
//FOOD_MENU_STATUS_DELETE_API
export const FOOD_MENU_STATUS_DELETE_API = "/foodmenustatus/delete";
//FOOD_MENU_LIST_API
export const FOOD_MENU_LIST_API = "/foodmenu/list";
//FOOD_MENU_DATA_API
export const FOOD_MENU_DATA_API = "/foodmenu/data";
//FOOD_MENU_CREATE_API
export const FOOD_MENU_CREATE_API = "/foodmenu/create";
//FOOD_MENU_UPDATE_API
export const FOOD_MENU_UPDATE_API = "/foodmenu/update";
//FOOD_MENU_DELETE_API
export const FOOD_MENU_DELETE_API = "/foodmenu/delete";
//FOOD_MENU_ITEM_LIST_API
export const FOOD_MENU_ITEM_LIST_API = "/foodmenuitem/list";
//FOOD_MENU_ITEM_DATA_API
export const FOOD_MENU_ITEM_DATA_API = "/foodmenuitem/data";
//FOOD_MENU_ITEM_CREATE_API
export const FOOD_MENU_ITEM_CREATE_API = "/foodmenuitem/create";
//FOOD_MENU_ITEM_UPDATE_API
export const FOOD_MENU_ITEM_UPDATE_API = "/foodmenuitem/update";
//FOOD_MENU_ITEM_DELETE_API
export const FOOD_MENU_ITEM_DELETE_API = "/foodmenuitem/delete";
//FOOD_MENU_CATEGORY_LIST_API
export const FOOD_MENU_CATEGORY_LIST_API = "/foodmenucategory/list";
//FOOD_MENU_CATEGORY_DATA_API
export const FOOD_MENU_CATEGORY_DATA_API = "/foodmenucategory/data";
//FOOD_MENU_CATEGORY_CREATE_API
export const FOOD_MENU_CATEGORY_CREATE_API = "/foodmenucategory/create";
//FOOD_MENU_CATEGORY_UPDATE_API
export const FOOD_MENU_CATEGORY_UPDATE_API = "/foodmenucategory/update";
//FOOD_MENU_CATEGORY_DELETE_API
export const FOOD_MENU_CATEGORY_DELETE_API = "/foodmenucategory/delete";
//FOOD_PRE_ORDER_EVENT_STATUS_LIST_API
export const FOOD_PRE_ORDER_EVENT_STATUS_LIST_API =
  "/foodpreordereventstatus/list";
//FOOD_PRE_ORDER_EVENT_STATUS_DATA_API
export const FOOD_PRE_ORDER_EVENT_STATUS_DATA_API =
  "/foodpreordereventstatus/data";
//FOOD_PRE_ORDER_EVENT_STATUS_CREATE_API
export const FOOD_PRE_ORDER_EVENT_STATUS_CREATE_API =
  "/foodpreordereventstatus/create";
//FOOD_PRE_ORDER_EVENT_STATUS_UPDATE_API
export const FOOD_PRE_ORDER_EVENT_STATUS_UPDATE_API =
  "/foodpreordereventstatus/update";
//FOOD_PRE_ORDER_EVENT_STATUS_DELETE_API
export const FOOD_PRE_ORDER_EVENT_STATUS_DELETE_API =
  "/foodpreordereventstatus/delete";
//FOOD_PRE_ORDER_EVENT_TYPE_LIST_API
export const FOOD_PRE_ORDER_EVENT_TYPE_LIST_API = "/foodpreordereventtype/list";
//FOOD_PRE_ORDER_EVENT_TYPE_DATA_API
export const FOOD_PRE_ORDER_EVENT_TYPE_DATA_API = "/foodpreordereventtype/data";
//FOOD_PRE_ORDER_EVENT_TYPE_CREATE_API
export const FOOD_PRE_ORDER_EVENT_TYPE_CREATE_API =
  "/foodpreordereventtype/create";
//FOOD_PRE_ORDER_EVENT_TYPE_UPDATE_API
export const FOOD_PRE_ORDER_EVENT_TYPE_UPDATE_API =
  "/foodpreordereventtype/update";
//FOOD_PRE_ORDER_EVENT_TYPE_DELETE_API
export const FOOD_PRE_ORDER_EVENT_TYPE_DELETE_API =
  "/foodpreordereventtype/delete";
//FOOD_MENU_TYPE_LIST_API
export const FOOD_MENU_TYPE_LIST_API = "/foodmenutype/list";
//FOOD_MENU_TYPE_DATA_API
export const FOOD_MENU_TYPE_DATA_API = "/foodmenutype/data";
//FOOD_MENU_TYPE_CREATE_API
export const FOOD_MENU_TYPE_CREATE_API = "/foodmenutype/create";
//FOOD_MENU_TYPE_UPDATE_API
export const FOOD_MENU_TYPE_UPDATE_API = "/foodmenutype/update";
//FOOD_MENU_TYPE_DELETE_API
export const FOOD_MENU_TYPE_DELETE_API = "/foodmenutype/delete";
//FOOD_PRE_ORDER_SITE_LOCATION_LIST_API
export const FOOD_PRE_ORDER_SITE_LOCATION_LIST_API =
  "/foodpreordersitelocation/list";
//FOOD_PRE_ORDER_SITE_LOCATION_DATA_API
export const FOOD_PRE_ORDER_SITE_LOCATION_DATA_API =
  "/foodpreordersitelocation/data";
//FOOD_PRE_ORDER_SITE_LOCATION_CREATE_API
export const FOOD_PRE_ORDER_SITE_LOCATION_CREATE_API =
  "/foodpreordersitelocation/create";
//FOOD_PRE_ORDER_SITE_LOCATION_UPDATE_API
export const FOOD_PRE_ORDER_SITE_LOCATION_UPDATE_API =
  "/foodpreordersitelocation/update";
//FOOD_PRE_ORDER_SITE_LOCATION_DELETE_API
export const FOOD_PRE_ORDER_SITE_LOCATION_DELETE_API =
  "/foodpreordersitelocation/delete";
//FOOD_PRE_ORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_API
export const FOOD_PRE_ORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_API =
  "/foodpreordereventguesttofoodmenuitem/create";
//FOOD_PRE_ORDER_EVENT_GUEST_ACCEPT_API
export const FOOD_PRE_ORDER_EVENT_GUEST_ACCEPT_API =
  "/foodpreordereventguest/accept";
//FOOD_PRE_ORDER_EVENT_GUEST_DECLINE_API
export const FOOD_PRE_ORDER_EVENT_GUEST_DECLINE_API =
  "/foodpreordereventguest/decline";
//FOOD_MENU_SEARCH_API
export const FOOD_MENU_SEARCH_API = "/foodmenu/search";
//FOOD_PRE_ORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_API
export const FOOD_PRE_ORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_API =
  "/foodpreorderevent/email/organiser/eventready";
//FOOD_PRE_ORDER_EVENT_GUEST_INVITE_RESEND_API
export const FOOD_PRE_ORDER_EVENT_GUEST_INVITE_RESEND_API =
  "/foodpreordereventguest/invite/resend";
//FOOD_PRE_ORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_API
export const FOOD_PRE_ORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_API =
  "/foodpreorderevent/pdf/guestlist/confirmed";
//FOOD_PRE_ORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_API
export const FOOD_PRE_ORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_API =
  "/foodpreorderevent/pdf/kitchenmealplan/";
//FOOD_PRE_ORDER_EVENT_PDF_TABLE_TENT_CARDS_API
export const FOOD_PRE_ORDER_EVENT_PDF_TABLE_TENT_CARDS_API =
  "/foodpreorderevent/pdf/tabletentcards";
//FOOD_PRE_ORDER_EVENT_RECENT_ACTIVITY_LIST_API
export const FOOD_PRE_ORDER_EVENT_RECENT_ACTIVITY_LIST_API =
  "/foodpreordereventrecentactivity/list";
//************  API Calls ************//
//TIME_ENTRIES_SUMMARY_DAILY_API
export const TIME_ENTRIES_SUMMARY_DAILY_API = "/timeentry/list/summary/daily";
//************  API Calls ************//
//Appointment api calls
//APPOINTMENT_LIST_API
export const APPOINTMENT_LIST_API = "/appointment/list";
//APPOINTMENT_DATA_API
export const APPOINTMENT_DATA_API = "/appointment/data";
//APPOINTMENT_CREATE_API
export const APPOINTMENT_CREATE_API = "/appointment/create";
//APPOINTMENT_UPDATE_API
export const APPOINTMENT_UPDATE_API = "/appointment/update";
//APPOINTMENT_DELETE_API
export const APPOINTMENT_DELETE_API = "/appointment/delete";
//APPOINTMENT_SEARCH_API
export const APPOINTMENT_SEARCH_API = "/appointment/search";
//APPOINTMENT_TYPE_LIST_API
export const APPOINTMENT_TYPE_LIST_API = "/appointmenttype/list";
//APPOINTMENT_TYPE_DATA_API
export const APPOINTMENT_TYPE_DATA_API = "/appointmenttype/data";
//APPOINTMENT_TYPE_CREATE_API
export const APPOINTMENT_TYPE_CREATE_API = "/appointmenttype/create";
//APPOINTMENT_TYPE_UPDATE_API
export const APPOINTMENT_TYPE_UPDATE_API = "/appointmenttype/update";
//APPOINTMENT_TYPE_DELETE_API
export const APPOINTMENT_TYPE_DELETE_API = "/appointmenttype/delete";
//APPOINTMENT_STATUS_LIST_API
export const APPOINTMENT_STATUS_LIST_API = "/appointmentstatus/list";
//APPOINTMENT_STATUS_DATA_API
export const APPOINTMENT_STATUS_DATA_API = "/appointmentstatus/data";
//APPOINTMENT_STATUS_CREATE_API
export const APPOINTMENT_STATUS_CREATE_API = "/appointmentstatus/create";
//APPOINTMENT_STATUS_UPDATE_API
export const APPOINTMENT_STATUS_UPDATE_API = "/appointmentstatus/update";
//APPOINTMENT_STATUS_DELETE_API
export const APPOINTMENT_STATUS_DELETE_API = "/appointmentstatus/delete";
//APPOINTMENT_SEARCH_SPECIFIC_LIST_API
export const APPOINTMENT_SEARCH_SPECIFIC_LIST_API = "/appointment/search";

//DIARY_SLOT_SEARCH_API
export const DIARY_SLOT_SEARCH_API = "/diaryslot/search";

//DIARY_SLOT_UPDATE_API (Task 24646 - persisting a drag on the dispatch board)
export const DIARY_SLOT_UPDATE_API = "/diaryslot/update";

// Change #100483 - cancel an appointment from the dispatch board.
export const DIARY_SLOT_DELETE_API = "/diaryslot/delete";
export const DIARY_SLOT_UNASSIGN_ALL_API = "/diaryslot/unassign/all";

//DIARY_SLOT_ASSIGNEE_SEARCH_API
export const DIARY_SLOT_ASSIGNEE_SEARCH_API = "/diaryslotassignee/search";

//DIARY_SLOT_CHECK_AVAILABILITY_API
export const DIARY_SLOT_CHECK_AVAILABILITY_API = "/diaryslot/checkavailability";

//DIARY_SLOT_BOOK_API
export const DIARY_SLOT_BOOK_API = "/diaryslot/book";
// Change #100537 - multi-day basket, cancel one part, status per visit.
export const DIARY_SLOT_BOOK_BASKET_API = "/diaryslot/bookbasket";
// Change #100699 - how often the first option offered is the one booked
export const DIARY_SLOT_OPTION_PICK_STATS_API = "/diaryslot/optionpickstats";
// Change #100705 - drive time between appointments on the diary
export const DIARY_SLOT_TRAVEL_LEGS_API = "/diaryslot/travellegs";
export const DIARY_SLOT_CANCEL_PART_API = "/diaryslot/cancelpart";
export const DIARY_SLOT_STATUS_API = "/diaryslot/slotstatus";
// Change #100605 - internal appointment (no customer) and confirming its equipment was collected.
export const DIARY_SLOT_CREATE_INTERNAL_API = "/diaryslot/createinternal";
export const DIARY_SLOT_CONFIRM_COLLECTION_API = "/diaryslot/confirmcollection";

//************  API Calls ************//
//GET_ACQUISITION_CHANNEL_LIST_API
export const GET_ACQUISITION_CHANNEL_LIST_API =
  "/customeracquisitionchannel/list";
//GET_ACQUISITION_CHANNEL_DATA_API
export const GET_ACQUISITION_CHANNEL_DATA_API =
  "/customeracquisitionchannel/data";
//CREATE_ACQUISITION_CHANNEL_API
export const CREATE_ACQUISITION_CHANNEL_API =
  "/customeracquisitionchannel/create";
//UPDATE_ACQUISITION_CHANNEL_API
export const UPDATE_ACQUISITION_CHANNEL_API =
  "/customeracquisitionchannel/update";
//DELETE_ACQUISITION_CHANNEL_API
export const DELETE_ACQUISITION_CHANNEL_API =
  "/customeracquisitionchannel/delete";
//************  API Calls ************//
//GET_MASTER_REPORTING_ITEM_LIST_API
export const GET_MASTER_REPORTING_ITEM_LIST_API =
  "/masterreportingitem/list/grouped";
//GET_MASTER_REPORTING_ITEM_DATA_API
export const GET_MASTER_REPORTING_ITEM_DATA_API =
  "/masterreportingitemdata/report";
//************  API Calls ************//
// Master Reporting API Calls
//GET_MASTER_REPORTING_ITEMS_API
export const GET_MASTER_REPORTING_ITEMS_API =
  "/masterreportingitem/list/grouped";
//************  API Calls ************//
// Security
//GET_SECURITY_AUTH_ROLE_LIST_API
export const GET_SECURITY_AUTH_ROLE_LIST_API = "/securityauthrole/list";
//GET_SECURITY_AUTH_ROLE_BY_ID_API
export const GET_SECURITY_AUTH_ROLE_BY_ID_API = "/securityauthrole/data";
//CREATE_SECURITY_AUTH_ROLE_API
export const CREATE_SECURITY_AUTH_ROLE_API = "/securityauthrole/create";
//UPDATE_SECURITY_AUTH_ROLE_API
export const UPDATE_SECURITY_AUTH_ROLE_API = "/securityauthrole/update";
//DELETE_SECURITY_AUTH_ROLE_API
export const DELETE_SECURITY_AUTH_ROLE_API = "/securityauthrole/delete";
//GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_API
export const GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_API =
  "/mastersecurityauthcapability/list";
//GET_SECURITY_AUTH_ROLE_TO_USER_LIST_API
export const GET_SECURITY_AUTH_ROLE_TO_USER_LIST_API =
  "/securityauthroletouser/list";
//CREATE_SECURITY_AUTH_ROLE_TO_USER_API
export const CREATE_SECURITY_AUTH_ROLE_TO_USER_API =
  "/securityauthroletouser/create";
//UPDATE_SECURITY_AUTH_ROLE_TO_USER_API - Task 24736, edits StartDate/EndDate only
export const UPDATE_SECURITY_AUTH_ROLE_TO_USER_API =
  "/securityauthroletouser/update";
//DELETE_SECURITY_AUTH_ROLE_TO_USER_API
export const DELETE_SECURITY_AUTH_ROLE_TO_USER_API =
  "/securityauthroletouser/delete";
//CREATE_SECURITY_AUTH_MISSING_REQUEST_API
export const CREATE_SECURITY_AUTH_MISSING_REQUEST_API =
  "/securityauthmissingrequest/create";

//************  API Calls ************//
// Year End Period
//GET_YEAR_END_PERIOD_LIST_API
export const GET_YEAR_END_PERIOD_LIST_API = "/yearendperiod/list";
//GET_YEAR_END_PERIOD_DETAILS_API
export const GET_YEAR_END_PERIOD_DETAILS_API = "/yearendperiod/data";
//UPDATE_YEAR_END_PERIOD_DETAILS_API
export const UPDATE_YEAR_END_PERIOD_DETAILS_API = "/yearendperiod/update";
//CREATE_YEAR_END_PERIOD_API
export const CREATE_YEAR_END_PERIOD_API = "/yearendperiod/create";
//DELETE_YEAR_END_PERIOD_API
export const DELETE_YEAR_END_PERIOD_API = "/yearendperiod/delete";
//GET_YEAR_END_PERIOD_INVOICE_LIST_API
export const GET_YEAR_END_PERIOD_INVOICE_LIST_API =
  "/yearendperiod/data/invoice";
//GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_API
export const GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_API =
  "/yearendperiod/data/invoiceitem";
//GET_YEAR_END_PERIOD_PURCHASE_LIST_API
export const GET_YEAR_END_PERIOD_PURCHASE_LIST_API =
  "/yearendperiod/data/purchase";
//GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_API
export const GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_API =
  "/yearendperiod/data/purchaseitem";
//************  API Calls ************//
//VAT period export
//GET_VAT_INVOICE_LIST_API
export const GET_VAT_INVOICE_LIST_API = "/vatperiod/data/invoice";
//GET_VAT_INVOICE_ITEM_LIST_API
export const GET_VAT_INVOICE_ITEM_LIST_API = "/vatperiod/data/invoiceitem";
//GET_VAT_PURCHASE_LIST_API
export const GET_VAT_PURCHASE_LIST_API = "/vatperiod/data/purchase";
//GET_VAT_PURCHASE_ITEM_LIST_API
export const GET_VAT_PURCHASE_ITEM_LIST_API = "/vatperiod/data/purchaseitem";
//************  API Calls ************//
// General Settings
//GET_VAT_PERIOD_LIST_API
export const GET_VAT_PERIOD_LIST_API = "/vatperiod/list";
//GET_VAT_PERIOD_DETAILS_API
export const GET_VAT_PERIOD_DETAILS_API = "/vatperiod/data";
//ADD_VAT_PERIOD_API
export const ADD_VAT_PERIOD_API = "/vatperiod/create";
//UPDATE_VAT_PERIOD_API
export const UPDATE_VAT_PERIOD_API = "/vatperiod/update";
//DELETE_VAT_PERIOD_API
export const DELETE_VAT_PERIOD_API = "/vatperiod/delete";
//GET_RENEWAL_FREQUENCIES_LIST_API
export const GET_RENEWAL_FREQUENCIES_LIST_API = "/renewalfrequency/list";
//GET_RENEWAL_FREQUENCIES_DETAILS_API
export const GET_RENEWAL_FREQUENCIES_DETAILS_API = "/renewalfrequency/data";
//ADD_RENEWAL_FREQUENCIES_API
export const ADD_RENEWAL_FREQUENCIES_API = "/renewalfrequency/create";
//UPDATE_RENEWAL_FREQUENCIES_API
export const UPDATE_RENEWAL_FREQUENCIES_API = "/renewalfrequency/update";
//DELETE_RENEWAL_FREQUENCIES_API
export const DELETE_RENEWAL_FREQUENCIES_API = "/renewalfrequency/delete";
//GET_UNIT_FREQUENCIES_LIST_API
export const GET_UNIT_FREQUENCIES_LIST_API = "/unitfrequency/list";
//GET_UNIT_FREQUENCIES_DETAILS_API
export const GET_UNIT_FREQUENCIES_DETAILS_API = "/unitfrequency/data";
//ADD_UNIT_FREQUENCIES_API
export const ADD_UNIT_FREQUENCIES_API = "/unitfrequency/create";
//UPDATE_UNIT_FREQUENCIES_API
export const UPDATE_UNIT_FREQUENCIES_API = "/unitfrequency/update";
//DELETE_UNIT_FREQUENCIES_API
export const DELETE_UNIT_FREQUENCIES_API = "/unitfrequency/delete";
//GET_MASTER_TIME_FRAME_LIST_API
export const GET_MASTER_TIME_FRAME_LIST_API = "/mastertimeframeinterval/list";
//GET_MASTER_TIME_FRAME_DETAILS_API
export const GET_MASTER_TIME_FRAME_DETAILS_API =
  "/mastertimeframeinterval/data";
//ADD_MASTER_TIME_FRAME_API
export const ADD_MASTER_TIME_FRAME_API = "/mastertimeframeinterval/create";
//UPDATE_MASTER_TIME_FRAME_API
export const UPDATE_MASTER_TIME_FRAME_API = "/mastertimeframeinterval/update";
//DELETE_MASTER_TIME_FRAME_API
export const DELETE_MASTER_TIME_FRAME_API = "/mastertimeframeinterval/delete";
//GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_API
export const GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_API =
  "/masterconfigitem/list/company";
//UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_API
export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_API =
  "/configcompany/append";
//GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_API
export const GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_API =
  "/masterconfigitem/list/user";
//UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_API
export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_API =
  "/configuser/append";
//GET_CONFIG_ITEMS_COMPANY_EDITABLE - company Config Items screen (FlagAllowFrontEndEdit=1)
export const GET_CONFIG_ITEMS_COMPANY_EDITABLE =
  "/masterconfigitem/list/company/editable";
//Master Config Item (Super Admin CRUD)
export const GET_MASTER_CONFIG_ITEM_LIST_ALL = "/masterconfigitem/list/all";
export const CREATE_MASTER_CONFIG_ITEM = "/masterconfigitem/create";
export const UPDATE_MASTER_CONFIG_ITEM = "/masterconfigitem/update";
//************  API Calls ************//
//Liability Api calls
//GET_LIABILITY_LIST_API
export const GET_LIABILITY_LIST_API = "/liability/list";
//GET_LIABILITY_DETAIL_API
export const GET_LIABILITY_DETAIL_API = "/liability/data";
//CREATE_LIABILITY_API
export const CREATE_LIABILITY_API = "/liability/create";
//UPDATE_LIABILITY_API
export const UPDATE_LIABILITY_API = "/liability/update";
//DELETE_LIABILITY_API
export const DELETE_LIABILITY_API = "/liability/void";
//GET_LIABILITY_PROVIDER_LIST_API
export const GET_LIABILITY_PROVIDER_LIST_API = "/liabilityprovider/list";
//GET_LIABILITY_PROVIDER_DETAIL_API
export const GET_LIABILITY_PROVIDER_DETAIL_API = "/liabilityprovider/data";
//CREATE_LIABILITY_PROVIDER_API
export const CREATE_LIABILITY_PROVIDER_API = "/liabilityprovider/create";
//UPDATE_LIABILITY_PROVIDER_API
export const UPDATE_LIABILITY_PROVIDER_API = "/liabilityprovider/update";
// DELETE_LIABILITY_PROVIDER_API
export const DELETE_LIABILITY_PROVIDER_API = "/liabilityprovider/delete";
//GET_LIABILITY_STATUS_LIST_API
export const GET_LIABILITY_STATUS_LIST_API = "/liabilitystatus/list";
//GET_LIABILITY_STATUS_DETAIL_API
export const GET_LIABILITY_STATUS_DETAIL_API = "/liabilitystatus/data";
//CREATE_LIABILITY_STATUS_API
export const CREATE_LIABILITY_STATUS_API = "/liabilitystatus/create";
//UPDATE_LIABILITY_STATUS_API
export const UPDATE_LIABILITY_STATUS_API = "/liabilitystatus/update";
//DELETE_LIABILITY_STATUS_API
export const DELETE_LIABILITY_STATUS_API = "/liabilitystatus/delete";
//GET_LIABILITY_ITEM_CATEGORY_LIST_API
export const GET_LIABILITY_ITEM_CATEGORY_LIST_API =
  "/liabilityitemcategory/list";
//GET_LIABILITY_ITEM_CATEGORY_DETAIL_API
export const GET_LIABILITY_ITEM_CATEGORY_DETAIL_API =
  "/liabilityitemcategory/data";
//CREATE_LIABILITY_ITEM_CATEGORY_API
export const CREATE_LIABILITY_ITEM_CATEGORY_API =
  "/liabilityitemcategory/create";
//UPDATE_LIABILITY_ITEM_CATEGORY_API
export const UPDATE_LIABILITY_ITEM_CATEGORY_API =
  "/liabilityitemcategory/update";
//DELETE_LIABILITY_ITEM_CATEGORY_API
export const DELETE_LIABILITY_ITEM_CATEGORY_API =
  "/liabilityitemcategory/delete";
//************  API Calls ************//
//Dashboard Api calls
//GET_DASHBOARD_DATA_API
export const GET_DASHBOARD_DATA_API = "/dashboard/data";
//GET_DASHBOARD_ACTIVITY_LIST_API
export const GET_DASHBOARD_ACTIVITY_LIST_API = "/userrecentactivity/list";
//Recently Viewed
export const RECORD_RECENTLY_VIEWED_API = "/userrecentlyviewed/record";
export const GET_RECENTLY_VIEWED_LIST_API = "/userrecentlyviewed/list";
//************  API Calls ************//
// Manage License API Calls
//GET_LICENSES_SUBSCRIPTION_LIST_API
export const GET_LICENSES_SUBSCRIPTION_LIST_API =
  "/subscriptionlicence/list/company/active"; // replaced from  "/subscriptionlicence/list/company";
//GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_API
export const GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_API =
  "/subscriptionproduct/list";
//REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_API
export const REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_API =
  "/subscriptionlicence/create/company/preview";
//CONFIRM_SUBSCRIPTION_LICENSES_ORDER_API
export const CONFIRM_SUBSCRIPTION_LICENSES_ORDER_API =
  "/subscriptionlicence/create/company";
//UPDATE_SUBSCRIPTION_LICENSES_ORDER_API
export const UPDATE_SUBSCRIPTION_LICENSES_ORDER_API =
  "/subscriptionlicence/update/company";
//UNASSIGN_LICENSE_FROM_USER_API
export const UNASSIGN_LICENSE_FROM_USER_API =
  "/subscriptionlicence/unassign/company";
//GET_SUBSCRIPTION_PRODUCT_LIST_API
export const GET_SUBSCRIPTION_PRODUCT_LIST_API =
  "/subscriptionproduct/list/company/available";
//GET_USER_LICENCE_LIST_API - all licences (active + expired) held by one user (append /:userId)
export const GET_USER_LICENCE_LIST_API = "/subscriptionlicence/list/user";

//************  API Calls ************//
// Verify Email
//VERIFY_EMAIL_API
export const VERIFY_EMAIL_API = "/auth/verifyemail";
//SEND_NEW_VERIFICATION_EMAIL_API
export const SEND_NEW_VERIFICATION_EMAIL_API = "/auth/resendemailverification";
//CREATE_COMPANY_API
export const CREATE_COMPANY_API = "/auth/register/company";
//VERIFY_USER_JOIN_API
export const VERIFY_USER_JOIN_API = "/auth/invite/user/verify";
//ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_API
export const ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_API = "/auth/register/user";
//AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_API
export const AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_API =
  "/auth/verifyforgotpassword";
//RESET_PASSWORD_API
export const RESET_PASSWORD_API = "/auth/executeforgotpassword";
//************  API Calls ************//
//SEND_LEAVE_REQUEST_API
// Dunning
// Get Dunning List api GET_DUNNING_LIST_API
export const GET_DUNNING_LIST_API = "/customer/list/dunning"; // "/customer/list/dunning/eventoverdue"; replaced
// GET_DUNNING_ACTION_LIST_API
export const GET_DUNNING_ACTION_LIST_API = "/dunningeventaction/list";
// CREATE_DUNNING_EVENT_API
export const CREATE_DUNNING_EVENT_API = "/dunningevent/create";
//SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_API
export const SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_API =
  "/dunningevent/search";
//GET_DUNNING_SINGLE_EVENT_API
export const GET_DUNNING_SINGLE_EVENT_API = "/dunningevent/data";
//UPDATE_DUNNING_EVENT_API
export const UPDATE_DUNNING_EVENT_API = "/dunningevent/update";
//DELETE_DUNNING_EVENT_API
export const DELETE_DUNNING_EVENT_API = "/dunningevent/delete";

// ADD_NEW_DUNNING_EVENT_ACTION_API
export const ADD_NEW_DUNNING_EVENT_ACTION_API = "/dunningeventaction/create";
//UPDATE_DUNNING_EVENT_ACTION_API
export const UPDATE_DUNNING_EVENT_ACTION_API = "/dunningeventaction/update";
//DELETE_DUNNING_EVENT_ACTION_API
export const DELETE_DUNNING_EVENT_ACTION_API = "/dunningeventaction/delete";
//GET_DUNNING_LOCK_TYPE_LIST_API
export const GET_DUNNING_LOCK_TYPE_LIST_API = "/dunninglocktype/list";
//GET_DUNNING_LOCK_TYPE_DATA_API
export const GET_DUNNING_LOCK_TYPE_DATA_API = "/dunninglocktype/data";
//CREATE_DUNNING_LOCK_TYPE_API
export const CREATE_DUNNING_LOCK_TYPE_API = "/dunninglocktype/create";
//UPDATE_DUNNING_LOCK_TYPE_API
export const UPDATE_DUNNING_LOCK_TYPE_API = "/dunninglocktype/update";
//DELETE_DUNNING_LOCK_TYPE_API
export const DELETE_DUNNING_LOCK_TYPE_API = "/dunninglocktype/delete";
//GET_DUNNING_LOCK_LIST_API
export const GET_DUNNING_LOCK_LIST_API = "/dunninglock/list";
//GET_DUNNING_LOCK_DATA_API
export const GET_DUNNING_LOCK_DATA_API = "/dunninglock/data";
//CREATE_DUNNING_LOCK_API
export const CREATE_DUNNING_LOCK_API = "/dunninglock/create";
//UPDATE_DUNNING_LOCK_API
export const UPDATE_DUNNING_LOCK_API = "/dunninglock/update";
//DELETE_DUNNING_LOCK_API
export const DELETE_DUNNING_LOCK_API = "/dunninglock/delete";
//GET_DUNNING_PROFILE_LIST_API
export const GET_DUNNING_PROFILE_LIST_API = "/dunningprofile/list";
//GET_DUNNING_PROFILE_DATA_API
export const GET_DUNNING_PROFILE_DATA_API = "/dunningprofile/data";
//CREATE_DUNNING_PROFILE_API
export const CREATE_DUNNING_PROFILE_API = "/dunningprofile/create";
//UPDATE_DUNNING_PROFILE_API
export const UPDATE_DUNNING_PROFILE_API = "/dunningprofile/update";
//DELETE_DUNNING_PROFILE_API
export const DELETE_DUNNING_PROFILE_API = "/dunningprofile/delete";
//GET_DUNNING_PROFILE_STEP_LIST_API
export const GET_DUNNING_PROFILE_STEP_LIST_API = "/dunningprofilestep/list";
//GET_DUNNING_PROFILE_STEP_DATA_API
export const GET_DUNNING_PROFILE_STEP_DATA_API = "/dunningprofilestep/data";
//CREATE_DUNNING_PROFILE_STEP_API
export const CREATE_DUNNING_PROFILE_STEP_API = "/dunningprofilestep/create";
//UPDATE_DUNNING_PROFILE_STEP_API
export const UPDATE_DUNNING_PROFILE_STEP_API = "/dunningprofilestep/update";
//DELETE_DUNNING_PROFILE_STEP_API
export const DELETE_DUNNING_PROFILE_STEP_API = "/dunningprofilestep/delete";
//************  API Calls ************//
//SEND_LEAVE_REQUEST_API
export const SEND_LEAVE_REQUEST_API = "/staffleave/create";
//************  API Calls ************//
// Customer Card Api Calls
//CUSTOMER_CARD_ADD_SUCCESS_API
export const CUSTOMER_CARD_ADD_SUCCESS_API =
  "/masterpaymentcard/stripe/setupintentsuccess";

// GET_CUSTOMER_CARDS_API
export const GET_CUSTOMER_CARDS_API = "/masterpaymentcard/company/list";

//************  API Calls ************//
// Payment Method API Calls
// Get Payment Method List API
// Profit and loss
// // profit and loss statement data from date range sent api call
export const PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT_API =
  "/transactionfinancial/profitlossstatement";
//************  API Calls ************//
// Payment Method API Calls
// Get Payment Method List API
export const GET_PAYMENT_METHOD_LIST_API = "/paymentmethod/list";
//************  API Calls ************//

// Contact Person Lookup API Calls
// Search Contact Person Lookup by Phone Number API
export const SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_API =
  "/search/lookuptelephone";
// Blended lookup behind the browser dialler's search box (Task 24515). The
// term travels in the URL path, so callers pass it as `id` and let FetchAPI
// append it.
export const SEARCH_DIALLER_LOOKUP_API = "/search/lookupdialler";
//************  API Calls ************//

// Get Single Job Page Invoice Items List API
export const GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_API =
  "/jobinvoiceitem/search";

//************  API Calls ************//

//Payment Term API Calls
// Get Payment Term List API
export const GET_PAYMENT_TERM_LIST_API = "/paymentterm/list";
//GET_PAYMENT_TERM_DATA_API
export const GET_PAYMENT_TERM_DATA_API = "/paymentterm/data";
//CREATE_PAYMENT_TERM_API
export const CREATE_PAYMENT_TERM_API = "/paymentterm/create";
//UPDATE_PAYMENT_TERM_API
export const UPDATE_PAYMENT_TERM_API = "/paymentterm/update";
//DELETE_PAYMENT_TERM_API
export const DELETE_PAYMENT_TERM_API = "/paymentterm/delete";

//************  API Calls ************//

// Quote API Calls
// Get Quote List API
export const GET_QUOTE_LIST_API = "/quote/list";
// Get Quote Details API
export const GET_QUOTE_DETAILS_API = "/quote/data";
// Create Quote API
export const CREATE_QUOTE_API = "/quote/create";
// Update Quote API
export const UPDATE_QUOTE_API = "/quote/update";
// Delete Quote API
export const DELETE_QUOTE_API = "/quote/delete";
// Get Quote Status List API
export const GET_QUOTE_STATUS_LIST_API = "/quotestatus/list";
// Quote get Pdf api
export const GET_QUOTE_PDF_API = "/quote/pdf";
//ADD_NEW_QUOTE_STATUS_API
export const ADD_NEW_QUOTE_STATUS_API = "/quotestatus/create";
//UPDATE_QUOTE_STATUS_API
export const UPDATE_QUOTE_STATUS_API = "/quotestatus/update";
//DELETE_QUOTE_STATUS_API
export const DELETE_QUOTE_STATUS_API = "/quotestatus/delete";
//GET_SINGLE_CUSTOMER_QUOTE_LIST_API
export const GET_SINGLE_CUSTOMER_QUOTE_LIST_API = "/quote/search";

// ************ Opportunity API Calls ************ //

// Search Single Customer Opportunities List API
export const SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_API =
  "/opportunity/search";
// Create Opportunity New Item API
export const CREATE_OPPORTUNITY_NEW_ITEM_API = "/opportunity/create";
//  Update Opportunity Item API
export const UPDATE_OPPORTUNITY_ITEM_API = "/opportunity/update";
// Get All Opportunities List API
export const GET_ALL_OPPORTUNITIES_LIST_API = "/opportunity/list";
// Get Single Opportunity Item API
export const GET_SINGLE_OPPORTUNITY_ITEM_API = "/opportunity/data";
// Delete Opportunity Item API
export const DELETE_OPPORTUNITY_ITEM_API = "/opportunity/delete";
// Get Opportunity Status List API
export const GET_OPPORTUNITY_STATUS_LIST_API = "/opportunitystatus/list";
// Get Opportunity Priority List API
export const GET_OPPORTUNITY_PRIORITY_LIST_API = "/opportunitypriority/list";
// Get Opportunity Type List API
export const GET_OPPORTUNITY_TYPE_LIST_API = "/opportunitytype/list";
// Get Opportunity Notes List API
export const GET_OPPORTUNITY_NOTES_LIST_API = "/opportunitynote/search";
// Create Opportunity Notes Item API
export const CREATE_OPPORTUNITY_NOTES_ITEM_API = "/opportunitynote/create";
// Get Single Opportunity Activity List
export const GET_SINGLE_OPPORTUNITY_ACTIVITY_LIST_API =
  "/opportunityrecentactivity/list/";
//ADD_NEW_OPPORTUNITY_STATUS_API
export const ADD_NEW_OPPORTUNITY_STATUS_API = "/opportunitystatus/create";
//DELETE_OPPORTUNITY_STATUS_API
export const DELETE_OPPORTUNITY_STATUS_API = "/opportunitystatus/delete";
//UPDATE_OPPORTUNITY_STATUS_API
export const UPDATE_OPPORTUNITY_STATUS_API = "/opportunitystatus/update";
//ADD_NEW_OPPORTUNITY_PRIORITY_API
export const ADD_NEW_OPPORTUNITY_PRIORITY_API = "/opportunitypriority/create";
//DELETE_OPPORTUNITY_PRIORITY_API
export const DELETE_OPPORTUNITY_PRIORITY_API = "/opportunitypriority/delete";
//UPDATE_OPPORTUNITY_PRIORITY_API
export const UPDATE_OPPORTUNITY_PRIORITY_API = "/opportunitypriority/update";
//ADD_NEW_OPPORTUNITY_TYPE_API
export const ADD_NEW_OPPORTUNITY_TYPE_API = "/opportunitytype/create";
//DELETE_OPPORTUNITY_TYPE_API
export const DELETE_OPPORTUNITY_TYPE_API = "/opportunitytype/delete";
//UPDATE_OPPORTUNITY_TYPE_API
export const UPDATE_OPPORTUNITY_TYPE_API = "/opportunitytype/update";
//GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_API
export const GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_API =
  "/opportunity/overview/funnel";
//SEARCH_OPPORTUNITY_ATTACHMENT_LIST_API
export const SEARCH_OPPORTUNITY_ATTACHMENT_LIST_API =
  "/opportunityattachment/search";
//DELETE_OPPORTUNITY_ATTACHMENT_API
export const DELETE_OPPORTUNITY_ATTACHMENT_API =
  "/opportunityattachment/delete";
// Search Opportunity Product (interested products) List API
export const SEARCH_OPPORTUNITY_PRODUCT_LIST_API = "/opportunityproduct/search";
// Create Opportunity Product Item API
export const CREATE_OPPORTUNITY_PRODUCT_ITEM_API = "/opportunityproduct/create";
// Delete Opportunity Product Item API
export const DELETE_OPPORTUNITY_PRODUCT_ITEM_API = "/opportunityproduct/delete";

//*************************************//
//* *********  Company TO User API Calls ********* //
// Get Company To User List API
export const GET_COMPANY_TO_USER_LIST_API = "/companytouser/listavailable";
// Switch Company API
export const SWITCH_COMPANY_API = "/api/switchcompany";
// GET_COMPANY_USER_INVITATIONS_API
export const GET_COMPANY_USER_INVITATIONS_API = "/userinvitation/list";
//SEND_EMAIL_INVITATION_API
export const SEND_EMAIL_INVITATION_API = "/auth/invite/user";
//GET_JOIN_COMPANY_INVITATION_LIST_API
export const GET_JOIN_COMPANY_INVITATION_LIST_API = "/userinvitation/list/my";
//ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_API
export const ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_API =
  "/userinvitation/update/my";
//GET_COMPANY_TEAM_MEMBERS_LIST_API
export const GET_COMPANY_TEAM_MEMBERS_LIST_API = "/companytouser/list/team";
//GET_COMPANY_DETAILS_API
export const GET_COMPANY_DETAILS_API = "/company/data/my";
//UPDATE_COMPANY_DETAILS_API
export const UPDATE_COMPANY_DETAILS_API = "/company/update/my";
//GET_USER_AVAILABLE_MENU_API
export const GET_USER_AVAILABLE_MENU_API = "/menunav/list";
//GET_USER_AVAILABLE_DASHBOARD_API
export const GET_USER_AVAILABLE_DASHBOARD_API = "/dashboardtemplate/list";

// Custom Dashboard Builder (Task 24269)
export const DASHBOARD_TEMPLATE_LIST_API = "/dashboardtemplate/list";
export const DASHBOARD_TEMPLATE_DATA_API = "/dashboardtemplate/data"; // + /{id}
export const DASHBOARD_BOX_LIST_API = "/dashboardtemplate/boxlist";
export const DASHBOARD_TEMPLATE_CREATE_API = "/dashboardtemplate/create";
export const DASHBOARD_TEMPLATE_SAVE_LAYOUT_API = "/dashboardtemplate/savelayout";
export const DASHBOARD_TEMPLATE_SET_DEFAULT_API = "/dashboardtemplate/setdefault";
export const DASHBOARD_TEMPLATE_SET_SCOPE_API = "/dashboardtemplate/setscope";
export const DASHBOARD_TEMPLATE_SET_ACTIVE_API = "/dashboardtemplate/setactive";
export const DASHBOARD_TEMPLATE_DELETE_API = "/dashboardtemplate/delete"; // + /{id}

//MAP_DASHBOARD_AND_MENU_TO_USER_API
export const MAP_DASHBOARD_AND_MENU_TO_USER_API = "/menunav/unmap";
//GET_COMPANY_TO_USER_LIST_TEAM_API
export const GET_COMPANY_TO_USER_LIST_TEAM_API = "/companytouser/list/team";
//UPDATE_COMPANY_TO_USER_TEAM_API
export const UPDATE_COMPANY_TO_USER_TEAM_API = "/companytouser/update/team";
//CREATE_COMPANY_TO_USER_API
export const CREATE_COMPANY_TO_USER_API = "/companytouser/create";
//DELETE_COMPANY_TO_USER_API
export const DELETE_COMPANY_TO_USER_API = "/companytouser/delete";
//COMPANY_TO_USER_LOCK_USER_API
export const COMPANY_TO_USER_LOCK_USER_API = "/companytouser/lockuser";
//COMPANY_TO_USER_UNLOCK_USER_API
export const COMPANY_TO_USER_UNLOCK_USER_API = "/companytouser/unlockuser";
//COMPANY_TO_USER_RESET_PASSWORD_API
export const COMPANY_TO_USER_RESET_PASSWORD_API =
  "/companytouser/resetpassword";
//COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_API
export const COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_API =
  "/subscriptionlicence/update/user";
//GET_COMPANY_TO_USER_DATA_API
export const GET_COMPANY_TO_USER_DATA_API = "/companytouser/data/team/";

// ********* Supplier  API Calls ********* //
// Get Supplier List API
export const GET_SUPPLIER_LIST_API = "/supplier/list";
// Get Single Supplier Details API
export const GET_SINGLE_SUPPLIER_DETAILS_API = "/supplier/data";
// Create New Supplier API
export const CREATE_NEW_SUPPLIER_API = "/supplier/create";
// Update Supplier API
export const UPDATE_SUPPLIER_API = "/supplier/update";
// Delete Supplier API
export const DELETE_SUPPLIER_API = "/supplier/delete";
//GET_SUPPLIER_RECENT_ACTIVITY_API
export const GET_SUPPLIER_RECENT_ACTIVITY_API = "/supplierrecentactivity/list";
//SEARCH_SUPPLIER_NOTE_API
export const SEARCH_SUPPLIER_NOTE_API = "/suppliernote/search";
//CREATE_SUPPLIER_NOTE_API
export const CREATE_SUPPLIER_NOTE_API = "/suppliernote/create";
//DELETE_SUPPLIER_NOTE_API
export const DELETE_SUPPLIER_NOTE_API = "/suppliernote/delete";
//SEARCH_SUPPLIER_ATTACHMENT_API
export const SEARCH_SUPPLIER_ATTACHMENT_API = "/supplierattachment/search";
//DELETE_SUPPLIER_ATTACHMENT_API
export const DELETE_SUPPLIER_ATTACHMENT_API = "/supplierattachment/delete";
// Change #100122 - files kept against a customer
export const SEARCH_CUSTOMER_ATTACHMENT_API = "/customerattachment/search";
export const DELETE_CUSTOMER_ATTACHMENT_API = "/customerattachment/delete";
//Supplier Url Link APIs (Task 24318)
export const SEARCH_SUPPLIER_URL_LINK_API = "/supplierurllink/search";
export const GET_SUPPLIER_URL_LINK_DETAILS_API = "/supplierurllink/data";
export const CREATE_SUPPLIER_URL_LINK_API = "/supplierurllink/create";
export const UPDATE_SUPPLIER_URL_LINK_API = "/supplierurllink/update";
export const DELETE_SUPPLIER_URL_LINK_API = "/supplierurllink/delete";
export const GET_SUPPLIER_URL_LINK_STATUS_LIST_API =
  "/supplierurllinkstatus/list";
export const GET_SUPPLIER_URL_LINK_TYPE_LIST_API = "/supplierurllinktype/list";
//Supplier Balance Historical APIs
export const GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_API =
  "/supplierbalancehistorical/listbysupplier";
export const GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_API =
  "/supplierbalancehistorical/specificdate";
export const GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_API =
  "/supplierbalancehistorical/availabledates";
//************** Purchase API Calls **********************//
// Get Purchase List API
export const GET_PURCHASE_LIST_API = "/purchase/list";
// Get Single Purchase Data API
export const GET_SINGLE_PURCHASE_DATA_API = "/purchase/data";
// Create Single Purchase API
export const CREATE_SINGLE_PURCHASE_API = "/purchase/create";
// Update Single Purchase API
export const UPDATE_SINGLE_PURCHASE_API = "/purchase/update";
// Get Purchase Status List API
export const GET_PURCHASE_STATUS_LIST_API = "/purchasestatus/list";

// Search Single Supplier Purchase List API Call
export const SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_API_CALL = "/purchase/search";

// Get Purchase Item Category List API
export const GET_PURCHASE_ITEM_CATEGORY_LIST_API = "/purchaseitemcategory/list";
// Get Purchase Item List By Job Id API
export const GET_PURCHASE_ITEM_LIST_BY_JOB_ID_API = "/purchaseitem/search";
// Convert a purchase item into a billable item (JobPredictedBillableItem)
export const CONVERT_PURCHASE_ITEM_TO_BILLABLE_API =
  "/purchaseitem/converttobillable";
// Undo a purchase-item -> billable-item conversion
export const UNLINK_PURCHASE_ITEM_BILLABLE_API =
  "/purchaseitem/unlinkbillable";
// Manually mark a purchase item as billed (flag only, not linked to anything)
export const MARK_PURCHASE_ITEM_BILLED_API = "/purchaseitem/markbilled";
//ADD_NEW_PURCHASE_STATUS_API
export const ADD_NEW_PURCHASE_STATUS_API = "/purchasestatus/create";
//DELETE_PURCHASE_STATUS_API
export const DELETE_PURCHASE_STATUS_API = "/purchasestatus/delete";
//UPDATE_PURCHASE_STATUS_API
export const UPDATE_PURCHASE_STATUS_API = "/purchasestatus/update";
//ADD_NEW_PURCHASE_ITEM_CATEGORY_API
export const ADD_NEW_PURCHASE_ITEM_CATEGORY_API =
  "/purchaseitemcategory/create";
//DELETE_PURCHASE_ITEM_CATEGORY_API
export const DELETE_PURCHASE_ITEM_CATEGORY_API = "/purchaseitemcategory/delete";
//UPDATE_PURCHASE_ITEM_CATEGORY_API
export const UPDATE_PURCHASE_ITEM_CATEGORY_API = "/purchaseitemcategory/update";
//DELETE_SINGLE_PURCHASE_API
export const DELETE_SINGLE_PURCHASE_API = "/purchase/void";
//SEARCH_PURCHASE_ITEM_LIST_API
export const SEARCH_PURCHASE_ITEM_LIST_API = "/purchaseitem/search";
//UPLOAD_PURCHASE_DRAFT_API
export const UPLOAD_PURCHASE_DRAFT_API = "/purchasedraft/upload";
//CREATE_FILE_ATTACHMENT_API
export const CREATE_FILE_ATTACHMENT_API = "/fileattachment/create";
//SEARCH_PURCHASE_ATTACHMENT_API
export const SEARCH_PURCHASE_ATTACHMENT_API = "/fileattachment/search";
//DELETE_JOB_ATTACHMENT_API
export const DELETE_JOB_ATTACHMENT_API = "/fileattachment/delete";

// Predict Transaction Financial
export const PREDICT_TRANSACTION_FINANCIAL_API =
  "/transactionfinancial/predict";

// Get Purchase Item List By Job Id API
// ********* Products  API Calls ********* //
// Contract API calls

// Get Contract list API
export const GET_CONTRACT_LIST_API = "/contract/list";
// Create Contract API
export const CREATE_CONTRACT_API = "/contract/create";
// Get Contract Status List API
export const GET_CONTRACT_STATUS_LIST_API = "/contractstatus/list";

// Get Single Contract API
export const GET_SINGLE_CONTRACT_API = "/contract/data";
// Update Contract API
export const UPDATE_CONTRACT_API = "/contract/update";
// Update Contract with Items API
export const UPDATE_CONTRACT_WITH_ITEMS_API = "/contract/update";
// Preview Contract Update (dry-run, no save) API
export const PREVIEW_CONTRACT_UPDATE_API = "/contract/update/preview";
// Preview Contract Create (dry-run, no save) API
export const PREVIEW_CONTRACT_CREATE_API = "/contract/create/preview";
// Delete Contract API
export const DELETE_CONTRACTS_API = "/contract/delete";
// Search Single Customer Contracts API
export const SINGLE_CUSTOMER_SEARCH_CONTRACTS_API = "/contract/search";
// Get Contract Items List API
export const GET_CONTRACT_ITEMS_LIST_API = "/contractitem/list";

// Get Contract Item Status List
export const GET_CONTRACT_ITEM_STATUS_LIST_API = "/contractitemstatus/list";

// Get Contract Frequency List
export const GET_CONTRACT_FREQUENCY_LIST_API = "/unitfrequency/list";
// Search Single Customer Contract Items List API
export const SEARCH_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_API =
  "/contractitem/search";
// Create Contract With Items API Call
export const CREATE_CONTRACT_WITH_ITEMS_API = "/contract/create";

// Search Single Customer Contract Items Summary List API
export const SEARCH_SINGLE_CUSTOMER_CONTRACT_ITEMS_SUMMARY_LIST_API =
  "/contractitem/search/summary";
// Get COntract Item Frequency List API
export const GET_CONTRACT_ITEM_FREQUENCY_LIST_API = "/renewalfrequency/list";
// Get Master Time Frame Interval List API
export const GET_MASTER_TIME_FRAME_INTERVAL_LIST_API =
  "/mastertimeframeinterval/list";
//DELETE_SINGLE_CONTRACT_ITEM_API
export const DELETE_SINGLE_CONTRACT_ITEM_API = "/contractitem/delete";
//GET_CONTRACT_ITEMS_ACTIVE_LIST_API
export const GET_CONTRACT_ITEMS_ACTIVE_LIST_API = "/contractitem/list/active";
//GET_CONTRACT_ITEMS_CANCELLED_LIST_API
export const GET_CONTRACT_ITEMS_CANCELLED_LIST_API =
  "/contractitem/list/cancelled";
//GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_API
export const GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_API =
  "/contractitemusage/search";
//GET_CONTRACT_ITEM_USAGE_LIST_API
export const GET_CONTRACT_ITEM_USAGE_LIST_API = "/contractitemusage/list";
//GET_CONTRACT_ITEM_USAGE_SEARCH_API
export const GET_CONTRACT_ITEM_USAGE_SEARCH_API = "/contractitemusage/search";
//SEARCH_CONTRACT_PDF_API
export const SEARCH_CONTRACT_PDF_API = "/contract/pdfcontractsheet";
//DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_API
export const DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_API =
  "/contractitemusage/delete/allprevious";
//GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_API
export const GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_API =
  "/contractitemusage/livebalance/pdf";
//GENERATE_CONTRACT_ITEM_USAGE_API
export const GENERATE_CONTRACT_ITEM_USAGE_API = "/contractitemusage/generate";
//CONVERT_CONTRACT_ITEM_USAGE_API - Change #100435
export const CONVERT_CONTRACT_ITEM_USAGE_API = "/contractitemusage/convert";
//GET_CONTRACT_ITEM_USAGE_PDF_API
export const GET_CONTRACT_ITEM_USAGE_PDF_API = "/contractitemusage/pdf";
//REGENERATE_CONTRACT_ITEM_USAGE_PDF_API
export const REGENERATE_CONTRACT_ITEM_USAGE_PDF_API =
  "/contractitemusage/pdfregenerate";
//GET_CONTRACT_ITEM_CREDIT_LIST_API
export const GET_CONTRACT_ITEM_CREDIT_LIST_API = "/contractitemcredit/list";
//CREATE_CONTRACT_ITEM_CREDIT_API
export const CREATE_CONTRACT_ITEM_CREDIT_API = "/contractitemcredit/create";
//UPDATE_CONTRACT_ITEM_CREDIT_API
export const UPDATE_CONTRACT_ITEM_CREDIT_API = "/contractitemcredit/update";
//DELETE_CONTRACT_ITEM_CREDIT_API
export const DELETE_CONTRACT_ITEM_CREDIT_API = "/contractitemcredit/delete";
//GET_CONTRACT_ITEM_PORTFOLIO_API
export const GET_CONTRACT_ITEM_PORTFOLIO_API =
  "/contractitem/portfolio/timetracked";
//GET_CONTRACT_ITEM_DEBIT_LIST_API
export const GET_CONTRACT_ITEM_DEBIT_LIST_API = "/contractitemdebit/list";
//GET_JOB_LIST_BY_CONTRACT_ITEM_API
export const GET_JOB_LIST_BY_CONTRACT_ITEM_API = "/job/listbycontractitem";
// Get Products List API Call
export const GET_PRODUCTS_LIST_API_CALL = "/product/list";
//GET_PRODUCT_SELF_SERVE_WIDGET_RENDER
export const GET_PRODUCT_SELF_SERVE_WIDGET_RENDER =
  "/productselfservewidget/render";
//POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK
export const POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK =
  "/productselfservewidget/book";
//POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY
export const POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY =
  "/productselfservewidget/checkavailability";
//GET_PRODUCT_DETAIL_API_CALL
export const GET_PRODUCT_DETAIL_API_CALL = "/product/data";
//ADD_PRODUCT_API_CALL
export const ADD_PRODUCT_API_CALL = "/product/create";
//UPDATE_PRODUCT_API_CALL
export const UPDATE_PRODUCT_API_CALL = "/product/update";
//DELETE_PRODUCT_API_CALL
export const DELETE_PRODUCT_API_CALL = "/product/delete";
//SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_API_CALL
export const SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_API_CALL = "/product/search";
//SEARCH_PRODUCTS_PRICING_API_CALL
export const SEARCH_PRODUCTS_PRICING_API_CALL = "/productpricing/search";
//CREATE_PRODUCTS_PRICING_API_CALL
export const CREATE_PRODUCTS_PRICING_API_CALL = "/productpricing/create";
//UPDATE_PRODUCTS_PRICING_API_CALL
export const UPDATE_PRODUCTS_PRICING_API_CALL = "/productpricing/update";
//DELETE_PRODUCTS_PRICING_API_CALL
export const DELETE_PRODUCTS_PRICING_API_CALL = "/productpricing/delete";
//GET_PRODUCTS_PRICING_DATA_API_CALL
export const GET_PRODUCTS_PRICING_DATA_API_CALL = "/productpricing/data";
//GET_PRODUCTS_RECENT_ACTIVITY_API_CALL
export const GET_PRODUCTS_RECENT_ACTIVITY_API_CALL =
  "/productrecentactivity/list";
//GET_PRODUCTS_PRICING_LIST_API_CALL
export const GET_PRODUCTS_PRICING_LIST_API_CALL = "/productpricing/list";
// Task 24858 - ProductPrice is the product's own DATED price schedule, and is a
// different table from ProductPricing above, which is a customer's bespoke
// price. The schedule was read-only in the UI: product/data returns it as
// productprice_data and the Price History tab listed it, but nothing could add
// a price, correct one, or schedule the next one. The backend CRUD existed all
// along, it had simply never been wired up.
//SEARCH_PRODUCT_PRICE_API_CALL
export const SEARCH_PRODUCT_PRICE_API_CALL = "/productprice/search";
//CREATE_PRODUCT_PRICE_API_CALL
export const CREATE_PRODUCT_PRICE_API_CALL = "/productprice/create";
//UPDATE_PRODUCT_PRICE_API_CALL
export const UPDATE_PRODUCT_PRICE_API_CALL = "/productprice/update";
//DELETE_PRODUCT_PRICE_API_CALL
export const DELETE_PRODUCT_PRICE_API_CALL = "/productprice/delete";
//GET_FOOD_ALLERGEN_LIST_API
export const GET_FOOD_ALLERGEN_LIST_API = "/foodallergen/list";
//GET_FOOD_ALLERGEN_DATA_API
export const GET_FOOD_ALLERGEN_DATA_API = "/foodallergen/data";
//CREATE_FOOD_ALLERGEN_API
export const CREATE_FOOD_ALLERGEN_API = "/foodallergen/create";
//UPDATE_FOOD_ALLERGEN_API
export const UPDATE_FOOD_ALLERGEN_API = "/foodallergen/update";
//DELETE_FOOD_ALLERGEN_API
export const DELETE_FOOD_ALLERGEN_API = "/foodallergen/delete";
//GET_FOOD_DIET_TYPE_LIST_API
export const GET_FOOD_DIET_TYPE_LIST_API = "/fooddiettype/list";
//GET_FOOD_DIET_TYPE_DATA_API
export const GET_FOOD_DIET_TYPE_DATA_API = "/fooddiettype/data";
//CREATE_FOOD_DIET_TYPE_API
export const CREATE_FOOD_DIET_TYPE_API = "/fooddiettype/create";
//UPDATE_FOOD_DIET_TYPE_API
export const UPDATE_FOOD_DIET_TYPE_API = "/fooddiettype/update";
//DELETE_FOOD_DIET_TYPE_API
export const DELETE_FOOD_DIET_TYPE_API = "/fooddiettype/delete";
//GET_PRODUCT_ATTRIBUTE_LIST_API
export const GET_PRODUCT_ATTRIBUTE_LIST_API = "/productattribute/list";
//GET_PRODUCT_ATTRIBUTE_DATA_API
export const GET_PRODUCT_ATTRIBUTE_DATA_API = "/productattribute/data";
//CREATE_PRODUCT_ATTRIBUTE_API
export const CREATE_PRODUCT_ATTRIBUTE_API = "/productattribute/create";
//UPDATE_PRODUCT_ATTRIBUTE_API
export const UPDATE_PRODUCT_ATTRIBUTE_API = "/productattribute/update";
//DELETE_PRODUCT_ATTRIBUTE_API
export const DELETE_PRODUCT_ATTRIBUTE_API = "/productattribute/delete";
//GET_PRODUCT_ATTRIBUTE_VALUE_LIST_API
export const GET_PRODUCT_ATTRIBUTE_VALUE_LIST_API =
  "/productattributevalue/list";
//GET_PRODUCT_ATTRIBUTE_VALUE_DATA_API
export const GET_PRODUCT_ATTRIBUTE_VALUE_DATA_API =
  "/productattributevalue/data";
//CREATE_PRODUCT_ATTRIBUTE_VALUE_API
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_API =
  "/productattributevalue/create";
//UPDATE_PRODUCT_ATTRIBUTE_VALUE_API
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_API =
  "/productattributevalue/update";
//DELETE_PRODUCT_ATTRIBUTE_VALUE_API
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_API =
  "/productattributevalue/delete";
//GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_API
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_API =
  "/productattributevalueprice/list";
//GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_API
export const GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_API =
  "/productattributevalueprice/data";
//CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API
export const CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API =
  "/productattributevalueprice/create";
//UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API
export const UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API =
  "/productattributevalueprice/update";
//DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API
export const DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API =
  "/productattributevalueprice/delete";
// Shortcut Apps API
//Get Shortcut Apps List
export const GET_SHORTCUT_APPS_LIST = "/shortcutquick/list/my";
//GET_SHORTCUT_APP_DATA_API
export const GET_SHORTCUT_APP_DATA_API = "/shortcutquick/data";
//CREATE_SHORTCUT_APP_DATA_API
export const CREATE_SHORTCUT_APP_DATA_API = "/shortcutquick/create/my";
//UPDATE_SHORTCUT_APP_DATA_API
export const UPDATE_SHORTCUT_APP_DATA_API = "/shortcutquick/update/my";
//DELETE_SHORTCUT_APP_DATA_API
export const DELETE_SHORTCUT_APP_DATA_API = "/shortcutquick/delete/my";

//Notification

//Get Notification Open List Api
export const GET_NOTIFICATION_OPEN_LIST_API = "/notification/list/open";
//SYSTEM_NOTIFICATION_INTERNAL_SEND_API
export const SYSTEM_NOTIFICATION_INTERNAL_SEND_API =
  "/system/notification/internal/send";
//Site Wide Search

// Get Results from search call
export const GET_SITE_WIDE_SEARCH_RESULTS = "/search/search/";

// Advanced search (server-side filtered) endpoint
export const ADVANCED_SEARCH_RESULTS = "/search/advanced";

// People API CALLS
// SINGLE_COMPANY_CONTACT_PERSON_SEARCH
export const SINGLE_COMPANY_CONTACT_PERSON_SEARCH_API = "/contactperson/search";
//CREATE_CONTACT_PERSON_API
export const CREATE_CONTACT_PERSON_API = "/contactperson/create";
//LINK_EMAIL_TO_CONTACT_PERSON_API - Task 24737, attach a typed address to a contact
export const LINK_EMAIL_TO_CONTACT_PERSON_API =
  "/contactperson/linkemailaddress";
//GET_SINGLE_PERSON_CONTACT_DETAILS_API
export const GET_SINGLE_PERSON_CONTACT_DETAILS_API = "/contactperson/data";
//DELETE_CONTACT_PERSON_API
export const DELETE_CONTACT_PERSON_API = "/contactperson/delete";
//UPDATE_CONTACT_PERSON_API
export const UPDATE_CONTACT_PERSON_API = "/contactperson/update";
//DELETE_CONTACT_PERSON_RELATIONSHIP_API
export const DELETE_CONTACT_PERSON_RELATIONSHIP_API =
  "/customertocontactpersonrelationship/delete";
//CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_API
export const CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_API =
  "/contactpersontoemailinbound/search";
//CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_API
export const CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_API =
  "/contactpersontoemailinbound/data";
//CONTACT_PERSON_DATA_API
export const CONTACT_PERSON_DATA_API = "/contactperson/data";
//CONTACT_PERSON_LIST_API
export const CONTACT_PERSON_LIST_API = "/contactperson/list";
//SEARCH_PERSON_WITH_CUSTOMER_ID_API
export const SEARCH_PERSON_WITH_CUSTOMER_ID_API =
  "/customertocontactpersonrelationship/search";
//Bank Api Calls
//Bank List APi CAll
export const GET_BANK_LIST = "/bankaccount/list";
//Bank Transaction List APi CAll
export const SINGLE_BANK_TRANSACTION_LIST = "/banktransactionallocation/search";

// All Banks Transaction List APi CAll
export const ALL_BANK_TRANSACTION_LIST = "/banktransactionallocation/list";
// Bank UnAllocated Transaction List APi CAll
export const BANK_UNALLOCATED_TRANSACTION_LIST =
  "/banktransactionallocation/list/unmatched";
// Bank UnAllocated Item List APi CAll
export const BANK_UNALLOCATED_ITEM_LIST =
  "/transactionfinancial/list/unmatched";
// Bank Clear Transaction and Item Request API Call
export const BANK_CLEAR_TRANSACTION_AND_ITEM_REQUEST_API =
  "/clearingdocument/create";
// Bank UnClear Transaction and Item Request API Call
export const BANK_UNCLEAR_TRANSACTION_AND_ITEM_REQUEST_API =
  "/clearingdocument/delete";
// Bank Search Single Customer all transactions request
export const BANK_SEARCH_SINGLE_CUSTOMER_ALL_TRANSACTIONS_REQUEST_API =
  "/customertransactionfinancial/search";

// Bank Single Supplier All transactiosn requests
export const BANK_SEARCH_SINGLE_SUPPLIER_ALL_TRANSACTIONS_REQUEST_API =
  "/suppliertransactionfinancial/search";

// Create Bank Transaction API Call
export const CREATE_BANK_TRANSACTION_API = "/banktransaction/create";
// Bank Single Customer PDF transaction statment API Call
export const BANK_SINGLE_CUSTOMER_PDF_TRANSACTION_STATEMENT_API =
  "/customer/pdfstatement/";
// Bank Upload Transactions file API Call
export const BANK_UPLOAD_TRANSACTIONS_FILE_API = "/banktransaction/upload";
// Assigned Only bank transaction list API Call
export const ASSIGNED_ONLY_BANK_TRANSACTION_LIST_API =
  "/banktransactionallocation/list/unallocated";
// Assign Bank Transaction to Customer API Call
export const BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_API =
  "/banktransactionallocation/assign";
// Bank unassign transaction from customer API Call
export const BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_API =
  "/banktransactionallocation/unassign";
// CREATE_BANK_API
export const CREATE_BANK_API = "/bankaccount/create";
// UPDATE_BANK_API
export const UPDATE_BANK_API = "/bankaccount/update";
//DELETE_BANK_API
export const DELETE_BANK_API = "/bankaccount/delete";
export const SYNC_BANK_TRANSACTIONS_API = "/bankaccount/synctransactions"; // /{bankAccountId}
//SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_API
export const SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_API =
  "/customer/pdfstatement/openitems/";
//SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_API
export const SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_API =
  "/customer/pdfstatement/allitems/";
//GET_BANK_ACCOUNT_STATUS_LIST_API
export const GET_BANK_ACCOUNT_STATUS_LIST_API = "/bankaccountstatus/list";
//BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_API
export const BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_API =
  "/banktransactionallocation/delete";
//MANUAL_BANK_TRANSACTION_DETAILS_API
export const MANUAL_BANK_TRANSACTION_DETAILS_API =
  "/banktransactionallocation/data";
//UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_API
export const UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_API =
  "/banktransactionallocation/update";
//GET_BANK_ACCOUNT_PROVIDER_LIST_API
export const GET_BANK_ACCOUNT_PROVIDER_LIST_API =
  "/masterbankaccountprovider/list";
//GET_BANK_ACCOUNT_STATUS_DATA_API
export const GET_BANK_ACCOUNT_STATUS_DATA_API = "/bankaccountstatus/data";
//CREATE_BANK_ACCOUNT_STATUS_API
export const CREATE_BANK_ACCOUNT_STATUS_API = "/bankaccountstatus/create";
//UPDATE_BANK_ACCOUNT_STATUS_API
export const UPDATE_BANK_ACCOUNT_STATUS_API = "/bankaccountstatus/update";
//DELETE_BANK_ACCOUNT_STATUS_API
export const DELETE_BANK_ACCOUNT_STATUS_API = "/bankaccountstatus/delete";
//CREATE_BANK_ACCOUNT_FEED_CONNECTION_API
export const CREATE_BANK_ACCOUNT_FEED_CONNECTION_API =
  "/bankaccountfeed/connectionrequest";
//BANK_ACCOUNT_FEED_MAP_ACCOUNTS_API
export const BANK_ACCOUNT_FEED_MAP_ACCOUNTS_API =
  "/bankaccountfeed/mapaccounts";
//BANK_TRANSACTION_IMPORT_API
export const BANK_TRANSACTION_IMPORT_API = "/banktransaction/import";
//BANK_TRANSACTION_ALLOCATION_UNCLEAR_API
export const BANK_TRANSACTION_ALLOCATION_UNCLEAR_API =
  "/banktransactionallocation/unclear";
//BANK_TRANSACTION_ALLOCATION_SPLIT_API
export const BANK_TRANSACTION_ALLOCATION_SPLIT_API =
  "/banktransactionallocation/split";
//BANK_ACCOUNT_FEED_RECONNECTION_API
export const BANK_ACCOUNT_FEED_RECONNECTION_API =
  "/bankaccountfeed/reconnectionrequest";
//SEARCH_CLEARING_DOCUMENT_API
export const SEARCH_CLEARING_DOCUMENT_API = "/clearingdocument/search";
//BANK_TRANSACTION_ALLOCATION_AUTO_CLEAR_API_CALL
export const BANK_TRANSACTION_ALLOCATION_AUTO_CLEAR_API_CALL =
  "/banktransactionallocation/autoclear";

// Navigation Menu API Calls
// Get Navigation Menu API Call
export const GET_NAVIGATION_MENU = "/menunavstructure/search";
//GET_MENU_NAVIGATION_LIST_API
export const GET_MENU_NAVIGATION_LIST_API = "/menunav/list";
//CREATE_SINGLE_MENU_NAVIGATION_API
export const CREATE_SINGLE_MENU_NAVIGATION_API = "/menunav/create";
//UPDATE_SINGLE_MENU_NAVIGATION_API
export const UPDATE_SINGLE_MENU_NAVIGATION_API = "/menunav/update";
//DELETE_SINGLE_MENU_NAVIGATION_API
export const DELETE_SINGLE_MENU_NAVIGATION_API = "/menunav/delete";
//GET_AVAILABLE_MENU_NAVIGATION_ITEMS_API
export const GET_AVAILABLE_MENU_NAVIGATION_ITEMS_API = "/menunavoption/list";
//GET_SINGLE_NAVIGATION_MENU_API
export const GET_SINGLE_NAVIGATION_MENU_API = "/menunav/data";
//GET_MENU_ITEM_LIST_API
export const GET_MENU_ITEM_LIST_API = "/menunavitem/list";
//GET_SINGLE_MENU_ITEM_DATA_API
export const GET_SINGLE_MENU_ITEM_DATA_API = "/menunavitem/data";
//CREATE_SINGLE_MENU_ITEM_API
export const CREATE_SINGLE_MENU_ITEM_API = "/menunavitem/create";
//UPDATE_SINGLE_MENU_ITEM_API
export const UPDATE_SINGLE_MENU_ITEM_API = "/menunavitem/update";
//DELETE_SINGLE_MENU_ITEM_API
export const DELETE_SINGLE_MENU_ITEM_API = "/menunavitem/delete";
//CREATE_MASTER_MENU_NAV_ITEM_API
export const CREATE_MASTER_MENU_NAV_ITEM_API = "/menunavoption/create";
// Task 24886 - global (platform-wide) menus. These live in ZCRM_Master and are
// rolled out into every company database, so they are Super Admin routes and
// carry the developer filter server side.
export const GET_MASTER_MENU_NAV_LIST_API = "/mastermenunav/list";
export const GET_MASTER_MENU_NAV_DATA_API = "/mastermenunav/data";
export const CREATE_MASTER_MENU_NAV_API = "/mastermenunav/create";
export const UPDATE_MASTER_MENU_NAV_API = "/mastermenunav/update";
export const DELETE_MASTER_MENU_NAV_API = "/mastermenunav/delete";
export const ROLLOUT_MASTER_MENU_NAV_API = "/mastermenunav/rollout";
//
// Loyalty API Calls

// Loyalty List API Call
export const GET_LOYALTY_LIST_API = "/loyaltytransaction/list";
// Loyalty Single Customer Data API Call
export const GET_LOYALTY_SINGLE_CUSTOMER_DATA_API =
  "/loyaltytransaction/search";
// Loyalty Single Customer Balance Search API Call
export const LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_API =
  "/loyaltybalance/search";

// Get Single Customer Acitivities List API Call
export const GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_API =
  "/customerrecentactivity/list";

// Search Single Customer URL LINK List API Call
export const SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_API =
  "/customerurllink/search";
// Search Single customer external api call
export const SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_API =
  "/customerexternalidentification/search";
// Microsoft 365 integration - per-customer overview (live from Graph). The
// customer Id is appended to the path by FetchAPI (GET with { id }).
export const GET_CUSTOMER_MICROSOFT365_OVERVIEW_API = "/microsoft365/overview";
// Product external ids (e.g. Microsoft 365 SKU GUID mapped to a product).
export const SEARCH_SINGLE_PRODUCT_EXTERNAL_IDS_LIST_API =
  "/productexternalidentification/search";
export const CREATE_SINGLE_PRODUCT_EXTERNAL_IDS_API =
  "/productexternalidentification/create";
export const UPDATE_SINGLE_PRODUCT_EXTERNAL_IDS_API =
  "/productexternalidentification/update";
export const DELETE_SINGLE_PRODUCT_EXTERNAL_IDS_API =
  "/productexternalidentification/delete";
// Master catalogue of external identification providers (Super Admin) + used to
// map per-company providers to the master list.
export const MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_API =
  "/masterexternalidentificationprovider/list";
export const MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_CREATE_API =
  "/masterexternalidentificationprovider/create";
export const MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_UPDATE_API =
  "/masterexternalidentificationprovider/update";
export const MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_DELETE_API =
  "/masterexternalidentificationprovider/delete";
//GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_API
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_API =
  "/customersitelocation/search";
//GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_API
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_API =
  "/customersitelocation/data";
//ADD_SINGLE_CUSTOMER_SITE_LOCATION_API
export const ADD_SINGLE_CUSTOMER_SITE_LOCATION_API =
  "/customersitelocation/create";
//UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_API
export const UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_API =
  "/customersitelocation/update";
//DELETE_SINGLE_CUSTOMER_SITE_LOCATION_API
export const DELETE_SINGLE_CUSTOMER_SITE_LOCATION_API =
  "/customersitelocation/delete";
//GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_API
export const GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_API = "/customerurllink/data";
//CREATE_SINGLE_CUSTOMER_URL_LINK_API
export const CREATE_SINGLE_CUSTOMER_URL_LINK_API = "/customerurllink/create";
//UPDATE_SINGLE_CUSTOMER_URL_LINK_API
export const UPDATE_SINGLE_CUSTOMER_URL_LINK_API = "/customerurllink/update";
//DELETE_SINGLE_CUSTOMER_URL_LINK_API
export const DELETE_SINGLE_CUSTOMER_URL_LINK_API = "/customerurllink/delete";
//GET_CUSTOMER_URL_LINK_STATUS_LIST_API
export const GET_CUSTOMER_URL_LINK_STATUS_LIST_API =
  "/customerurllinkstatus/list";
//GET_CUSTOMER_URL_LINK_STATUS_DETAILS_API
export const GET_CUSTOMER_URL_LINK_STATUS_DETAILS_API =
  "/customerurllinkstatus/data";
//CREATE_CUSTOMER_URL_LINK_STATUS_API
export const CREATE_CUSTOMER_URL_LINK_STATUS_API =
  "/customerurllinkstatus/create";
//UPDATE_CUSTOMER_URL_LINK_STATUS_API
export const UPDATE_CUSTOMER_URL_LINK_STATUS_API =
  "/customerurllinkstatus/update";
//DELETE_CUSTOMER_URL_LINK_STATUS_API
export const DELETE_CUSTOMER_URL_LINK_STATUS_API =
  "/customerurllinkstatus/delete";
//GET_CUSTOMER_URL_LINK_TYPE_LIST_API
export const GET_CUSTOMER_URL_LINK_TYPE_LIST_API = "/customerurllinktype/list";
//GET_CUSTOMER_URL_LINK_TYPE_DETAILS_API
export const GET_CUSTOMER_URL_LINK_TYPE_DETAILS_API =
  "/customerurllinktype/data";
//CREATE_CUSTOMER_URL_LINK_TYPE_API
export const CREATE_CUSTOMER_URL_LINK_TYPE_API = "/customerurllinktype/create";
//UPDATE_CUSTOMER_URL_LINK_TYPE_API
export const UPDATE_CUSTOMER_URL_LINK_TYPE_API = "/customerurllinktype/update";
//DELETE_CUSTOMER_URL_LINK_TYPE_API
export const DELETE_CUSTOMER_URL_LINK_TYPE_API = "/customerurllinktype/delete";
//GET_CUSTOMERS_DEBIT_BALANCE_LIST_API
export const GET_CUSTOMERS_DEBIT_BALANCE_LIST_API =
  "/customer/list/balances/debit";
//GET_CUSTOMERS_OVERDUE_BALANCE_LIST_API
export const GET_CUSTOMERS_OVERDUE_BALANCE_LIST_API =
  "/customer/list/balances/overdue";
//GET_CUSTOMERS_BALANCE_LIST_ALL_API
export const GET_CUSTOMERS_BALANCE_LIST_ALL_API = "/customer/list/balances";
//CLEAR_CUSTOMER_TRANSACTIONS_LIST_API
export const CLEAR_CUSTOMER_TRANSACTIONS_LIST_API =
  "/customertransactionfinancial/search";
//GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_API
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_API =
  "/customerexternalidentification/data";
//CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_API
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_API =
  "/customerexternalidentification/create";
//UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_API
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_API =
  "/customerexternalidentification/update";
//DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_API
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_API =
  "/customerexternalidentification/delete";
//GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_API
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_API =
  "/externalidentificationprovider/list";
//GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_API
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_API =
  "/externalidentificationprovider/data";
// CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API =
  "/externalidentificationprovider/create";
//UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API =
  "/externalidentificationprovider/update";
//DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API =
  "/externalidentificationprovider/delete";
//GET_CUSTOMER_STATUS_LIST_DATA_API
export const GET_CUSTOMER_STATUS_LIST_DATA_API = "/customerstatus/list";
//GET_CUSTOMER_STATUS_DETAILS_API
export const GET_CUSTOMER_STATUS_DETAILS_API = "/customerstatus/data";
//CREATE_CUSTOMER_STATUS_API
export const CREATE_CUSTOMER_STATUS_API = "/customerstatus/create";
//UPDATE_CUSTOMER_STATUS_API
export const UPDATE_CUSTOMER_STATUS_API = "/customerstatus/update";
//DELETE_CUSTOMER_STATUS_API
export const DELETE_CUSTOMER_STATUS_API = "/customerstatus/delete";
//GET_CUSTOMER_TYPE_LIST_DATA_API
export const GET_CUSTOMER_TYPE_LIST_DATA_API = "/customertype/list";
//GET_CUSTOMER_TYPE_DETAILS_API
export const GET_CUSTOMER_TYPE_DETAILS_API = "/customertype/data";
//CREATE_CUSTOMER_TYPE_API
export const CREATE_CUSTOMER_TYPE_API = "/customertype/create";
//UPDATE_CUSTOMER_TYPE_API
export const UPDATE_CUSTOMER_TYPE_API = "/customertype/update";
//DELETE_CUSTOMER_TYPE_API
export const DELETE_CUSTOMER_TYPE_API = "/customertype/delete";
//EXPORT_CONTACTS_API
export const EXPORT_CONTACTS_API = "/thirdpartymailchimp/export/contacts";
//SEARCH_CUSTOMER_API
export const SEARCH_CUSTOMER_API = "/customer/search";
//GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_API
export const GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_API =
  "/customerbalancehistorical/availabledates";
//GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_API
export const GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_API =
  "/customerbalancehistorical/specificdate";
export const GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_API =
  "/customerbalancehistorical/listbycustomer";
//SEARCH_CUSTOMER_NOTE_API
export const SEARCH_CUSTOMER_NOTE_API = "/customernote/search";
//CREATE_CUSTOMER_NOTE_API
export const CREATE_CUSTOMER_NOTE_API = "/customernote/create";

// Loyalty Balances List API Call
export const GET_LOYALTY_BALANCES_LIST_API = "/loyaltybalance/list";

// Loyalty Vouchers List API Call
export const GET_LOYALTY_VOUCHERS_LIST_API = "/loyaltyvoucher/list";

// Loyalty Dashboard Recent activity List API Call
export const GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_API =
  "/loyaltyrecentactivity/list";

// Loyalty Dashboard Report Data Search API Call
export const SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_API = "/loyaltyreport/data";

// Business Overview Dashboard Data API Call
export const BUSINESS_OVERVIEW_DATA_API = "/businessoverview/data";

// Create Loyalty Transaction API Call
export const CREATE_LOYALTY_TRANSACTION_API = "/loyaltytransaction/create";

// Loyalty Create Voucher Amount API Call
export const CREATE_LOYALTY_VOUCHER_AMOUNT_API = "/loyaltyvoucher/create";

// Loyalty RedeemVoucher API Call
export const REDEEM_LOYALTY_VOUCHER_API = "/loyaltyvoucher/redeem";
// Void Voucher API Call
export const VOID_LOYALTY_VOUCHER_API = "/loyaltyvoucher/void";

// Loyalty Resend Voucher API Call
export const RESEND_LOYALTY_VOUCHER_API = "/loyaltyvoucher/resendemail";
// Loyalty Single Customer Voucher List
export const GET_LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_API =
  "/loyaltyvoucher/search";

// Loyalty Spinner API Calls
export const GET_LOYALTY_SPINNER_LIST_API = "/loyaltyspinner/list";
export const CREATE_LOYALTY_SPINNER_API = "/loyaltyspinner/create";
export const UPDATE_LOYALTY_SPINNER_API = "/loyaltyspinner/update";
export const DELETE_LOYALTY_SPINNER_API = "/loyaltyspinner/delete";
export const GET_LOYALTY_SPINNER_RENDER_API = "/loyaltyspinner/render";
export const GET_LOYALTY_SPINNER_DATA_API = "/loyaltyspinner/data";
export const EXECUTE_LOYALTY_SPINNER_API = "/loyaltyspinner/execute";
// Task 24787 - staff unlock a PIN-gated spinner through this before they can
// spin. Public, like render and execute: the spinner page has no login.
export const VERIFY_LOYALTY_SPINNER_PIN_API = "/loyaltyspinner/verifypin";

// Loyalty Portal — public (customer-facing) endpoints
export const LOYALTY_PORTAL_RENDER_API = "/loyaltyportalpublic/render";
export const LOYALTY_AUTH_SEND_CODE_API = "/loyaltyauth/sendcode";
export const LOYALTY_AUTH_VERIFY_CODE_API = "/loyaltyauth/verifycode";
export const LOYALTY_ACCOUNT_DASHBOARD_API = "/loyaltyaccount/dashboard";

// Loyalty Portal — admin CRUD endpoints
export const GET_LOYALTY_PORTAL_LIST_API = "/loyaltyportal/list";
export const GET_LOYALTY_PORTAL_DATA_API = "/loyaltyportal/data";
export const CREATE_LOYALTY_PORTAL_API = "/loyaltyportal/create";
export const UPDATE_LOYALTY_PORTAL_API = "/loyaltyportal/update";
export const DELETE_LOYALTY_PORTAL_API = "/loyaltyportal/delete";

// Loyalty Scheme list (for the portal admin dropdown)
export const GET_LOYALTY_SCHEME_LIST_API = "/loyaltyscheme/list";

// Time Entries API Calls
// Get "TimeEntry List" Api Call
export const GET_TIME_ENTRIES_LIST_API_CALL = "/timeentry/list";

// POST "TimeEntry List/Open" Api Call
export const TIME_ENTRY_LIST_OPEN_API_CALL = "/timeentry/list/open";

// POST "TimeEntry Start" Api Call
export const TIME_ENTRY_START_API_CALL = "/timeentry/singletimerstart";

// POST "TimeEntry Stop" Api Call
export const TIME_ENTRY_STOP_API_CALL = "/timeentry/singletimerstop";

// POST "TimeEntry Search by staff ID" Api Call
export const TIME_ENTRY_SEARCH_BY_STAFF_ID_API_CALL = "/timeentry/search";

// Get "TimeEntry Type List" Api Call
export const GET_TIME_ENTRY_TYPE_LIST_API_CALL =
  "/timeentrytypeunbillable/list";

// Time Entries Update Single Time Entry Api Call
export const TIME_ENTRY_SINGLE_ENTRY_UPDATE_API_CALL =
  "/timeentry/singletimerupdate";

// Time Entry Search with Today's Date Api Call
export const TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_API_CALL = "/timeentry/search";
//ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL
export const ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL =
  "/timeentrytypeunbillable/create";
//DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL
export const DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL =
  "/timeentrytypeunbillable/delete";
//UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL
export const UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL =
  "/timeentrytypeunbillable/update";
//DELETE_SELECTED_TIME_ENTRIES_API_CALL
export const DELETE_SELECTED_TIME_ENTRIES_API_CALL = "/timeentry/delete";
//TIME_ENTRY_LIST_SUMMARY_DAILY_API_CALL
export const TIME_ENTRY_LIST_SUMMARY_DAILY_API_CALL =
  "/timeentry/list/summary/daily";
//TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_API_CALL
export const TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_API_CALL =
  "/timeentry/list/summary/daily/byactivity";
//TIME_ENTRY_CREATE_API_CALL
export const TIME_ENTRY_CREATE_API_CALL = "/timeentry/create";
//************************************//

//PROTOTYPING API CALLS
export const POST_PROTOTYPING_API_CALL = "/purchase/upload";
//************  API Calls ************//
// CRMit Email Inbox API Call EmailInbound

// EmailInbound List API Call
export const GET_EMAILINBOUND_LIST = "/emailinbound/list";

// EmailInbound Single API Call
export const GET_EMAILINBOUND_SINGLE = "/emailinbound/data";

// EmailInbound Archive API Call
export const PUT_EMAILINBOUND_ARCHIVE = "/emailinbound/archive";

// EmailInbound MarkedRead API Call
export const PUT_EMAILINBOUND_MARKEDREAD = "/emailinbound/markread";
// Email Outbound Send API Call
export const SEND_EMAILOUTBOUND_EMAIL = "/emailoutbound/sendmail";
// Email Inbound Update Staff API Call
export const UPDATE_EMAILINBOUND_STAFF = "/emailinbound/update";
//Email Outbound Account List APi Call
export const GET_EMAILOUTBOUND_ACCOUNT_LIST_API =
  "/emailaccount/list/outbound/server";
// Email Inbound Unarchive email API Call
export const UNARCHIVE_EMAILINBOUND_EMAIL = "/emailinbound/unarchive";
//MARK_EMAILINBOUND_AS_UNREAD
export const MARK_EMAILINBOUND_AS_UNREAD = "/emailinbound/markunread";
//GET_EMAIL_ACCOUNT_LIST_API_CALL
export const GET_EMAIL_ACCOUNT_LIST_API_CALL = "/emailaccount/list";
//GET_EMAIL_ACCOUNT_DETAILS_API_CALL
export const GET_EMAIL_ACCOUNT_DETAILS_API_CALL = "/emailaccount/data";
//CREATE_EMAIL_ACCOUNT_API_CALL
export const CREATE_EMAIL_ACCOUNT_API_CALL = "/emailaccount/create";
//UPDATE_EMAIL_ACCOUNT_API_CALL
export const UPDATE_EMAIL_ACCOUNT_API_CALL = "/emailaccount/update";
//DELETE_EMAIL_ACCOUNT_API_CALL
export const DELETE_EMAIL_ACCOUNT_API_CALL = "/emailaccount/delete";
//JOB_EMAIL_INBOUND_SEARCH_API_CALL
export const JOB_EMAIL_INBOUND_SEARCH_API_CALL =
  "/jobtoemailinbound/search/emails";
// Change #100151 - emails filed against an opportunity by its email tag
export const OPPORTUNITY_EMAIL_INBOUND_SEARCH_API_CALL =
  "/opportunitytoemailinbound/search/emails";
//LINK_JOB_TO_EMAIL_API_CALL
export const LINK_JOB_TO_EMAIL_API_CALL = "/jobtoemailinbound/create";
//EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_API_CALL
export const EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_API_CALL =
  "/emailoutbound/search/addressbook";
//EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_API_CALL
export const EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_API_CALL =
  "/emailoutbound/search/availableattachments";
//EMAIL_TEMPLATE_LIST_API_CALL
export const EMAIL_TEMPLATE_LIST_API_CALL = "/emailtemplate/list";
//EMAIL_TEMPLATE_SEARCH_API_CALL
export const EMAIL_TEMPLATE_SEARCH_API_CALL = "/emailtemplate/search";
//GET_EMAIL_TEMPLATE_DATA_API_CALL
export const GET_EMAIL_TEMPLATE_DATA_API_CALL = "/emailtemplate/data";
//CREATE_EMAIL_TEMPLATE_API_CALL
export const CREATE_EMAIL_TEMPLATE_API_CALL = "/emailtemplate/create";
//UPDATE_EMAIL_TEMPLATE_API_CALL
//UPDATE_EMAIL_TEMPLATE_API_CALL
export const UPDATE_EMAIL_TEMPLATE_API_CALL = "/emailtemplate/update";
//DELETE_EMAIL_TEMPLATE_API_CALL
export const DELETE_EMAIL_TEMPLATE_API_CALL = "/emailtemplate/delete";
//SEND_EMAIL_OUTBOUND_SCHEDULED_API_CALL
export const SEND_EMAIL_OUTBOUND_SCHEDULED_API_CALL =
  "/emailoutbound/sendmail/scheduled";
//EMAIL_DOMAIN_LIST_API_CALL
export const EMAIL_DOMAIN_LIST_API_CALL = "/emaildomain/list";
//EMAIL_DOMAIN_DATA_API_CALL
export const EMAIL_DOMAIN_DATA_API_CALL = "/emaildomain/data";
//CREATE_EMAIL_DOMAIN_API_CALL
export const CREATE_EMAIL_DOMAIN_API_CALL = "/emaildomain/create";
//CHECK_EMAIL_DOMAIN_DNS_API_CALL
export const CHECK_EMAIL_DOMAIN_DNS_API_CALL = "/emaildomain/checkdns";
//DELETE_EMAIL_DOMAIN_API_CALL
export const DELETE_EMAIL_DOMAIN_API_CALL = "/emaildomain/delete";
//EMAIL_INBOUND_REPLY_AUTOGENERATE_API_CALL
export const EMAIL_INBOUND_REPLY_AUTOGENERATE_API_CALL =
  "/emailinbound/reply/autogenerate";

//EMAIL_INBOUND_RULE_LIST_API_CALL
export const EMAIL_INBOUND_RULE_LIST_API_CALL = "/emailinboundrule/list";
//EMAIL_INBOUND_RULE_SEARCH_API_CALL
export const EMAIL_INBOUND_RULE_SEARCH_API_CALL = "/emailinboundrule/search";
//GET_EMAIL_INBOUND_RULE_DATA_API_CALL
export const GET_EMAIL_INBOUND_RULE_DATA_API_CALL = "/emailinboundrule/data";
//CREATE_EMAIL_INBOUND_RULE_API_CALL
export const CREATE_EMAIL_INBOUND_RULE_API_CALL = "/emailinboundrule/create";
//UPDATE_EMAIL_INBOUND_RULE_API_CALL
export const UPDATE_EMAIL_INBOUND_RULE_API_CALL = "/emailinboundrule/update";
//DELETE_EMAIL_INBOUND_RULE_API_CALL
export const DELETE_EMAIL_INBOUND_RULE_API_CALL = "/emailinboundrule/delete";
//RUN_EMAIL_INBOUND_RULE_API_CALL
export const RUN_EMAIL_INBOUND_RULE_API_CALL = "/emailinboundrule/run";
//EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_API_CALL
export const EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_API_CALL =
  "/emailinboundruleitemfield/list";
//SYSTEM_FUNCTION_OPERAND_LIST_API_CALL
export const SYSTEM_FUNCTION_OPERAND_LIST_API_CALL =
  "/systemfunctionoperand/list";

// Get Archived Email List API Call
export const GET_ARCHIVED_EMAIL_LIST = "/emailinbound/listarchived";

// ********* Invoice API Calls *********//
// Get Invoice List API Call
export const GET_INVOICE_LIST = "/invoice/list";

// Get Invoice Status List API Call
export const GET_INVOICE_STATUS_List = "/invoicestatus/list";

// GEt Single Invoice PDF API Call

export const GET_INVOICE_SINGLE_PDF = "/invoice/pdf";
// Get Single Invoice Data API Call

export const GET_SINGLE_INVOICE_DATA = "/invoice/data";

// Create Single Invoice Data API Call

export const CREATE_SINGLE_INVOICE_DATA = "/invoice/create";

// Update Single Invoice Data API Call

// Single Customer Invoice List API Call
export const SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_API = "/invoice/search";

export const UPDATE_SINGLE_INVOICE_DATA = "/invoice/update";
// Resend Invoice Email API Call
export const RESEND_INVOICE_EMAIL_API_CALL = "/invoice/emailresend/automated";
// Send Invoice Email API Call
export const SEND_INVOICE_EMAIL_API_CALL = "/invoice/emailsend/automated";
// VOID_INVOICE_API_CALL
export const VOID_INVOICE_API_CALL = "/invoice/void";
// REINVOICE_API_CALL
export const REINVOICE_API_CALL = "/invoice/reinvoice";
//ADD_NEW_INVOICE_STATUS_API_CALL
export const ADD_NEW_INVOICE_STATUS_API_CALL = "/invoicestatus/create";
//DELETE_INVOICE_STATUS_API_CALL
export const DELETE_INVOICE_STATUS_API_CALL = "/invoicestatus/delete";
//UPDATE_INVOICE_STATUS_API_CALL
export const UPDATE_INVOICE_STATUS_API_CALL = "/invoicestatus/update";
//GET_INVOICE_PAYMENT_METHOD_LIST_API_CALL
export const GET_INVOICE_PAYMENT_METHOD_LIST_API_CALL = "/paymentmethod/list";
//ADD_NEW_INVOICE_PAYMENT_METHOD_API_CALL
export const ADD_NEW_INVOICE_PAYMENT_METHOD_API_CALL = "/paymentmethod/create";
//DELETE_INVOICE_PAYMENT_METHOD_API_CALL
export const DELETE_INVOICE_PAYMENT_METHOD_API_CALL = "/paymentmethod/delete";
//UPDATE_INVOICE_PAYMENT_METHOD_API_CALL
export const UPDATE_INVOICE_PAYMENT_METHOD_API_CALL = "/paymentmethod/update";
//GET_MASTER_INVOICE_LIST_API_CALL
export const GET_MASTER_INVOICE_LIST_API_CALL = "/masterinvoice/list";
//GET_MASTER_INVOICE_SINGLE_DATA_API_CALL
export const GET_MASTER_INVOICE_SINGLE_DATA_API_CALL = "/masterinvoice/data";
//GET_CRMIT_INVOICE_SINGLE_DATA_API_CALL
export const GET_CRMIT_INVOICE_SINGLE_DATA_API_CALL = "/masterinvoice/pdf";
//GET_INVOICE_ITEM_LIST_API_CALL
export const GET_INVOICE_ITEM_LIST_API_CALL = "/invoiceitem/list";
//GET_MASTER_INVOICE_LIST_CUSTOMER_API_CALL
export const GET_MASTER_INVOICE_LIST_CUSTOMER_API_CALL =
  "/masterinvoice/list/customer";
//SEARCH_INVOICE_ACTIVITY_LOG_API_CALL
export const SEARCH_INVOICE_ACTIVITY_LOG_API_CALL =
  "/invoiceactivitylog/search";
//SEARCH_INVOICE_ITEMS_LIST_API_CALL
export const SEARCH_INVOICE_ITEMS_LIST_API_CALL = "/invoiceitem/search";
//GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_API_CALL
export const GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_API_CALL =
  "/jobinvoiceitemtemplate/list";
//GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_API_CALL
export const GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_API_CALL =
  "/jobinvoiceitemtemplate/data";
//SEARCH_JOB_INVOICE_ITEM_TEMPLATE_API_CALL
export const SEARCH_JOB_INVOICE_ITEM_TEMPLATE_API_CALL =
  "/jobinvoiceitemtemplate/search";
//CREATE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL
export const CREATE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL =
  "/jobinvoiceitemtemplate/create";
//UPDATE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL
export const UPDATE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL =
  "/jobinvoiceitemtemplate/update";
//DELETE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL
export const DELETE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL =
  "/jobinvoiceitemtemplate/delete";
//********* Calendar API DATA CALLS*********//
// Get Staff Leave List API Call
export const GET_STAFF_LEAVE_LIST = "/staffleave/list";

// Get Staff Leave Type API Call
export const GET_STAFF_LEAVE_TYPE = "/staffleavetype/list";
//********* Product API Calls *********//
// Get Product List API Call
export const GET_PRODUCT_LIST = "/product/list";

// Get Product Unit Type List API Call
export const GET_PRODUCT_UNIT_TYPE_LIST = "/unittype/list";
//ADD_PRODUCT_UNIT_TYPE
export const ADD_PRODUCT_UNIT_TYPE = "/unittype/create";
//UPDATE_PRODUCT_UNIT_TYPE
export const UPDATE_PRODUCT_UNIT_TYPE = "/unittype/update";
//DELETE_PRODUCT_UNIT_TYPE
export const DELETE_PRODUCT_UNIT_TYPE = "/unittype/delete";
//GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_API
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_API =
  "/productstockstoragelocation/list";
//GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_API
export const GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_API =
  "/productstockstoragelocation/data";
//CREATE_PRODUCT_STOCK_STORAGE_LOCATION_API
export const CREATE_PRODUCT_STOCK_STORAGE_LOCATION_API =
  "/productstockstoragelocation/create";
//UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_API
export const UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_API =
  "/productstockstoragelocation/update";
//DELETE_PRODUCT_STOCK_STORAGE_LOCATION_API
export const DELETE_PRODUCT_STOCK_STORAGE_LOCATION_API =
  "/productstockstoragelocation/delete";
//GET_PRODUCT_STOCK_LIST_API
export const GET_PRODUCT_STOCK_LIST_API = "/productstock/list";
//SEARCH_PRODUCT_STOCK_API
export const SEARCH_PRODUCT_STOCK_API = "/productstock/search";
//SEARCH_PRODUCT_STOCK_TRANSACTION_API
export const SEARCH_PRODUCT_STOCK_TRANSACTION_API =
  "/productstocktransaction/search";
//GET_PRODUCT_STOCK_TRANSACTION_LIST_API
export const GET_PRODUCT_STOCK_TRANSACTION_LIST_API =
  "/productstocktransaction/list";
//ADD_PRODUCT_STOCK_TRANSACTION_API
export const ADD_PRODUCT_STOCK_TRANSACTION_API = "/productstocktransaction/add";
//MOVE_PRODUCT_STOCK_TRANSACTION_API
export const MOVE_PRODUCT_STOCK_TRANSACTION_API =
  "/productstocktransaction/move";
//REDUCE_PRODUCT_STOCK_TRANSACTION_API
export const REDUCE_PRODUCT_STOCK_TRANSACTION_API =
  "/productstocktransaction/reduce";
//Product Stock Transaction Reason (reduction reason picklist)
export const GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_API =
  "/productstocktransactionreason/list";
export const GET_PRODUCT_STOCK_TRANSACTION_REASON_DATA_API =
  "/productstocktransactionreason/data";
export const CREATE_PRODUCT_STOCK_TRANSACTION_REASON_API =
  "/productstocktransactionreason/create";
export const UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_API =
  "/productstocktransactionreason/update";
export const DELETE_PRODUCT_STOCK_TRANSACTION_REASON_API =
  "/productstocktransactionreason/delete";
//GET_UNIT_MEASUREMENT_LIST_API
export const GET_UNIT_MEASUREMENT_LIST_API = "/unitmeasurement/list";

// Customer API CALLS

// GET Customer List data "Read"
export const GET_CUSTOMERS_LIST_DATA = "/customer/list";
// GET Customer data "Read"
export const V2_GET_CUSTOMERS_DATA = "/customer/data";
// Create New Customer "Create"
export const V2_ADD_NEW_CUSTOMER = "/customer/create";
// Update Customer "Update"
export const V2_UPDATE_CUSTOMER = "/customer/update";
// Delete Customer "Delete"
export const V2_DELETE_CUSTOMER = "/customer/delete";

// Create Single Customer API Call
export const CREATE_SINGLE_CUSTOMER_API = "/customer/create";

//JOB API CALLS
//Read
export const API_ENGINE_LOOP = "/systemdataupdatecheck/list";
//Create
export const ADD_JOBS_DATA = "/job/create";
//Read
export const GET_JOBS_DATA = "/job/list";
//Update
export const UPDATE_JOBS_DATA = "/job/update";
//Delete
export const DELETE_JOBS_DATA = "/job/delete";
//Read Single job pdf page
export const GET_JOBS_PDF_DATA = "/job/pdfjobsheet";

//******************************//
// JOB notes single and list
//Read List
export const GET_JOBS_NOTES_DATA = "/jobnote/search";

//Read Single
export const GET_JOBS_NOTES_SINGLE_DATA = "/jobnote/data";

//Create Single
export const ADD_JOBS_NOTES_DATA = "/jobnote/create";
// Get Uninvoiced Jobs List API call
export const GET_UNINVOICED_JOBS_LIST = "/job/list_uninvoiced";
//MERGE_JOB
export const MERGE_JOB = "/job/merge";

//******************************//
//JOB STATUS API CALLS
//Read
export const GET_JOB_STATUS_DATA = "/jobstatus/list";
//Create
export const ADD_JOB_STATUS_DATA = "/jobstatus/create";
//Update
export const UPDATE_JOB_STATUS_DATA = "/jobstatus/update";
//Delete
export const DELETE_JOB_STATUS_DATA = "/jobstatus/delete";
//******************************//
//Single Job API CALLS
export const CREATE_SINGLE_JOB = "/job/create";

//Read
export const READ_SINGLE_JOB = "/job/data";
//Update
export const UPDATE_SINGLE_JOB = "/job/update";
//Delete
export const DELETE_SINGLE_JOB = "/job/delete";
//Auth Register Login API CALLS

// ******************************//
// Job Types List
// Get Job Types List
export const GET_JOB_TYPES_LIST = "/jobtype/list";

// ******************************//
// Job Priority List
// Get Job Priority List
export const GET_JOB_PRIORITY_LIST = "/jobpriority/list";

// ******************************//
// Job Time Entry API CALLS
export const GET_JOB_TIME_ENTRY_LIST = "/jobtimeentry/search";
export const CREATE_JOB_TIME_ENTRY = "/jobtimeentry/create";
export const JOB_TIME_ENTRY_REPORT_API = "/jobtimeentry/report";
export const PLACEMENT_REVENUE_REPORT_API = "/staffshift/report";

// Invoicing report suite (Task 24523). All POST, all AUTHCAP1373X.
export const INVOICE_REPORT_VOLUMES_API = "/invoice/report/volumes";
export const INVOICE_REPORT_AGED_DEBTORS_API = "/invoice/report/ageddebtors";
export const INVOICE_REPORT_CREDIT_NOTES_API = "/invoice/report/creditnotes";
export const INVOICE_REPORT_VAT_API = "/invoice/report/vat";
export const INVOICE_REPORT_PAYMENT_PERFORMANCE_API =
  "/invoice/report/paymentperformance";

// Manual ordering of a job's billing lines (Task 24532).
export const JOB_INVOICE_ITEM_REORDER_API = "/jobinvoiceitem/reorder";
export const JOB_PREDICTED_BILLABLE_ITEM_REORDER_API =
  "/jobpredictedbillableitem/reorder";

// Purchase line marked as never billable (Task 24518).
export const PURCHASE_ITEM_MARK_IGNORED_API = "/purchaseitem/markignored";
export const FOOD_PREORDER_EVENT_REPORT_API = "/foodpreorderevent/report";
export const FOOD_PREORDER_EVENT_REPORT_FUNNEL_API =
  "/foodpreorderevent/report/funnel";
export const FOOD_PREORDER_EVENT_REPORT_REVENUE_API =
  "/foodpreorderevent/report/revenue";
export const FOOD_PREORDER_EVENT_REPORT_MENUITEMS_API =
  "/foodpreorderevent/report/menuitems";
export const FOOD_PREORDER_EVENT_REPORT_DIETARY_API =
  "/foodpreorderevent/report/dietary";
export const FOOD_PREORDER_EVENT_REPORT_DEPOSITS_API =
  "/foodpreorderevent/report/deposits";
export const FOOD_PREORDER_EVENT_REPORT_UPCOMING_API =
  "/foodpreorderevent/report/upcoming";
export const FOOD_TABLE_RESERVATION_REPORT_SUMMARY_API =
  "/foodtablereservation/report/summary";
export const FOOD_TABLE_RESERVATION_REPORT_PATTERNS_API =
  "/foodtablereservation/report/patterns";
export const FOOD_TABLE_RESERVATION_REPORT_DEPOSITS_API =
  "/foodtablereservation/report/deposits";
export const FOOD_TABLE_RESERVATION_REPORT_LIST_API =
  "/foodtablereservation/report/list";
//Standby / turn-down log (Task 24337) — feeds the Turn Downs report (Task 24420)
export const FOOD_TABLE_RESERVATION_STANDBY_REPORT_API =
  "/foodtablereservationstandby/report";

// ******************************//
// Task Time Entry API CALLS
export const SEARCH_TASK_TIME_ENTRY_LIST_API = "/tasktimeentry/search";
export const CREATE_TASK_TIME_ENTRY_API = "/tasktimeentry/create";

// ******************************//

// Single Job Attachment List Api Call
export const GET_SINGLE_JOB_ATTACHMENT_LIST = "/jobattachment/search";
// Single Customer  Jobs List Api Call

export const GET_SINGLE_CUSTOMER_JOBS_LIST = "/job/search";

// Single Job RecentActivity List Api Call
export const GET_SINGLE_JOB_RECENT_ACTIVITY_LIST = "/jobrecentactivity/list";
//GET_SINGLE_JOB_ATTACHMENT_URL
export const GET_SINGLE_JOB_ATTACHMENT_URL = "/fileattachment/dataurl";
//GET_BILLABLE_JOB_ITEMS_LIST
export const GET_BILLABLE_JOB_ITEMS_LIST = "/jobinvoiceitem/search";
//GET_BILLABLE_JOB_ITEM_DETAILS
export const GET_BILLABLE_JOB_ITEM_DETAILS = "/jobinvoiceitem/data";
//CREATE_BILLABLE_JOB_ITEM
export const CREATE_BILLABLE_JOB_ITEM = "/jobinvoiceitem/create";
// Change #100495 - predicted line -> billable line
export const MOVE_PREDICTED_TO_BILLABLE = "/jobpredictedbillableitem/move_to_billable";
//UPDATE_BILLABLE_JOB_ITEM
export const UPDATE_BILLABLE_JOB_ITEM = "/jobinvoiceitem/update";
//DELETE_BILLABLE_JOB_ITEM
export const DELETE_BILLABLE_JOB_ITEM = "/jobinvoiceitem/delete";
//Predicted (forecast) billable items on a job
export const GET_JOB_PREDICTED_BILLABLE_ITEMS_LIST = "/jobpredictedbillableitem/list_by_job";
export const CREATE_JOB_PREDICTED_BILLABLE_ITEM = "/jobpredictedbillableitem/create";
export const UPDATE_JOB_PREDICTED_BILLABLE_ITEM = "/jobpredictedbillableitem/update";
export const DELETE_JOB_PREDICTED_BILLABLE_ITEM = "/jobpredictedbillableitem/delete";
// Mark a predicted billable item as (manually) billed / unbilled — no invoice
export const PREDICTED_MARK_BILLED_API_CALL = "/jobpredictedbillableitem/mark_billed";
// Link a predicted billable item to an existing invoice line item
export const PREDICTED_LINK_TO_INVOICEITEM_API_CALL = "/jobpredictedbillableitem/link_to_invoiceitem";
//Convert Job To Invoice
export const CONVERT_JOB_TO_INVOICE_API_CALL = "/job/converttoinvoice";
//GET_RECURRING_JOBS_LIST
export const GET_RECURRING_JOBS_LIST = "/jobrecurring/list";
//CREATE_RECURRING_JOB_API_CALL
export const CREATE_RECURRING_JOB_API_CALL = "/jobrecurring/create";
//GET_RECURRING_JOB_DETAIL_API_CALL
export const GET_RECURRING_JOB_DETAIL_API_CALL = "/jobrecurring/data";
//UPDATE_RECURRING_JOB_API_CALL
export const UPDATE_RECURRING_JOB_API_CALL = "/jobrecurring/update";
//UPLOAD_JOB_FILES_API_CALL
export const UPLOAD_JOB_FILES_API_CALL = "/fileattachment/create";
//SEARCH_SINGLE_JOB_FILES_LIST_API_CALL
export const SEARCH_SINGLE_JOB_FILES_LIST_API_CALL = "/jobattachment/search";
// ADD_JOB_TYPE_API_CALL
export const ADD_JOB_TYPE_API_CALL = "/jobtype/create";
//DELETE_JOB_TYPE_API_CALL
export const DELETE_JOB_TYPE_API_CALL = "/jobtype/delete";
//UPDATE_JOB_TYPE_API_CALL
export const UPDATE_JOB_TYPE_API_CALL = "/jobtype/update";
// ******************************//
// Attachment Category Type List
// Get Attachment Category Type List
export const GET_ATTACHMENT_CATEGORY_TYPES_LIST =
  "/attachmentcategorytype/list";
// ADD_ATTACHMENT_CATEGORY_TYPE_API_CALL
export const ADD_ATTACHMENT_CATEGORY_TYPE_API_CALL =
  "/attachmentcategorytype/create";
//DELETE_ATTACHMENT_CATEGORY_TYPE_API_CALL
export const DELETE_ATTACHMENT_CATEGORY_TYPE_API_CALL =
  "/attachmentcategorytype/delete";
//UPDATE_ATTACHMENT_CATEGORY_TYPE_API_CALL
export const UPDATE_ATTACHMENT_CATEGORY_TYPE_API_CALL =
  "/attachmentcategorytype/update";
//ADD_JOB_PRIORITY_API_CALL
export const ADD_JOB_PRIORITY_API_CALL = "/jobpriority/create";
//DELETE_JOB_PRIORITY_API_CALL
export const DELETE_JOB_PRIORITY_API_CALL = "/jobpriority/delete";
//UPDATE_JOB_PRIORITY_API_CALL
export const UPDATE_JOB_PRIORITY_API_CALL = "/jobpriority/update";
//DELETE_SINGLE_JOB_FILE_API_CALL
export const DELETE_SINGLE_JOB_FILE_API_CALL = "/jobattachment/delete";
//UPDATE_FILE_ATTACHMENT_API_CALL
export const UPDATE_FILE_ATTACHMENT_API_CALL = "/fileattachment/update";
//GET_JOB_SEARCH_LIST_API_CALL
export const GET_JOB_SEARCH_LIST_API_CALL = "/job/searchlive";
//GET_JOBS_OPEN_LIST_API_CALL
export const GET_JOBS_OPEN_LIST_API_CALL = "/job/list/open";
// Change #100386 - open jobs with no activity in the last X days
export const GET_JOB_LIST_STALE_API = "/job/list/stale";
//GET_READY_TO_INVOICE_JOBS_LIST_API_CALL
export const GET_READY_TO_INVOICE_JOBS_LIST_API_CALL =
  "/job/list/uninvoiced/due";
//MARK_JOB_AS_COMPLETED_API_CALL
export const MARK_JOB_AS_COMPLETED_API_CALL = "/job/markcomplete";
//CONVERT_JOB_TO_PROFORMA_INVOICE_API_CALL
export const CONVERT_JOB_TO_PROFORMA_INVOICE_API_CALL =
  "/job/converttoproformainvoice";
//INVOICES_BY_JOB_API_CALL (id appended as /{id})
export const INVOICES_BY_JOB_API_CALL = "/job/invoices_by_job";
// ******************************//
//Register
export const REGISTER_USER_DATA = "/auth/register/user";
// Token Renew
export const REFRESH_TOKEN_DATA = "/api/tokenrenew";
//LOGIN_WITH_TOKEN_KEY
export const LOGIN_WITH_TOKEN_KEY = "/api/logintokenkey";
//REGISTER_GUEST_TO_EVENT
export const REGISTER_GUEST_TO_EVENT = "/foodpreordereventguest/create";

//Login
export const LOGIN_USER_DATA = "/api/login";

//Staff API CALLS
//Read
export const GET_STAFF_DATA = "/staff/data";
//Create
export const ADD_STAFF_DATA = "/staff/create";
//Update
export const UPDATE_STAFF_DATA = "/staff/update";
//Delete
export const DELETE_STAFF_DATA = "/staff/delete";
//GET_STAFF_LIST
export const GET_STAFF_LIST = "/staff/list";
//SEARCH_STAFF_INCOME_LIST
export const SEARCH_STAFF_INCOME_LIST = "/staffincome/search";
//GET_STAFF_LEAVE_TYPE_LIST
// Task 24489 - the fixed classification behind a leave type.
export const GET_STAFF_LEAVE_CATEGORY_LIST = "/staffleavecategory/list";
export const UPDATE_STAFF_LEAVE_CATEGORY = "/staffleavecategory/update";
export const GET_STAFF_LEAVE_TYPE_LIST = "/staffleavetype/list";
//ADD_STAFF_LEAVE_TYPE
export const ADD_STAFF_LEAVE_TYPE = "/staffleavetype/create";
//UPDATE_STAFF_LEAVE_TYPE
export const UPDATE_STAFF_LEAVE_TYPE = "/staffleavetype/update";
//DELETE_STAFF_LEAVE_TYPE
export const DELETE_STAFF_LEAVE_TYPE = "/staffleavetype/delete";
//CREATE_STAFF_INCOME
export const CREATE_STAFF_INCOME = "/staffincome/create";
//GET_STAFF_INCOME_CATEGORY_ITEM_LIST
export const GET_STAFF_INCOME_CATEGORY_ITEM_LIST =
  "/staffincomeitemcategory/list";
//GET_STAFF_INCOME_CATEGORY_ITEM_DATA
export const GET_STAFF_INCOME_CATEGORY_ITEM_DATA =
  "/staffincomeitemcategory/data";
//CREATE_STAFF_INCOME_CATEGORY_ITEM
export const CREATE_STAFF_INCOME_CATEGORY_ITEM =
  "/staffincomeitemcategory/create";
//UPDATE_STAFF_INCOME_CATEGORY_ITEM
export const UPDATE_STAFF_INCOME_CATEGORY_ITEM =
  "/staffincomeitemcategory/update";
//DELETE_STAFF_INCOME_CATEGORY_ITEM
export const DELETE_STAFF_INCOME_CATEGORY_ITEM =
  "/staffincomeitemcategory/delete";
//GET_STAFF_INCOME_LIST
export const GET_STAFF_INCOME_LIST = "/staffincome/list";
//GET_STAFF_INCOME_DATA
export const GET_STAFF_INCOME_DATA = "/staffincome/data";
//UPDATE_STAFF_INCOME
export const UPDATE_STAFF_INCOME = "/staffincome/update";
//DELETE_STAFF_INCOME
export const DELETE_STAFF_INCOME = "/staffincome/void";
//GET_STAFF_LEAVE_LIST_API
export const GET_STAFF_LEAVE_LIST_API = "/staffleave/list";
//GET_STAFF_LEAVE_DATA
export const GET_STAFF_LEAVE_DATA = "/staffleave/data";
//UPDATE_STAFF_LEAVE
export const UPDATE_STAFF_LEAVE = "/staffleave/update";
//DELETE_STAFF_LEAVE
export const DELETE_STAFF_LEAVE = "/staffleave/void";
//CREATE_STAFF_LEAVE
export const CREATE_STAFF_LEAVE = "/staffleave/create";
//SEARCH_STAFF_LEAVE
export const SEARCH_STAFF_LEAVE = "/staffleave/search";
//GET_STAFF_LEAVE_ALLOWANCE_LIST
export const GET_STAFF_LEAVE_ALLOWANCE_LIST = "/staffleaveallowance/list";
//GET_STAFF_LEAVE_ALLOWANCE_DATA
export const GET_STAFF_LEAVE_ALLOWANCE_DATA = "/staffleaveallowance/data";
//UPDATE_STAFF_LEAVE_ALLOWANCE
export const UPDATE_STAFF_LEAVE_ALLOWANCE = "/staffleaveallowance/update";
//DELETE_STAFF_LEAVE_ALLOWANCE
export const DELETE_STAFF_LEAVE_ALLOWANCE = "/staffleaveallowance/delete";
//CREATE_STAFF_LEAVE_ALLOWANCE
export const CREATE_STAFF_LEAVE_ALLOWANCE = "/staffleaveallowance/create";
//SEARCH_STAFF_LEAVE_ALLOWANCE
export const SEARCH_STAFF_LEAVE_ALLOWANCE = "/staffleaveallowance/search";
//SEARCH_STAFF
export const SEARCH_STAFF = "/staff/search";
//SEARCH_STAFFMEMBER_API
export const SEARCH_STAFF_MEMBER_API = "/staff/search/myteammembers";
//CREATE_STAFF_AND_USER_API
export const CREATE_STAFF_AND_USER_API = "/subscriptionlicence/create/user";
//GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST =
  "/organisationdepartmenttostaff/list";
//GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA =
  "/organisationdepartmenttostaff/data";
//CREATE_ORGANISATION_DEPARTMENT_TO_STAFF
export const CREATE_ORGANISATION_DEPARTMENT_TO_STAFF =
  "/organisationdepartmenttostaff/create";
//SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF
export const SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF =
  "/organisationdepartmenttostaff/search";
//UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF
export const UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF =
  "/organisationdepartmenttostaff/update";
//DELETE_ORGANISATION_DEPARTMENT_TO_STAFF
export const DELETE_ORGANISATION_DEPARTMENT_TO_STAFF =
  "/organisationdepartmenttostaff/delete";
//GET_ORGANISATION_DEPARTMENT_LIST
export const GET_ORGANISATION_DEPARTMENT_LIST = "/organisationdepartment/list";
//GET_ORGANISATION_DEPARTMENT_DATA
export const GET_ORGANISATION_DEPARTMENT_DATA = "/organisationdepartment/data";
//CREATE_ORGANISATION_DEPARTMENT
export const CREATE_ORGANISATION_DEPARTMENT = "/organisationdepartment/create";
//GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY
export const GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY =
  "/organisationdepartment/hierarchy/enquiry";
//UPDATE_ORGANISATION_DEPARTMENT
export const UPDATE_ORGANISATION_DEPARTMENT = "/organisationdepartment/update";
//DELETE_ORGANISATION_DEPARTMENT
export const DELETE_ORGANISATION_DEPARTMENT = "/organisationdepartment/delete";
//GET_STAFF_TO_STAFF_MANAGER_LIST
export const GET_STAFF_TO_STAFF_MANAGER_LIST = "/stafftostaffmanager/list";
//GET_STAFF_TO_STAFF_MANAGER_DATA
export const GET_STAFF_TO_STAFF_MANAGER_DATA = "/stafftostaffmanager/data";
//CREATE_STAFF_TO_STAFF_MANAGER
export const CREATE_STAFF_TO_STAFF_MANAGER = "/stafftostaffmanager/create";
//UPDATE_STAFF_TO_STAFF_MANAGER
export const UPDATE_STAFF_TO_STAFF_MANAGER = "/stafftostaffmanager/update";
//DELETE_STAFF_TO_STAFF_MANAGER
export const DELETE_STAFF_TO_STAFF_MANAGER = "/stafftostaffmanager/delete";
//GET_STAFF_RECENT_ACTIVITY_LIST
export const GET_STAFF_RECENT_ACTIVITY_LIST = "/staffrecentactivity/list";
//STAFF_ACTIVITY_LOG_SEARCH_API (POST) — { Staff_Id, StartDate, EndDate }
export const STAFF_ACTIVITY_LOG_SEARCH_API = "/staffactivitylog/search";
//SEARCH_STAFF_REAL_TIME
export const SEARCH_STAFF_REAL_TIME = "/staff/search/realtime";
//GET_STAFF_SKILL_SET_LIST
export const GET_STAFF_SKILL_SET_LIST = "/staffskillset/list";
//GET_STAFF_SKILL_SET_DATA
export const GET_STAFF_SKILL_SET_DATA = "/staffskillset/data";
//CREATE_STAFF_SKILL_SET
export const CREATE_STAFF_SKILL_SET = "/staffskillset/create";
//UPDATE_STAFF_SKILL_SET
export const UPDATE_STAFF_SKILL_SET = "/staffskillset/update";
//DELETE_STAFF_SKILL_SET
export const DELETE_STAFF_SKILL_SET = "/staffskillset/delete";
//GET_STAFF_TO_STAFF_SKILL_SET_LIST
export const GET_STAFF_TO_STAFF_SKILL_SET_LIST = "/stafftostaffskillset/list";
//GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST
export const GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST =
  "/stafftostaffskillset/list/active";
//GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST
export const GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST =
  "/stafftostaffskillset/list/expired";
//GET_STAFF_TO_STAFF_SKILL_SET_DATA
export const GET_STAFF_TO_STAFF_SKILL_SET_DATA = "/stafftostaffskillset/data";
//CREATE_STAFF_TO_STAFF_SKILL_SET
export const CREATE_STAFF_TO_STAFF_SKILL_SET = "/stafftostaffskillset/create";
//UPDATE_STAFF_TO_STAFF_SKILL_SET
export const UPDATE_STAFF_TO_STAFF_SKILL_SET = "/stafftostaffskillset/update";
//DELETE_STAFF_TO_STAFF_SKILL_SET
export const DELETE_STAFF_TO_STAFF_SKILL_SET = "/stafftostaffskillset/delete";
//SEARCH_STAFF_TO_STAFF_SKILL_SET
export const SEARCH_STAFF_TO_STAFF_SKILL_SET = "/stafftostaffskillset/search";
//SEARCH_STAFF_AVAILABILITY
export const SEARCH_STAFF_AVAILABILITY = "/staff/search/availability";
//CREATE_STAFF_AVAILABILITY (StaffAvailability rows: Staff_Id, FlagAvailable,
// StartDateTime, EndDateTime, Notes)
export const CREATE_STAFF_AVAILABILITY = "/staffavailability/create";
export const LIST_STAFF_AVAILABILITY = "/staffavailability/list";
// Dated staff preferences per customer (Task 24563).
export const SEARCH_CUSTOMER_PREFERRED_STAFF =
  "/customerpreferredstaff/search";
export const CREATE_CUSTOMER_PREFERRED_STAFF =
  "/customerpreferredstaff/create";
export const DELETE_CUSTOMER_PREFERRED_STAFF =
  "/customerpreferredstaff/delete";
export const DELETE_STAFF_AVAILABILITY = "/staffavailability/delete";
export const UPDATE_STAFF_AVAILABILITY = "/staffavailability/update";
//SEARCH_STAFF_GPS_LOCATION_HISTORY
export const SEARCH_STAFF_GPS_LOCATION_HISTORY =
  "/staffgpslocationhistory/search";

//staffworkingschedulerecord/list
export const GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_API =
  "/staffworkingschedulerecord/list";
//staffworkingschedulerecord/data
export const GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_API =
  "/staffworkingschedulerecord/data";
//staffworkingschedulerecord/create
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_API =
  "/staffworkingschedulerecord/create";
//staffworkingschedulerecord/update
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_API =
  "/staffworkingschedulerecord/update";
//staffworkingschedulerecord/delete
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_API =
  "/staffworkingschedulerecord/delete";

//staffworkingschedulerecordadjustment/list
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_API =
  "/staffworkingschedulerecordadjustment/list";
//staffworkingschedulerecordadjustment/data
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_API =
  "/staffworkingschedulerecordadjustment/data";
//staffworkingschedulerecordadjustment/create
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_API =
  "/staffworkingschedulerecordadjustment/create";
//staffworkingschedulerecordadjustment/update
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_API =
  "/staffworkingschedulerecordadjustment/update";
//staffworkingschedulerecordadjustment/delete
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_API =
  "/staffworkingschedulerecordadjustment/delete";

//staffworkingschedule/list
export const GET_STAFF_WORKING_SCHEDULE_LIST_API = "/staffworkingschedule/list";
//staffworkingschedule/data
export const GET_STAFF_WORKING_SCHEDULE_DATA_API = "/staffworkingschedule/data";
//staffworkingschedule/create
export const CREATE_STAFF_WORKING_SCHEDULE_API = "/staffworkingschedule/create";
//staffworkingschedule/update
export const UPDATE_STAFF_WORKING_SCHEDULE_API = "/staffworkingschedule/update";
//staffworkingschedule/delete
export const DELETE_STAFF_WORKING_SCHEDULE_API = "/staffworkingschedule/delete";
//SEARCH_STAFF_WORKING_SCHEDULE_API
export const SEARCH_STAFF_WORKING_SCHEDULE_API = "/staffworkingschedule/search";
//CALCULATE_STAFF_WORKING_SCHEDULE_API
export const CALCULATE_STAFF_WORKING_SCHEDULE_API =
  "/staffworkingschedule/calculate";

//*****************************************//

//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
//GET_NEW_PASSWORD_REQUEST
export const GET_NEW_PASSWORD_REQUEST = "/auth/forgotpassword";
//EMAIL_PASSWORD_TOKEN_VALIDATION_REQUEST
export const EMAIL_PASSWORD_TOKEN_VALIDATION_REQUEST =
  "/auth/verifyforgotpassword";
//POST_CHANGE_PASSWORD
export const POST_CHANGE_PASSWORD = "/auth/changepassword";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/apps/product";
export const DELETE_PRODUCT = "/apps/product";
export const ADD_NEW_PRODUCT = "/apps/product";
export const UPDATE_PRODUCT = "/apps/product";

// Orders
export const GET_ORDERS = "/apps/order";
export const ADD_NEW_ORDER = "/apps/order";
export const UPDATE_ORDER = "/apps/order";
export const DELETE_ORDER = "/apps/order";

// Customers
export const GET_CUSTOMERS = "/apps/customers";
export const ADD_NEW_CUSTOMER = "/apps/customers";
export const UPDATE_CUSTOMER = "/apps/customers";
export const DELETE_CUSTOMER = "/apps/customers";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";
// Tasks List and CRUD
// TasksCrmIt List API
export const GET_TASKS_CRMIT_LIST_API = "/task/list";
// TaskCrmIt Create API
export const ADD_NEW_TASK_CRMIT_API = "/task/create";
// TaskCrmIt Read API
export const GET_TASK_CRMIT_API = "/task/data";
// TaskCrmIt Update API
export const UPDATE_TASK_CRMIT_API = "/task/update";
// TaskCrmIt Delete API
export const DELETE_TASK_CRMIT_API = "/task/delete";
// TaskCrmIt Claim API (a team member claims a pooled task)
export const CLAIM_TASK_CRMIT_API = "/task/claim";

// Get Tasks Status List CRMIT API
export const GET_TASKS_STATUS_LIST_CRMIT_API = "/taskstatus/list";

// Search Single Customer Tasks List API
export const SEARCH_TASK_LIST_API_CALL = "/task/search";
//ADD_NEW_TASK_STATUS_API_CALL
export const ADD_NEW_TASK_STATUS_API_CALL = "/taskstatus/create";
//UPDATE_TASK_STATUS_API_CALL
export const UPDATE_TASK_STATUS_API_CALL = "/taskstatus/update";
//DELETE_TASK_STATUS_API_CALL
export const DELETE_TASK_STATUS_API_CALL = "/taskstatus/delete";
//ADD_NEW_TASK_TYPE_API_CALL
export const ADD_NEW_TASK_TYPE_API_CALL = "/tasktype/create";
//UPDATE_TASK_TYPE_API_CALL
export const UPDATE_TASK_TYPE_API_CALL = "/tasktype/update";
//DELETE_TASK_TYPE_API_CALL
export const DELETE_TASK_TYPE_API_CALL = "/tasktype/delete";
//ADD_NEW_TASK_PRIORITY_API_CALL
export const ADD_NEW_TASK_PRIORITY_API_CALL = "/taskpriority/create";
//UPDATE_TASK_PRIORITY_API_CALL
export const UPDATE_TASK_PRIORITY_API_CALL = "/taskpriority/update";
//DELETE_TASK_PRIORITY_API_CALL
export const DELETE_TASK_PRIORITY_API_CALL = "/taskpriority/delete";
//GET_TASK_RECENT_ACTIVITY_LIST_API_CALL
export const GET_TASK_RECENT_ACTIVITY_LIST_API_CALL =
  "/taskrecentactivity/list";
//GET_TASK_CHANGE_LOG_LIST_API_CALL — generic activity log, ObjectTable=Task; {id} appended by FetchAPI
export const GET_TASK_CHANGE_LOG_LIST_API_CALL = "/activitylog/list/Task";
//ACTIVITY_LOG_LIST_API_CALL — generic change log; ObjectTable appended in the helper, {id} by FetchAPI
export const ACTIVITY_LOG_LIST_API_CALL = "/activitylog/list";
//MASTER_SYSTEM_DATA_STRUCTURE_CATALOG_API_CALL — Change Tracking admin screen
export const MASTER_SYSTEM_DATA_STRUCTURE_CATALOG_API_CALL =
  "/mastersystemdatastructure/catalog";
//MASTER_SYSTEM_DATA_STRUCTURE_FIELD_UPDATE_API_CALL — toggle per-field tracking
export const MASTER_SYSTEM_DATA_STRUCTURE_FIELD_UPDATE_API_CALL =
  "/mastersystemdatastructure/field/update";
//GET_TASK_TEMPLATE_LIST_API_CALL
export const GET_TASK_TEMPLATE_LIST_API_CALL = "/tasktemplate/list";
//GET_TASK_TEMPLATE_DATA_API_CALL
export const GET_TASK_TEMPLATE_DATA_API_CALL = "/tasktemplate/data";
//CREATE_TASK_TEMPLATE_API_CALL
export const CREATE_TASK_TEMPLATE_API_CALL = "/tasktemplate/create";
//UPDATE_TASK_TEMPLATE_API_CALL
export const UPDATE_TASK_TEMPLATE_API_CALL = "/tasktemplate/update";
//DELETE_TASK_TEMPLATE_API_CALL
export const DELETE_TASK_TEMPLATE_API_CALL = "/tasktemplate/delete";
//SEARCH_TASK_TEMPLATE_LIST_API_CALL
export const SEARCH_TASK_TEMPLATE_LIST_API_CALL = "/tasktemplate/search";
//GET_TASK_ATTACHMENT_LIST_API_CALL
export const GET_TASK_ATTACHMENT_LIST_API_CALL = "/taskattachment/list";
//SEARCH_TASK_ATTACHMENT_LIST_API_CALL
export const SEARCH_TASK_ATTACHMENT_LIST_API_CALL = "/taskattachment/search";
//GET_TASK_ATTACHMENT_DATA_API_CALL
export const GET_TASK_ATTACHMENT_DATA_API_CALL = "/taskattachment/data";
//DELETE_TASK_ATTACHMENT_API_CALL
export const DELETE_TASK_ATTACHMENT_API_CALL = "/taskattachment/delete";
// Get Task Type List API
export const GET_TASK_TYPE_LIST_API = "/tasktype/list";
// Get Task Priority List API
export const GET_TASK_PRIORITY_LIST_API = "/taskpriority/list";
// Get Single Task Search Note List
export const GET_SINGLE_TASK_NOTE_DATA_API = "/tasknote/search";
// Create Single Task Note API
export const ADD_NEW_TASK_NOTE_DATA_API = "/tasknote/create";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// TicketsList
export const GET_TICKETS_LIST = "/apps/ticket";
export const ADD_NEW_TICKET = "/apps/ticket";
export const UPDATE_TICKET = "/apps/ticket";
export const DELETE_TICKET = "/apps/ticket";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA =
  "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";

// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

// ===== Automation Engine =====
//scenario
export const CALL_AUTOMATION_SCENARIO_LIST_API = "/automationscenario/data";
export const CALL_AUTOMATION_SCENARIO_CREATE_API = "/automationscenario/data";
export const CALL_AUTOMATION_SCENARIO_UPDATE_API = "/automationscenario/data";
export const CALL_AUTOMATION_SCENARIO_DELETE_API = "/automationscenario/data";
export const CALL_AUTOMATION_SCENARIO_PUBLISH_API =
  "/automationscenario/publish";
export const CALL_AUTOMATION_SCENARIO_DUPLICATE_API =
  "/automationscenario/duplicate";
export const CALL_AUTOMATION_SCENARIO_DISABLE_API =
  "/automationscenario/disable";
export const CALL_AUTOMATION_SCENARIO_STATUS_LIST_API =
  "/automationscenario/status/data";
//canvas
export const CALL_AUTOMATION_CANVAS_API = "/automationscenario/canvas";
//node
export const CALL_AUTOMATION_NODE_DATA_API = "/automationscenarionode/data";
//link
export const CALL_AUTOMATION_LINK_DATA_API =
  "/automationscenariofnodelink/data";
//block (config fields)
export const CALL_AUTOMATION_BLOCK_API = "/automationblock";
//node config
export const CALL_AUTOMATION_NODE_CONFIG_DATA_API =
  "/automationscenariofnodeconfig/data";
//delay config
export const CALL_AUTOMATION_DELAY_CONFIG_DATA_API =
  "/automationdelayconfig/data";
//condition
export const CALL_AUTOMATION_CONDITION_GROUP_DATA_API =
  "/automationcondition/group/data";
export const CALL_AUTOMATION_CONDITION_RULE_DATA_API =
  "/automationcondition/rule/data";
//execution
export const CALL_AUTOMATION_EXECUTION_DATA_API = "/automationexecution/data";
export const CALL_AUTOMATION_EXECUTION_STATUS_LIST_API =
  "/automationexecution/status/data";

//************  API Calls ************//
//Reviews Centre (view & manage customer reviews; Google first, provider-agnostic)
//Reviews
//REVIEW_LIST_API
export const REVIEW_LIST_API = "/review/list";
//REVIEW_DATA_API (GET -> /review/data/{id})
export const REVIEW_DATA_API = "/review/data";
//REVIEW_CREATE_API
export const REVIEW_CREATE_API = "/review/create";
//REVIEW_UPDATE_API
export const REVIEW_UPDATE_API = "/review/update";
//REVIEW_DELETE_API (array of IDs)
export const REVIEW_DELETE_API = "/review/delete";
//REVIEW_ASSIGN_CUSTOMER_API
export const REVIEW_ASSIGN_CUSTOMER_API = "/review/assign/customer";
//REVIEW_STATUS_API (set status / assignee)
export const REVIEW_STATUS_API = "/review/status";
//REVIEW_REPLY_API
export const REVIEW_REPLY_API = "/review/reply";
//Review Providers (connection config)
//REVIEW_PROVIDERS_API
export const REVIEW_PROVIDERS_API = "/review/providers";
//REVIEW_PROVIDER_UPDATE_API
export const REVIEW_PROVIDER_UPDATE_API = "/review/provider/update";
//REVIEW_SYNC_GOOGLE_API
export const REVIEW_SYNC_GOOGLE_API = "/review/sync/google";
//Review Status lanes (admin lookup)
//REVIEW_STATUS_LIST_API
export const REVIEW_STATUS_LIST_API = "/reviewstatus/list";
//REVIEW_STATUS_DATA_API (GET -> /reviewstatus/data/{id})
export const REVIEW_STATUS_DATA_API = "/reviewstatus/data";
//REVIEW_STATUS_CREATE_API
export const REVIEW_STATUS_CREATE_API = "/reviewstatus/create";
//REVIEW_STATUS_UPDATE_API
export const REVIEW_STATUS_UPDATE_API = "/reviewstatus/update";
//REVIEW_STATUS_DELETE_API (array of IDs)
export const REVIEW_STATUS_DELETE_API = "/reviewstatus/delete";

/************************************************/
// Payroll Module API Calls
//PAYROLL_LIST_API (GET, optional ?TaxYear=2026)
export const PAYROLL_LIST_API = "/payroll/list";
//PAYROLL_DATA_API (GET -> /payroll/data/{PayrollRun_Id})
export const PAYROLL_DATA_API = "/payroll/data";
//PAYROLL_CREATE_PREVIEW_API (POST, calculates a full run, writes nothing)
export const PAYROLL_CREATE_PREVIEW_API = "/payroll/create/preview";
//PAYROLL_CREATE_PREVIEW_PDF_API (POST, renders first item as a payslip preview pdf)
export const PAYROLL_CREATE_PREVIEW_PDF_API = "/payroll/create/preview/pdf";
//PAYROLL_CREATE_API (POST, persists run + queues HMRC submission)
export const PAYROLL_CREATE_API = "/payroll/create";
//PAYROLL_UPDATE_API (PUT, status/notes/payment date)
export const PAYROLL_UPDATE_API = "/payroll/update";
//PAYROLL_DELETE_API (DELETE, soft delete)
export const PAYROLL_DELETE_API = "/payroll/delete";
//PAYROLL_PAYSLIP_DATA_API (GET -> /payroll/payslip/data/{PayrollRunItem_Id})
export const PAYROLL_PAYSLIP_DATA_API = "/payroll/payslip/data";
//PAYROLL_PAYSLIP_PDF_API (GET -> /payroll/payslip/pdf/{PayrollRunItem_Id})
export const PAYROLL_PAYSLIP_PDF_API = "/payroll/payslip/pdf";
//PAYROLL_HMRC_LIST_API (GET -> /payroll/hmrc/list/{PayrollRun_Id})
export const PAYROLL_HMRC_LIST_API = "/payroll/hmrc/list";
//PAYROLL_HMRC_SUBMIT_API (POST, retry/submit a queued submission)
export const PAYROLL_HMRC_SUBMIT_API = "/payroll/hmrc/submit";
//PAYROLL_HMRC_SETTINGS_API (POST, save employer settings)
export const PAYROLL_HMRC_SETTINGS_API = "/payroll/hmrc/settings";
//PAYROLL_HMRC_SETTINGS_DATA_API (GET, optional ?TaxYear=2026)
export const PAYROLL_HMRC_SETTINGS_DATA_API = "/payroll/hmrc/settings/data";

/************************************************/
// System Wallet (Master DB) Admin API Calls
// Wallets
//SYSTEM_WALLET_LIST_API (GET -> mastersystemwallet_list)
export const SYSTEM_WALLET_LIST_API = "/mastersystemwallet/list";
//SYSTEM_WALLET_DATA_API (GET -> /mastersystemwallet/data/{Company_Id})
export const SYSTEM_WALLET_DATA_API = "/mastersystemwallet/data";
//SYSTEM_WALLET_UPDATE_API (PUT, array keyed by Id; BalanceLocal/Company_Id stripped)
export const SYSTEM_WALLET_UPDATE_API = "/mastersystemwallet/update";
//SYSTEM_WALLET_TOPUP_API (POST { Company_Id, Amount, MasterPaymentCard_Id? })
export const SYSTEM_WALLET_TOPUP_API = "/mastersystemwallet/topup";
//SYSTEM_WALLET_TRANSACTIONS_API (GET -> /mastersystemwallet/transactions/{Company_Id})
export const SYSTEM_WALLET_TRANSACTIONS_API =
  "/mastersystemwallet/transactions";
//SYSTEM_WALLET_ADJUST_API (POST { Company_Id, Amount, MasterSystemWalletTransactionType_Id, Description })
export const SYSTEM_WALLET_ADJUST_API = "/mastersystemwallet/adjust";

// ***** Customer-facing wallet (own company only — Company_Id from the token) *****
//SYSTEM_WALLET_MY_DATA_API (GET -> own wallet balance + settings)
export const SYSTEM_WALLET_MY_DATA_API = "/systemwallet/mywallet";
//SYSTEM_WALLET_MY_TRANSACTIONS_API (GET -> own wallet ledger)
export const SYSTEM_WALLET_MY_TRANSACTIONS_API = "/systemwallet/mytransactions";
//SYSTEM_WALLET_MY_TOPUP_API (POST { Amount, MasterPaymentCard_Id? })
export const SYSTEM_WALLET_MY_TOPUP_API = "/systemwallet/topup";
//SYSTEM_WALLET_MY_UPDATE_API (PUT { LowBalanceThreshold, AutoTopUpAmount, FlagAutoTopUpEnabled, MaxMonthlyTopUpLocal, MasterPaymentCard_Id })
export const SYSTEM_WALLET_MY_UPDATE_API = "/systemwallet/update";

// Service types (CRUD)
export const SYSTEM_WALLET_SERVICE_TYPE_LIST_API =
  "/mastersystemwalletservicetype/list";
export const SYSTEM_WALLET_SERVICE_TYPE_DATA_API =
  "/mastersystemwalletservicetype/data";
export const SYSTEM_WALLET_SERVICE_TYPE_CREATE_API =
  "/mastersystemwalletservicetype/create";
export const SYSTEM_WALLET_SERVICE_TYPE_UPDATE_API =
  "/mastersystemwalletservicetype/update";
export const SYSTEM_WALLET_SERVICE_TYPE_DELETE_API =
  "/mastersystemwalletservicetype/delete";

// Service rates (CRUD)
export const SYSTEM_WALLET_SERVICE_RATE_LIST_API =
  "/mastersystemwalletservicerate/list";
export const SYSTEM_WALLET_SERVICE_RATE_DATA_API =
  "/mastersystemwalletservicerate/data";
export const SYSTEM_WALLET_SERVICE_RATE_CREATE_API =
  "/mastersystemwalletservicerate/create";
export const SYSTEM_WALLET_SERVICE_RATE_UPDATE_API =
  "/mastersystemwalletservicerate/update";
export const SYSTEM_WALLET_SERVICE_RATE_DELETE_API =
  "/mastersystemwalletservicerate/delete";

// =====================================================================
// Wi-Fi Access / Guest Portal (R&D)
// =====================================================================
// --- wifiaccesspoint ---
export const GET_WIFI_ACCESS_POINT_LIST = "/wifiaccesspoint/list";
export const GET_WIFI_ACCESS_POINT_DATA = "/wifiaccesspoint/data";
export const POST_WIFI_ACCESS_POINT_CREATE = "/wifiaccesspoint/create";
export const PUT_WIFI_ACCESS_POINT_UPDATE = "/wifiaccesspoint/update";
export const DELETE_WIFI_ACCESS_POINT_DELETE = "/wifiaccesspoint/delete";

// --- wifiportalguestprofile ---
export const GET_WIFI_PORTAL_GUEST_PROFILE_LIST =
  "/wifiportalguestprofile/list";
export const GET_WIFI_PORTAL_GUEST_PROFILE_DATA =
  "/wifiportalguestprofile/data";
export const POST_WIFI_PORTAL_GUEST_PROFILE_CREATE =
  "/wifiportalguestprofile/create";
export const PUT_WIFI_PORTAL_GUEST_PROFILE_UPDATE =
  "/wifiportalguestprofile/update";
export const DELETE_WIFI_PORTAL_GUEST_PROFILE_DELETE =
  "/wifiportalguestprofile/delete";

// --- wifisitelocation ---
export const GET_WIFI_SITE_LOCATION_LIST = "/wifisitelocation/list";
export const GET_WIFI_SITE_LOCATION_DATA = "/wifisitelocation/data";
export const POST_WIFI_SITE_LOCATION_CREATE = "/wifisitelocation/create";
// Change #100129 - copy a site (secrets kept, UniFi site id and APs not)
export const POST_WIFI_SITE_LOCATION_CLONE = "/wifisitelocation/clone";
// Change #100136 - render a guest portal profile as HTML for preview
export const POST_WIFI_PORTAL_GUEST_PROFILE_PREVIEW =
  "/wifiportalguestprofile/preview";
export const PUT_WIFI_SITE_LOCATION_UPDATE = "/wifisitelocation/update";
export const DELETE_WIFI_SITE_LOCATION_DELETE = "/wifisitelocation/delete";
export const POST_WIFI_SITE_LOCATION_UNIFI_TEST_CONNECTION =
  "/wifisitelocation/unifi/testconnection";
export const POST_WIFI_SITE_LOCATION_UNIFI_SYNC_APS =
  "/wifisitelocation/unifi/syncaps";
export const POST_WIFI_SITE_LOCATION_COMO_TEST_CONNECTION =
  "/wifisitelocation/como/testconnection";

// --- wifiguestregistration (read + search) ---
export const GET_WIFI_GUEST_REGISTRATION_LIST = "/wifiguestregistration/list";
export const GET_WIFI_GUEST_REGISTRATION_DATA = "/wifiguestregistration/data";
export const POST_WIFI_GUEST_REGISTRATION_SEARCH =
  "/wifiguestregistration/search";

// --- wifiportalerrorlog (read + search) ---
export const GET_WIFI_PORTAL_ERROR_LOG_LIST = "/wifiportalerrorlog/list";
export const GET_WIFI_PORTAL_ERROR_LOG_DATA = "/wifiportalerrorlog/data";
export const POST_WIFI_PORTAL_ERROR_LOG_SEARCH = "/wifiportalerrorlog/search";

// --- wifisitelocationtowifiaccesspoint (link) ---
export const GET_WIFI_SITE_LOCATION_TO_AP_LIST =
  "/wifisitelocationtowifiaccesspoint/list";
export const POST_WIFI_SITE_LOCATION_TO_AP_CREATE =
  "/wifisitelocationtowifiaccesspoint/create";
export const DELETE_WIFI_SITE_LOCATION_TO_AP_DELETE =
  "/wifisitelocationtowifiaccesspoint/delete";

// =====================================================================
// SERP Rank Tracking
// =====================================================================
// --- serpreport ---
export const GET_SERP_REPORT_LIST = "/serpreport/list";
export const GET_SERP_REPORT_DATA = "/serpreport/data";
export const POST_SERP_REPORT_CREATE = "/serpreport/create";
export const PUT_SERP_REPORT_UPDATE = "/serpreport/update";
export const DELETE_SERP_REPORT_DELETE = "/serpreport/delete";
export const POST_SERP_REPORT_RUN = "/serpreport/run"; // + /{id}
export const GET_SERP_REPORT_PDF = "/serpreport/pdf"; // + /{id}
export const GET_SERP_REPORT_SNAPSHOT_PDF = "/serpreport/snapshotpdf"; // + /{snapshotId}
export const POST_SERP_REPORT_EMAIL = "/serpreport/email";

// --- serpreportsearchitem (keywords) ---
export const GET_SERP_ITEM_LIST = "/serpreportsearchitem/list"; // ?SerpReport_Id=
export const GET_SERP_ITEM_DATA = "/serpreportsearchitem/data";
export const POST_SERP_ITEM_CREATE = "/serpreportsearchitem/create";
export const PUT_SERP_ITEM_UPDATE = "/serpreportsearchitem/update";
export const DELETE_SERP_ITEM_DELETE = "/serpreportsearchitem/delete";

// --- serpreportsnapshot (runs) ---
export const GET_SERP_SNAPSHOT_LIST = "/serpreportsnapshot/list"; // ?SerpReport_Id=
export const GET_SERP_SNAPSHOT_DATA = "/serpreportsnapshot/data";
export const DELETE_SERP_SNAPSHOT_DELETE = "/serpreportsnapshot/delete";

// --- serpreportsearchitemresult (positions) ---
export const GET_SERP_RESULT_LIST = "/serpreportsearchitemresult/list"; // ?SerpReportSnapshot_Id= | ?SerpReportSearchItem_Id=
export const GET_SERP_RESULT_DATA = "/serpreportsearchitemresult/data";
export const GET_SERP_RESULT_ORGANIC = "/serpreportsearchitemresult/organic"; // /{SerpReportSearchItemResult_Id}

// --- callinbound (Twilio inbound calls) ---
export const GET_CALL_INBOUND_LIST = "/callinbound/list";
export const GET_CALL_INBOUND_LIST_BY_CUSTOMER = "/callinbound/list/by_customer"; // + /{customerId}
export const GET_CALL_INBOUND_DATA = "/callinbound/data"; // + /{id}
export const POST_CALL_INBOUND_CREATE = "/callinbound/create";
export const PUT_CALL_INBOUND_UPDATE = "/callinbound/update";
export const DELETE_CALL_INBOUND_DELETE = "/callinbound/delete";

// =====================================================================
// Meeting AI (Notetaker)
// =====================================================================
// --- meetingrecording ---
export const GET_MEETING_RECORDING_LIST = "/meetingrecording/list";
export const GET_MEETING_RECORDING_DATA = "/meetingrecording/data"; // + /{id}
export const POST_MEETING_RECORDING_DISPATCH = "/meetingrecording/dispatch";
export const PUT_MEETING_RECORDING_UPDATE = "/meetingrecording/update";
export const DELETE_MEETING_RECORDING_DELETE = "/meetingrecording/delete";
export const POST_MEETING_RECORDING_RETRY_SUMMARY =
  "/meetingrecording/retrysummary"; // + /{id}
export const POST_MEETING_RECORDING_SYNC = "/meetingrecording/sync"; // + /{id}

// --- meetingrecording/settings (company-wide notetaker config) ---
export const GET_MEETING_RECORDING_SETTINGS = "/meetingrecording/settings";
export const PUT_MEETING_RECORDING_SETTINGS = "/meetingrecording/settings";

// --- Staff Qualifications & Certifications --------------------------------

// Qualification catalog (company definitions)
export const GET_QUALIFICATION_DEFINITION_LIST = "/qualificationdefinition/list";
export const GET_QUALIFICATION_DEFINITION_DATA = "/qualificationdefinition/data";
export const CREATE_QUALIFICATION_DEFINITION = "/qualificationdefinition/create";
export const UPDATE_QUALIFICATION_DEFINITION = "/qualificationdefinition/update";
export const DELETE_QUALIFICATION_DEFINITION = "/qualificationdefinition/delete";

// Certification catalog (company definitions)
export const GET_CERTIFICATION_DEFINITION_LIST = "/certificationdefinition/list";
export const GET_CERTIFICATION_DEFINITION_DATA = "/certificationdefinition/data";
export const CREATE_CERTIFICATION_DEFINITION = "/certificationdefinition/create";
export const UPDATE_CERTIFICATION_DEFINITION = "/certificationdefinition/update";
export const DELETE_CERTIFICATION_DEFINITION = "/certificationdefinition/delete";

// Staff qualifications
export const GET_STAFF_QUALIFICATION_LIST = "/staffqualification/list"; // + /{Staff_Id}
export const GET_STAFF_QUALIFICATION_LIST_ALL = "/staffqualification/listall";
export const GET_STAFF_QUALIFICATION_MATRIX = "/staffqualification/matrix";
export const GET_STAFF_QUALIFICATION_DATA = "/staffqualification/data";
export const CREATE_STAFF_QUALIFICATION = "/staffqualification/create";
export const UPDATE_STAFF_QUALIFICATION = "/staffqualification/update";
export const DELETE_STAFF_QUALIFICATION = "/staffqualification/delete";
export const ATTACH_STAFF_QUALIFICATION = "/staffqualification/attach";
export const GET_STAFF_QUALIFICATION_ATTACHMENTS = "/staffqualification/attachments"; // + /{id}
export const DETACH_STAFF_QUALIFICATION = "/staffqualification/detach";

// Staff certifications
export const GET_STAFF_CERTIFICATION_LIST = "/staffcertification/list"; // + /{Staff_Id}
export const GET_STAFF_CERTIFICATION_LIST_ALL = "/staffcertification/listall";
export const GET_STAFF_CERTIFICATION_MATRIX = "/staffcertification/matrix";
export const GET_STAFF_CERTIFICATION_DATA = "/staffcertification/data";
export const CREATE_STAFF_CERTIFICATION = "/staffcertification/create";
export const UPDATE_STAFF_CERTIFICATION = "/staffcertification/update";
export const DELETE_STAFF_CERTIFICATION = "/staffcertification/delete";
export const ATTACH_STAFF_CERTIFICATION = "/staffcertification/attach";
export const GET_STAFF_CERTIFICATION_ATTACHMENTS = "/staffcertification/attachments"; // + /{id}
export const DETACH_STAFF_CERTIFICATION = "/staffcertification/detach";

// Staff certification completion / renewal logs
export const GET_STAFF_CERTIFICATION_LOG_LIST = "/staffcertificationlog/list"; // + /{StaffCertification_Id}
export const GET_STAFF_CERTIFICATION_LOG_DATA = "/staffcertificationlog/data";
export const CREATE_STAFF_CERTIFICATION_LOG = "/staffcertificationlog/create";
export const UPDATE_STAFF_CERTIFICATION_LOG = "/staffcertificationlog/update";
export const DELETE_STAFF_CERTIFICATION_LOG = "/staffcertificationlog/delete";

// =====================================================================
// Customer Assets (Task 24274) - customer-owned equipment register.
// Distinct from ASSET_* above (equipment WE own).
// =====================================================================

// Customer asset status (configurable master list)
export const CUSTOMER_ASSET_STATUS_LIST_API = "/customerassetstatus/list";
export const CUSTOMER_ASSET_STATUS_DATA_API = "/customerassetstatus/data";
export const CUSTOMER_ASSET_STATUS_CREATE_API = "/customerassetstatus/create";
export const CUSTOMER_ASSET_STATUS_UPDATE_API = "/customerassetstatus/update";
export const CUSTOMER_ASSET_STATUS_DELETE_API = "/customerassetstatus/delete";

// Customer asset attribute types (master list, e.g. "IP Address")
// Asset attributes (Task 24313) - the company-asset twin of the customer-asset
// attribute pair below. Separate catalogue on purpose; see the model comment.
export const ASSET_ATTRIBUTE_TYPE_LIST_API = "/assetattributetype/list";
export const ASSET_ATTRIBUTE_TYPE_DATA_API = "/assetattributetype/data";
export const ASSET_ATTRIBUTE_TYPE_CREATE_API = "/assetattributetype/create";
export const ASSET_ATTRIBUTE_TYPE_UPDATE_API = "/assetattributetype/update";
export const ASSET_ATTRIBUTE_TYPE_DELETE_API = "/assetattributetype/delete";

export const ASSET_ATTRIBUTE_LIST_API = "/assetattribute/list"; // + /{Asset_Id}
export const ASSET_ATTRIBUTE_DATA_API = "/assetattribute/data";
export const ASSET_ATTRIBUTE_SEARCH_API = "/assetattribute/search";
export const ASSET_ATTRIBUTE_CREATE_API = "/assetattribute/create";
export const ASSET_ATTRIBUTE_UPDATE_API = "/assetattribute/update";
export const ASSET_ATTRIBUTE_DELETE_API = "/assetattribute/delete";

export const CUSTOMER_ASSET_ATTRIBUTE_TYPE_LIST_API = "/customerassetattributetype/list";
export const CUSTOMER_ASSET_ATTRIBUTE_TYPE_DATA_API = "/customerassetattributetype/data";
export const CUSTOMER_ASSET_ATTRIBUTE_TYPE_CREATE_API = "/customerassetattributetype/create";
export const CUSTOMER_ASSET_ATTRIBUTE_TYPE_UPDATE_API = "/customerassetattributetype/update";
export const CUSTOMER_ASSET_ATTRIBUTE_TYPE_DELETE_API = "/customerassetattributetype/delete";

// Customer assets
export const CUSTOMER_ASSET_LIST_API = "/customerasset/list";
export const CUSTOMER_ASSET_DATA_API = "/customerasset/data";
export const CUSTOMER_ASSET_SEARCH_API = "/customerasset/search";
export const CUSTOMER_ASSET_CREATE_API = "/customerasset/create";
export const CUSTOMER_ASSET_UPDATE_API = "/customerasset/update";
export const CUSTOMER_ASSET_DELETE_API = "/customerasset/delete";

// Customer asset attributes (date-bound values on an asset)
export const CUSTOMER_ASSET_ATTRIBUTE_LIST_API = "/customerassetattribute/list"; // + /{CustomerAsset_Id}
export const CUSTOMER_ASSET_ATTRIBUTE_DATA_API = "/customerassetattribute/data";
export const CUSTOMER_ASSET_ATTRIBUTE_SEARCH_API = "/customerassetattribute/search";
export const CUSTOMER_ASSET_ATTRIBUTE_CREATE_API = "/customerassetattribute/create";
export const CUSTOMER_ASSET_ATTRIBUTE_UPDATE_API = "/customerassetattribute/update";
export const CUSTOMER_ASSET_ATTRIBUTE_DELETE_API = "/customerassetattribute/delete";

// Customer asset notes (Task 24274)
export const CUSTOMER_ASSET_NOTE_LIST_API = "/customerassetnote/list"; // + /{CustomerAsset_Id}
export const CUSTOMER_ASSET_NOTE_SEARCH_API = "/customerassetnote/search";
export const CUSTOMER_ASSET_NOTE_CREATE_API = "/customerassetnote/create";
export const CUSTOMER_ASSET_NOTE_UPDATE_API = "/customerassetnote/update";
export const CUSTOMER_ASSET_NOTE_DELETE_API = "/customerassetnote/delete";

// Staff leave notes (Task 24594) - a running commentary on one leave request,
// e.g. sickness updates. Search is the one that carries the author name.
export const STAFF_LEAVE_NOTE_LIST_API = "/staffleavenote/list"; // + /{StaffLeave_Id}
export const STAFF_LEAVE_NOTE_SEARCH_API = "/staffleavenote/search";
export const STAFF_LEAVE_NOTE_CREATE_API = "/staffleavenote/create";
export const STAFF_LEAVE_NOTE_UPDATE_API = "/staffleavenote/update";
export const STAFF_LEAVE_NOTE_DELETE_API = "/staffleavenote/delete";

// Staff job roles (Task 24600) - the roles a staff member has held over time.
// "JobRole", not "Role": roles already means security roles on that profile.
export const STAFF_JOB_ROLE_SEARCH_API = "/staffjobrole/search";
export const STAFF_JOB_ROLE_CREATE_API = "/staffjobrole/create";
export const STAFF_JOB_ROLE_UPDATE_API = "/staffjobrole/update";
export const STAFF_JOB_ROLE_DELETE_API = "/staffjobrole/delete";

//******************** Gift Voucher (CRMit Task 24310)
export const GIFT_VOUCHER_LIST_API = "/giftvoucher/list";
export const GIFT_VOUCHER_DATA_API = "/giftvoucher/data";
export const GIFT_VOUCHER_CREATE_API = "/giftvoucher/create";
export const GIFT_VOUCHER_UPDATE_API = "/giftvoucher/update";
export const GIFT_VOUCHER_DELETE_API = "/giftvoucher/delete";
export const GIFT_VOUCHER_SEARCH_API = "/giftvoucher/search";
export const GIFT_VOUCHER_REDEEM_API = "/giftvoucher/redeem";
export const GIFT_VOUCHER_VOID_API = "/giftvoucher/void";
export const GIFT_VOUCHER_RESEND_EMAIL_API = "/giftvoucher/resendemail";

// Database Delta Manager (Super Admin). Delta scripts stored in ZCRM_Master and
// executed against the master DB or every company DB, replacing the
// copy-into-Postman-and-hit-/zcron/SqlMultipleDbUpdate routine.
export const MASTER_DATABASE_DELTA_LIST_API = "/masterdatabasedelta/list";
export const MASTER_DATABASE_DELTA_DATA_API = "/masterdatabasedelta/data";
export const MASTER_DATABASE_DELTA_RUN_LIST_API = "/masterdatabasedelta/runlist";
export const MASTER_DATABASE_DELTA_CREATE_API = "/masterdatabasedelta/create";
export const MASTER_DATABASE_DELTA_UPDATE_API = "/masterdatabasedelta/update";
export const MASTER_DATABASE_DELTA_ARCHIVE_API = "/masterdatabasedelta/archive";
export const MASTER_DATABASE_DELTA_DELETE_API = "/masterdatabasedelta/delete";
export const MASTER_DATABASE_DELTA_EXECUTE_API = "/masterdatabasedelta/execute";

// Server Errors (Super Admin, Task 24900)
export const SERVER_ERROR_LOG_LIST_API = "/servererrorlog/list";
export const SERVER_ERROR_LOG_DATA_API = "/servererrorlog/data";
export const SERVER_ERROR_LOG_SEARCH_API = "/servererrorlog/search";
export const SERVER_ERROR_LOG_RESOLVE_API = "/servererrorlog/resolve";
export const SERVER_ERROR_LOG_CREATE_TASK_API = "/servererrorlog/createtask";
// Task 24905 - archive (and restore). Not the same as resolve: an archived
// error stays archived when it happens again.
export const SERVER_ERROR_LOG_ARCHIVE_API = "/servererrorlog/archive";

// Auth Failures (Super Admin, Change #100539) - refused requests across every company.
export const AUTH_FAILURE_LOG_SUMMARY_API = "/authfailurelog/summary";
export const AUTH_FAILURE_LOG_DATA_API = "/authfailurelog/data";

// System Changes (Super Admin, Task 24912) - bugs and improvements to CRMit,
// moved out of company 3 tasks into ZCRM_Master. Developer-only routes.
export const SYSTEM_CHANGE_LIST_API = "/systemchange/list";
export const SYSTEM_CHANGE_DATA_API = "/systemchange/data";
export const SYSTEM_CHANGE_SEARCH_API = "/systemchange/search";
export const SYSTEM_CHANGE_CREATE_API = "/systemchange/create";
export const SYSTEM_CHANGE_UPDATE_API = "/systemchange/update";
export const SYSTEM_CHANGE_DELETE_API = "/systemchange/delete";
export const SYSTEM_CHANGE_ASSIGN_BUNDLE_API = "/systemchange/assignbundle";
export const SYSTEM_CHANGE_SYNC_API = "/systemchange/sync";
export const SYSTEM_CHANGE_NOTE_CREATE_API = "/systemchangenote/create";
export const SYSTEM_CHANGE_NOTE_DELETE_API = "/systemchangenote/delete";
// Change #100029 - connect a Stripe account's feeds to a bank account.
export const BANK_ACCOUNT_FEED_CONNECT_STRIPE_API = "/bankaccountfeed/connectstripe";
// Change #100040 - re-read a purchase draft's document with AI.
export const PURCHASE_DRAFT_REPROCESS_API = "/purchasedraft/reprocess";
// Change #100031 - run a feed's sync now.
export const BANK_ACCOUNT_FEED_SYNC_NOW_API = "/bankaccountfeed/syncnow";
// Change #100028 - companies / users a change affects.
export const SYSTEM_CHANGE_AFFECTED_CREATE_API = "/systemchangeaffected/create";
export const SYSTEM_CHANGE_AFFECTED_UPDATE_API = "/systemchangeaffected/update";
export const SYSTEM_CHANGE_AFFECTED_DELETE_API = "/systemchangeaffected/delete";
export const SYSTEM_CHANGE_AFFECTED_LOOKUP_API = "/systemchangeaffected/lookup";
export const SYSTEM_CHANGE_ATTACHMENT_PREAUTH_API = "/systemchangeattachment/preauth";
export const SYSTEM_CHANGE_ATTACHMENT_DELETE_API = "/systemchangeattachment/delete";
export const SYSTEM_CHANGE_BUNDLE_LIST_API = "/systemchangebundle/list";
export const SYSTEM_CHANGE_BUNDLE_DATA_API = "/systemchangebundle/data";
export const SYSTEM_CHANGE_BUNDLE_CREATE_API = "/systemchangebundle/create";
export const SYSTEM_CHANGE_BUNDLE_UPDATE_API = "/systemchangebundle/update";
export const SYSTEM_CHANGE_BUNDLE_DELETE_API = "/systemchangebundle/delete";
export const SYSTEM_CHANGE_BUNDLE_RELEASE_API = "/systemchangebundle/release";
// Status / type / priority share one shape: /systemchange{kind}/list|create|update|delete
export const SYSTEM_CHANGE_LOOKUP_API = (kind, action) =>
  `/systemchange${kind}/${action}`;

// Developer access (Super Admin > Users & Access > Developers, Task 24434).
// Who carries User.FlagDeveloper. Every endpoint is refused by the backend
// unless the caller is the one nominated account.
export const DEVELOPER_ACCESS_LIST_API = "/developeraccess/list";
export const DEVELOPER_ACCESS_SEARCH_API = "/developeraccess/search";
export const DEVELOPER_ACCESS_UPDATE_API = "/developeraccess/update";

// ===== Product Category (Task 24745) - nested catalogue categories =====
export const GET_PRODUCT_CATEGORY_LIST_API = "/productcategory/list";
export const GET_PRODUCT_CATEGORY_TREE_API = "/productcategory/tree";
export const GET_PRODUCT_CATEGORY_DATA_API = "/productcategory/data";
export const CREATE_PRODUCT_CATEGORY_API = "/productcategory/create";
export const UPDATE_PRODUCT_CATEGORY_API = "/productcategory/update";
export const DELETE_PRODUCT_CATEGORY_API = "/productcategory/delete";
export const ASSIGN_PRODUCTS_TO_CATEGORY_API =
  "/productcategory/assignproducts";

// Customer known names (Task 24758)
export const SEARCH_CUSTOMER_KNOWN_NAME_API = "/customerknownname/search";
export const CREATE_CUSTOMER_KNOWN_NAME_API = "/customerknownname/create";
export const UPDATE_CUSTOMER_KNOWN_NAME_API = "/customerknownname/update";
export const DELETE_CUSTOMER_KNOWN_NAME_API = "/customerknownname/delete";

// Task 24754 - filtered StaffAvailability read (staff + date range + flag),
// as opposed to LIST_STAFF_AVAILABILITY which returns the company's lot.
// Not to be confused with SEARCH_STAFF_AVAILABILITY above, which is the
// diary-slot "who is free" engine on a different controller entirely.
export const SEARCH_STAFF_AVAILABILITY_ROWS = "/staffavailability/search";

// Task 24769 - staff income has its own status table; the details screen was
// using InvoiceStatus because this had no route.
export const GET_STAFF_INCOME_STATUS_LIST_API = "/staffincomestatus/list";

// Change #100130 - Staff Attendance: clock records graded against rota / working hours
export const STAFF_ATTENDANCE_REPORT_API = "/staffattendance/report";
export const STAFF_ATTENDANCE_SETTINGS_API = "/staffattendance/settings";
// Change #100130 - manager / administrator corrections to a clock record
export const STAFF_CLOCK_RECORD_CREATE_API = "/staffclockrecord/create";
export const STAFF_CLOCK_RECORD_UPDATE_API = "/staffclockrecord/update";
export const STAFF_CLOCK_RECORD_DELETE_API = "/staffclockrecord/delete";
// Change #100162 - notes held against a staff member
export const STAFF_NOTE_LIST_API = "/staffnote/list";
export const STAFF_NOTE_CREATE_API = "/staffnote/create";
export const STAFF_NOTE_UPDATE_API = "/staffnote/update";
export const STAFF_NOTE_DELETE_API = "/staffnote/delete";
// Change #100165 - manager / administrator override: ignore an attendance day
export const STAFF_ATTENDANCE_EXCUSE_API = "/staffattendance/excuse";
export const STAFF_ATTENDANCE_UNEXCUSE_API = "/staffattendance/unexcuse";
// Change #100167 - forms that go with a product
export const PRODUCT_TO_FORM_LIST_API = "/producttoform/list";
// Change #100715 - the products a form is on
export const PRODUCT_TO_FORM_FORM_LIST_API = "/producttoform/formlist";
export const PRODUCT_TO_FORM_CREATE_API = "/producttoform/create";
export const PRODUCT_TO_FORM_UPDATE_API = "/producttoform/update";
export const PRODUCT_TO_FORM_DELETE_API = "/producttoform/delete";
// Change #100550 - staff skill sets a product needs (required / preferred)
export const PRODUCT_TO_STAFF_SKILLSET_LIST_API = "/producttostaffskillset/list";
export const PRODUCT_TO_STAFF_SKILLSET_CREATE_API = "/producttostaffskillset/create";
export const PRODUCT_TO_STAFF_SKILLSET_UPDATE_API = "/producttostaffskillset/update";
export const PRODUCT_TO_STAFF_SKILLSET_DELETE_API = "/producttostaffskillset/delete";
// Change #100198 - diary appointments a product was booked on
export const DIARY_SLOT_BY_PRODUCT_API = "/diaryslot/product";
// Change #100206 - AI-suggested wording for a billable item
export const JOB_INVOICE_ITEM_AI_GENERATE_API = "/jobinvoiceitem/aigenerate";
// Change #100422 - AI title / description for an invoice line, from its job (not saved)
export const INVOICE_ITEM_AI_GENERATE_API = "/invoiceitem/aigenerate";
// Change #100450 - one-off schedule changes (overtime / time off) for one staff member
export const STAFF_WORKING_SCHEDULE_ADJUSTMENT_LIST_API = "/staffworkingscheduleadjustment/list";
export const STAFF_WORKING_SCHEDULE_ADJUSTMENT_CREATE_API = "/staffworkingscheduleadjustment/create";
export const STAFF_WORKING_SCHEDULE_ADJUSTMENT_UPDATE_API = "/staffworkingscheduleadjustment/update";
export const STAFF_WORKING_SCHEDULE_ADJUSTMENT_DELETE_API = "/staffworkingscheduleadjustment/delete";
// Change #100461 - the signed-in user's diary permissions (field service dispatch)
export const DIARY_SLOT_PERMISSIONS_API = "/diaryslot/permissions";
// Change #100462 - Standard / Enterprise billing and seat usage for this company
export const SUBSCRIPTION_LICENCE_BILLING_API = "/subscriptionlicence/billing";
export const SUBSCRIPTION_LICENCE_SEAT_COMPANY_API = "/subscriptionlicence/seat/company";
export const SUBSCRIPTION_LICENCE_ASSIGN_BULK_API = "/subscriptionlicence/assign/bulk";
export const SUBSCRIPTION_LICENCE_BOLTONS_API = "/subscriptionlicence/boltons";
export const SUBSCRIPTION_LICENCE_LIST_COMPANY_ALL_API = "/subscriptionlicence/list/company";
// Change #100462 - Super Admin > Enterprise Plans
export const ENTERPRISE_PLAN_ADMIN_LIST_API = "/enterpriseplanadmin/list";
export const ENTERPRISE_PLAN_ADMIN_UPDATE_API = "/enterpriseplanadmin/update";
export const ENTERPRISE_PLAN_ADMIN_SETMODE_API = "/enterpriseplanadmin/setmode";
export const ENTERPRISE_PLAN_ADMIN_COMPANY_API = "/enterpriseplanadmin/company/";
export const LICENCE_ENFORCEMENT_ADMIN_LIST_API = "/licenceenforcementadmin/list";
export const LICENCE_ENFORCEMENT_ADMIN_UPDATE_API = "/licenceenforcementadmin/update";
